/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** Date custom scalar type */
  Date: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
  Long: { input: any; output: any; }
};

export type A2EAnchor = {
  __typename?: 'A2EAnchor';
  anchorId: Scalars['String']['output'];
  gender: Gender;
  lang: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  preview: Scalars['String']['output'];
  previewImageUrl: Scalars['String']['output'];
};

export enum A2ELanguage {
  DeDe = 'de_DE',
  EnGb = 'en_GB',
  EnUs = 'en_US',
  EsCo = 'es_CO',
  EsEs = 'es_ES',
  EsMx = 'es_MX',
  FrFr = 'fr_FR',
  ItIt = 'it_IT',
  JaJp = 'ja_JP',
  PtBr = 'pt_BR'
}

export type A2EVoice = {
  __typename?: 'A2EVoice';
  gender: Gender;
  id: Scalars['String']['output'];
  language: A2ELanguage;
  name: Scalars['String']['output'];
  preview: Scalars['String']['output'];
};

export type AccountInfo = {
  __typename?: 'AccountInfo';
  aiTokensCount: Scalars['Int']['output'];
  generationsCount: Scalars['Int']['output'];
  mojoProjectsCount: Scalars['Int']['output'];
};

export type AddSubscriptionInfosMutationResponse = MutationResponse & {
  __typename?: 'AddSubscriptionInfosMutationResponse';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  /** The SubscriptionInfos of the user was changed. */
  user?: Maybe<User>;
};

export type AiAnimatedElementGenerationTask = {
  __typename?: 'AiAnimatedElementGenerationTask';
  aspectRatio: AiRevealAspectRatio;
  audioTask?: Maybe<Task>;
  backgroundColor?: Maybe<Scalars['String']['output']>;
  coordinates?: Maybe<Coordinates>;
  customFirstFramePrompt?: Maybe<Scalars['String']['output']>;
  customLastFramePrompt?: Maybe<Scalars['String']['output']>;
  customPrompt?: Maybe<Scalars['String']['output']>;
  customVideoPrompt?: Maybe<Scalars['String']['output']>;
  imagePosition: AiRevealImagePosition;
  margin?: Maybe<Scalars['Float']['output']>;
  modelName: RevealsModelName;
  presetId: Scalars['String']['output'];
  rotation?: Maybe<Scalars['Float']['output']>;
  scale?: Maybe<Scalars['Float']['output']>;
  seed?: Maybe<Scalars['Int']['output']>;
  task?: Maybe<Task>;
  variationId: Scalars['String']['output'];
  videoDuration?: Maybe<Scalars['Int']['output']>;
};

export type AiAnimatedElementInputMediaTemplate = {
  __typename?: 'AiAnimatedElementInputMediaTemplate';
  frameRate: Scalars['Int']['output'];
  numberOfFrames: Scalars['Int']['output'];
  shaderCode: Scalars['String']['output'];
  templateId: Scalars['ID']['output'];
};

export type AiAnimatedElementInputMediaTemplateInput = {
  frameRate?: InputMaybe<Scalars['Int']['input']>;
  numberOfFrames: Scalars['Int']['input'];
  /** Must be a valid GLSL string format */
  shaderCode: Scalars['String']['input'];
  templateId: Scalars['ID']['input'];
};

export type AiAnimatedElementInputMediaTemplateUpdateInput = {
  frameRate?: InputMaybe<Scalars['Int']['input']>;
  numberOfFrames?: InputMaybe<Scalars['Int']['input']>;
  /** Must be a valid GLSL string format */
  shaderCode?: InputMaybe<Scalars['String']['input']>;
};

export type AiAnimatedElementPreset = {
  __typename?: 'AiAnimatedElementPreset';
  beforeAfterThumbnailData?: Maybe<ThumbnailData>;
  beforeAfterVideoUrl?: Maybe<Scalars['String']['output']>;
  categoryIds?: Maybe<Array<Scalars['String']['output']>>;
  createdAt?: Maybe<Scalars['String']['output']>;
  /** The user who created this preset */
  createdBy?: Maybe<User>;
  hidden: Scalars['Boolean']['output'];
  /** Contextual field: only preset when a preset is listed in a category */
  hiddenInCategory?: Maybe<Scalars['Boolean']['output']>;
  imageTransferModel?: Maybe<ImageStyleTransferModel>;
  /** JSON containing the input files used to create this preset */
  inputs?: Maybe<Scalars['String']['output']>;
  /** iOS versions for which this preset is available */
  iosVersion?: Maybe<IosVersion>;
  isPresetNew: Scalars['Boolean']['output'];
  isPro: Scalars['Boolean']['output'];
  /** For multipass presets - when true, generates N videos from N frames by looping back to the first frame */
  loop?: Maybe<Scalars['Boolean']['output']>;
  modelData: ReplicateModel;
  presetFlow: PresetFlow;
  presetId: Scalars['ID']['output'];
  /** This property will be non-null only when queried within the category context */
  previewToUse?: Maybe<PresetPreviewToUse>;
  /** This property is used client-side to display the correct preview video chosend by the admin - only available when queried within a preset category */
  previewVideoForCategory?: Maybe<PresetPreviewVideo>;
  previewVideoUrl: Scalars['String']['output'];
  thumbnailData?: Maybe<ThumbnailData>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  videoGenerationModel?: Maybe<VideoGenerationModel>;
  /** Contextual field: only preset when a preset is listed in a category */
  visibleInCategory?: Maybe<Scalars['Boolean']['output']>;
  weight: Scalars['Int']['output'];
};

export type AiAnimatedElementPresetInput = {
  beforeAfterVideoUrl?: InputMaybe<Scalars['String']['input']>;
  hidden: Scalars['Boolean']['input'];
  imageTransferModel?: InputMaybe<ImageStyleTransferModel>;
  /** Must be a valid JSON encoded format */
  inputs?: InputMaybe<Scalars['String']['input']>;
  iosVersion?: InputMaybe<IosVersionInput>;
  isPresetNew: Scalars['Boolean']['input'];
  isPro: Scalars['Boolean']['input'];
  /** For multipass presets - when true, generates N videos from N frames by looping back to the first frame */
  loop?: InputMaybe<Scalars['Boolean']['input']>;
  modelData: ReplicateModelDataInput;
  presetFlow: PresetFlow;
  presetId: Scalars['ID']['input'];
  previewVideoUrl: Scalars['String']['input'];
  videoGenerationModel?: InputMaybe<VideoGenerationModel>;
  weight: Scalars['Int']['input'];
};

export type AiAnimatedElementPresetUpdateInput = {
  beforeAfterVideoUrl?: InputMaybe<Scalars['String']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  imageTransferModel?: InputMaybe<ImageStyleTransferModel>;
  inputs?: InputMaybe<Scalars['String']['input']>;
  iosVersion?: InputMaybe<IosVersionInput>;
  isPresetNew?: InputMaybe<Scalars['Boolean']['input']>;
  isPro?: InputMaybe<Scalars['Boolean']['input']>;
  /** For multipass presets - when true, generates N videos from N frames by looping back to the first frame */
  loop?: InputMaybe<Scalars['Boolean']['input']>;
  modelData?: InputMaybe<ReplicateModelDataUpdateInput>;
  presetFlow?: InputMaybe<PresetFlow>;
  previewVideoUrl?: InputMaybe<Scalars['String']['input']>;
  videoGenerationModel?: InputMaybe<VideoGenerationModel>;
  weight?: InputMaybe<Scalars['Int']['input']>;
};

export type AiAnimatedElementPresetsFilters = {
  /** Once cursor is given, it will take the original filter parameters from the first request and apply them to the next subsequent requests, i.e.: if showHidden was given, it will keep using the same value for the next requests. */
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  showHidden?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AiAnimatedElementPresetsResponse = {
  __typename?: 'AiAnimatedElementPresetsResponse';
  nextCursor?: Maybe<Scalars['String']['output']>;
  presets: Array<AiAnimatedElementPreset>;
};

export type AiAnimatedElementsGeneration = {
  __typename?: 'AiAnimatedElementsGeneration';
  _id: Scalars['ID']['output'];
  createdAt: Scalars['Date']['output'];
  /** Total credit cost for all tasks in this generation */
  creditCost: Scalars['Int']['output'];
  errorMessages?: Maybe<Array<Scalars['String']['output']>>;
  feedback?: Maybe<GenerationFeedback>;
  generationId: Scalars['ID']['output'];
  inputBucketInfo?: Maybe<InputBucketInfo>;
  inputFileUrl: Scalars['String']['output'];
  /** Timestamp of the last time the generation was polled */
  lastPolledAt?: Maybe<Scalars['Float']['output']>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  metadataString?: Maybe<Scalars['String']['output']>;
  notifyEmail?: Maybe<Scalars['String']['output']>;
  presets: Array<AiAnimatedElementGenerationTask>;
  /** Preview URLs for all generation types (multipass, standard, nano banana with first/last frame pairs) */
  previewUrls: Array<Scalars['String']['output']>;
  /** Progress of the generation, from 0 to 100 */
  progress: Scalars['Float']['output'];
  status: AiAnimatedElementsGenerationStatus;
  userId: Scalars['String']['output'];
};

export enum AiAnimatedElementsGenerationStatus {
  /** Generation has been canceled */
  Canceled = 'CANCELED',
  /** There was an error with the generation itself */
  Error = 'ERROR',
  FetchingPresets = 'FETCHING_PRESETS',
  GeneratingTasks = 'GENERATING_TASKS',
  /** The generation is waiting for the frame validation to start */
  PendingFrameValidation = 'PENDING_FRAME_VALIDATION',
  RemovingBackground = 'REMOVING_BACKGROUND',
  Starting = 'STARTING',
  /** All tasks are completed */
  TasksCompleted = 'TASKS_COMPLETED',
  /** All tasks are completed, but at least one of them has an error */
  TasksCompletedWithErrors = 'TASKS_COMPLETED_WITH_ERRORS',
  /** At least one task is completed, but not all of them */
  TasksPartialCompleted = 'TASKS_PARTIAL_COMPLETED',
  /** At least one task failed, and the others are still queued/processing */
  TasksPartialError = 'TASKS_PARTIAL_ERROR',
  /** All tasks have been sent to the queue */
  TasksSent = 'TASKS_SENT'
}

export type AiCheckoutSessionInput = {
  couponId?: InputMaybe<Scalars['String']['input']>;
  periodicity?: InputMaybe<PricePeriodicity>;
  referral?: InputMaybe<Scalars['String']['input']>;
};

export type AiCreditsScheduledTask = {
  __typename?: 'AiCreditsScheduledTask';
  /** The task name */
  name: Scalars['String']['output'];
  /** The scheduled time for the task */
  scheduleTime: Scalars['Date']['output'];
};

export type AiCreditsTransferResponse = {
  __typename?: 'AiCreditsTransferResponse';
  transferedCredits: Scalars['Int']['output'];
};

export type AiFileInfo = {
  __typename?: 'AiFileInfo';
  bucketName: Scalars['String']['output'];
  filePath: Scalars['String']['output'];
  signedUrl: Scalars['String']['output'];
};

export enum AiRevealAspectRatio {
  /** 16:9 ratio */
  Landscape = 'landscape',
  /** 9:16 ratio */
  Portrait = 'portrait',
  /** 5:3 ratio */
  RunwayLandscape = 'runwayLandscape',
  RunwayLandscapeV4 = 'runwayLandscapeV4',
  /** 3:5 ratio */
  RunwayPortrait = 'runwayPortrait',
  RunwayPortraitV4 = 'runwayPortraitV4',
  /** 1:1 ratio */
  Square = 'square',
  /** 4:5 ratio */
  Vertical = 'vertical'
}

export enum AiRevealImagePosition {
  Bottom = 'bottom',
  BottomLeft = 'bottomLeft',
  BottomRight = 'bottomRight',
  Center = 'center',
  Custom = 'custom',
  Left = 'left',
  Right = 'right',
  Top = 'top',
  TopLeft = 'topLeft',
  TopRight = 'topRight'
}

export type AiRevealSubscription = {
  __typename?: 'AiRevealSubscription';
  currency: Currency;
  periodicity: PricePeriodicity;
  price: Scalars['Int']['output'];
  tokensGiven: Scalars['Int']['output'];
};

export enum AiSubIssueCode {
  InvalidScheduledTaskNameOrCycle = 'invalid_scheduled_task_name_or_cycle',
  MissingCycle = 'missing_cycle',
  MissingScheduledTaskInDb = 'missing_scheduled_task_in_db',
  ScheduledTaskNotFound = 'scheduled_task_not_found'
}

export type AiSubscriberInfo = {
  __typename?: 'AiSubscriberInfo';
  attributionHistory: Array<AttributionHistory>;
  autoRenewalStatus?: Maybe<AutoRenewalStatus>;
  expirationDate?: Maybe<Scalars['Date']['output']>;
  hasActiveSubscription: Scalars['Boolean']['output'];
  interval?: Maybe<SubscriptionInterval>;
  isInGracePeriod: Scalars['Boolean']['output'];
  store?: Maybe<Store>;
  tokenRenewalInfo?: Maybe<TokenRenewalInfo>;
};

export type AiTokensAttributionNumbers = {
  __typename?: 'AiTokensAttributionNumbers';
  oneOff: AiTokensAttributionOneOffNumbers;
  subscription: AiTokensAttributionSubscriptionNumbers;
};

export type AiTokensAttributionOneOffNumbers = {
  __typename?: 'AiTokensAttributionOneOffNumbers';
  l: Scalars['Int']['output'];
  m: Scalars['Int']['output'];
  s: Scalars['Int']['output'];
  xl: Scalars['Int']['output'];
};

export type AiTokensAttributionSubscriptionNumbers = {
  __typename?: 'AiTokensAttributionSubscriptionNumbers';
  monthly: Scalars['Int']['output'];
  weekly: Scalars['Int']['output'];
  yearly: Scalars['Int']['output'];
};

export type AiTokensPlan = {
  __typename?: 'AiTokensPlan';
  currency: Currency;
  name: Scalars['String']['output'];
  price: Scalars['Int']['output'];
  productId: Scalars['String']['output'];
  tokensGiven: Scalars['Int']['output'];
};

export type AnimatedEmoji = {
  __typename?: 'AnimatedEmoji';
  name: Scalars['String']['output'];
  urls: AnimatedEmojiUrls;
};

export type AnimatedEmojiUrls = {
  __typename?: 'AnimatedEmojiUrls';
  gif: Scalars['String']['output'];
  lottie: Scalars['String']['output'];
  webp: Scalars['String']['output'];
};

export type AnimatedEmojyByCategory = {
  __typename?: 'AnimatedEmojyByCategory';
  category: Scalars['String']['output'];
  emojis: Array<AnimatedEmoji>;
};

export enum AppName {
  Mojo = 'mojo',
  Reveals = 'reveals',
  RevealsAdmin = 'revealsAdmin'
}

export type AppPlatformVersionFilters = {
  platform: Platform;
  version: Scalars['String']['input'];
};

export type AppSnapshot = {
  __typename?: 'AppSnapshot';
  /** The build number of the application used to generate this video export. */
  build: Scalars['Long']['output'];
  /** The environment of the application used to generate this video export. */
  env: Scalars['String']['output'];
  /** The featuring status of this video in the application. */
  featuring: FeaturingStatus;
  /** The language of the device used to generate this video export. */
  language?: Maybe<Scalars['String']['output']>;
  /** A list of all the pages included in this video export. */
  pages: Array<Page>;
  /** The platform of the application used to generate this video export. */
  platform: Scalars['String']['output'];
  /** The version of the application used to generate this video export. */
  version: Scalars['String']['output'];
};

export type AppStoreBillingData = {
  eventId: Scalars['String']['input'];
  expirationTimeMs: Scalars['Float']['input'];
  originalTransactionId: Scalars['String']['input'];
  periodType: TransactionPeriodType;
  productId: Scalars['String']['input'];
  purchasedAtMs: Scalars['Float']['input'];
  transactionId: Scalars['String']['input'];
};

export type AttributionHistory = {
  __typename?: 'AttributionHistory';
  addedAt: Scalars['Date']['output'];
  attributionId: Scalars['String']['output'];
  currentTokensCount: Scalars['Int']['output'];
  initialTokensCount: Scalars['Int']['output'];
  source: TokenSource;
  storeEnvironment: IapEnvironment;
};

export type AudioElement = {
  __typename?: 'AudioElement';
  category?: Maybe<Scalars['String']['output']>;
};

export enum AudioEncoding {
  Amr = 'AMR',
  AmrWb = 'AMR_WB',
  EncodingUnspecified = 'ENCODING_UNSPECIFIED',
  Flac = 'FLAC',
  Linear16 = 'LINEAR16',
  Mulaw = 'MULAW',
  OggOpus = 'OGG_OPUS',
  SpeexWithHeaderByte = 'SPEEX_WITH_HEADER_BYTE',
  WebmOpus = 'WEBM_OPUS'
}

export type AudioFromTextResponse = {
  __typename?: 'AudioFromTextResponse';
  bucketName: Scalars['String']['output'];
  filePath: Scalars['String']['output'];
  /** Valid for 7 days */
  url: Scalars['String']['output'];
};

export type AutoEditSection = {
  __typename?: 'AutoEditSection';
  layoutId: Scalars['String']['output'];
  sentences: Array<AutoEditSectionSentence>;
};

export type AutoEditSectionSentence = {
  __typename?: 'AutoEditSectionSentence';
  bRollBucketInfo?: Maybe<BrollBucketInfo>;
  bRollUrl?: Maybe<Scalars['String']['output']>;
  end: Scalars['Float']['output'];
  start: Scalars['Float']['output'];
  text: Scalars['String']['output'];
  words: Array<Maybe<TextWithTimings>>;
};

export type AutoEditsResponse = {
  __typename?: 'AutoEditsResponse';
  detectedLanguage?: Maybe<Scalars['String']['output']>;
  fullText: Scalars['String']['output'];
  sections: Array<AutoEditSection>;
  speechToTextProviderUsed: SpeechToTextProvider;
  stockVideoProviderUsed: StockVideoProvider;
};

export enum AutoRenewalStatus {
  HasAlreadyRenewed = 'HAS_ALREADY_RENEWED',
  RequiresPriceIncreaseConsent = 'REQUIRES_PRICE_INCREASE_CONSENT',
  WillChangeProduct = 'WILL_CHANGE_PRODUCT',
  WillNotRenew = 'WILL_NOT_RENEW',
  WillPause = 'WILL_PAUSE',
  WillRenew = 'WILL_RENEW'
}

export type AvatarFromTextResponse = {
  __typename?: 'AvatarFromTextResponse';
  task_id: Scalars['String']['output'];
};

export enum AvatarTaskStatus {
  /** uploading to cloud storage */
  Copy = 'copy',
  /** algorithm error */
  Fail = 'fail',
  /** initialization */
  Init = 'init',
  /** in algorithm queue */
  Pending = 'pending',
  /** being processed */
  Process = 'process',
  /** sent to algorithm */
  Start = 'start',
  /** success */
  Success = 'success'
}

export type AvatarVideoTask = {
  __typename?: 'AvatarVideoTask';
  message?: Maybe<Scalars['String']['output']>;
  progress: Scalars['Float']['output'];
  status: AvatarTaskStatus;
  taskId: Scalars['String']['output'];
  video_url?: Maybe<Scalars['String']['output']>;
};

export type AvatarVideoTaskResponse = {
  __typename?: 'AvatarVideoTaskResponse';
  tasks: Array<AvatarVideoTask>;
};

export type BillingInfos = {
  __typename?: 'BillingInfos';
  payingUserId: Scalars['String']['output'];
  store: Store;
  stripeMetadata?: Maybe<StripeMetadata>;
  validUntil: Scalars['Date']['output'];
};

export type BlacklistStatus = {
  __typename?: 'BlacklistStatus';
  /** Whether or not the user is blacklisted from curation. */
  curation?: Maybe<Scalars['Boolean']['output']>;
};

export enum BrandkitFileType {
  Font = 'FONT',
  Logo = 'LOGO'
}

export type BrollBucketInfo = {
  __typename?: 'BrollBucketInfo';
  bucketName: Scalars['String']['output'];
  filePath: Scalars['String']['output'];
};

export type BucketInfoInput = {
  bucketName: Scalars['String']['input'];
  filePath: Scalars['String']['input'];
};

export type BucketsInfo = {
  __typename?: 'BucketsInfo';
  thumbnailBucketName: Scalars['String']['output'];
  videoBucketName: Scalars['String']['output'];
};

export enum CacheControlScope {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export type CancelGenerationResponse = {
  __typename?: 'CancelGenerationResponse';
  generationId: Scalars['ID']['output'];
  status: AiAnimatedElementsGenerationStatus;
};

/** Input for a template item within a category */
export type CategoryTemplateInput = {
  hidden: Scalars['Boolean']['input'];
  templateId: Scalars['String']['input'];
  weight: Scalars['Int']['input'];
};

/** Output type for category template items */
export type CategoryTemplateOutput = {
  __typename?: 'CategoryTemplateOutput';
  hidden: Scalars['Boolean']['output'];
  templateId: Scalars['String']['output'];
  weight: Scalars['Int']['output'];
};

export type CheckTrendySoundTemplatesResult = {
  __typename?: 'CheckTrendySoundTemplatesResult';
  status: Scalars['String']['output'];
};

export type CheckoutSession = {
  __typename?: 'CheckoutSession';
  sessionId: Scalars['String']['output'];
};

export type CheckoutSessionCustomerInfo = {
  __typename?: 'CheckoutSessionCustomerInfo';
  email?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  stripeCustomerId: Scalars['String']['output'];
};

export type CheckoutSessionInput = {
  annual?: InputMaybe<Scalars['Boolean']['input']>;
  couponId?: InputMaybe<Scalars['String']['input']>;
  isTeam?: InputMaybe<Scalars['Boolean']['input']>;
  referral?: InputMaybe<Scalars['String']['input']>;
};

export type CheckoutSessionSuccessInfo = {
  __typename?: 'CheckoutSessionSuccessInfo';
  currency: Scalars['String']['output'];
  customer: CheckoutSessionCustomerInfo;
  livemode: Scalars['Boolean']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
};

export type CleancutFilters = {
  mediaNb: Scalars['Int']['input'];
};

export type Collection = {
  __typename?: 'Collection';
  collectionId: Scalars['String']['output'];
  collectionName: Scalars['String']['output'];
};

export type CompositionParametersInput = {
  aspectRatio: AiRevealAspectRatio;
  coordinates?: InputMaybe<CoordinatesInput>;
  imagePosition: AiRevealImagePosition;
  margin: Scalars['Float']['input'];
};

export enum ContentAbout {
  Agency = 'agency',
  ArtDesign = 'art_design',
  Beauty = 'beauty',
  BusinessVenues = 'business_venues',
  Ecommerce = 'ecommerce',
  Education = 'education',
  Fashion = 'fashion',
  Food = 'food',
  HealthFitness = 'health_fitness',
  MediaPublishing = 'media_publishing',
  Music = 'music',
  Other = 'other',
  Photography = 'photography',
  RealEstate = 'real_estate',
  Technology = 'technology',
  Travel = 'travel'
}

export type ConvertSpeechFromAudioToTextResponse = {
  __typename?: 'ConvertSpeechFromAudioToTextResponse';
  detectedLanguage?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Float']['output']>;
  fullText: Scalars['String']['output'];
  provider: SpeechToTextProvider;
  sentences: Array<Maybe<SentenceWithSegments>>;
};

export type Coordinates = {
  __typename?: 'Coordinates';
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
};

export type CoordinatesInput = {
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
};

export enum CreateOrUpdateVideoProjectPerformedOperation {
  Create = 'create',
  None = 'none',
  Update = 'update'
}

export type CreateOrUpdateVideoProjectResult = {
  __typename?: 'CreateOrUpdateVideoProjectResult';
  existingProject: Scalars['Boolean']['output'];
  nowVideoProject: VideoProject;
  performedOperation: CreateOrUpdateVideoProjectPerformedOperation;
  previousVideoProject?: Maybe<VideoProject>;
  succeedAtTry: Scalars['Int']['output'];
};

export type CreateProjectMediasResponse = {
  __typename?: 'CreateProjectMediasResponse';
  bucketName: Scalars['String']['output'];
  toUpload: Array<Scalars['String']['output']>;
  uploadPath: Scalars['String']['output'];
};

/** Featured videos are user's videos we decided to keep and feature in the explore tab of the app. */
export type CuratedVideo = {
  __typename?: 'CuratedVideo';
  /** Whether or not this featured video is active in the explore tab. */
  active: Scalars['Boolean']['output'];
  /** The application information of this featured video. */
  app: AppSnapshot;
  /** The application snapshot of this featured video. */
  categories?: Maybe<Array<Scalars['String']['output']>>;
  /** The creation date of the curated video in the database. */
  createdAt: Scalars['Date']['output'];
  /** The original export who served as a base to create this featured video. */
  origin: VideoExport;
  /** The URL of video streamed by MUX. */
  streamUrl?: Maybe<Scalars['String']['output']>;
  /** The URL of thumbnail generated by MUX. */
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  /** The last date the curated video was updated in the database. */
  updatedAt: Scalars['Date']['output'];
  /** The URL of the original video to display. */
  url: Scalars['String']['output'];
};

export type Currency = {
  __typename?: 'Currency';
  isoCode: Scalars['String']['output'];
  showBefore?: Maybe<Scalars['Boolean']['output']>;
  symbol?: Maybe<Scalars['String']['output']>;
};

export type DeleteCuratedVideoMutationResponse = MutationResponse & {
  __typename?: 'DeleteCuratedVideoMutationResponse';
  code: Scalars['String']['output'];
  featuredVideo?: Maybe<CuratedVideo>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type DeleteProjectMutationResponse = MutationResponse & {
  __typename?: 'DeleteProjectMutationResponse';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  /** The id of the project which has been deleted. */
  projectId?: Maybe<Scalars['ID']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DeleteTrendySongTemplateMutationResponse = {
  __typename?: 'DeleteTrendySongTemplateMutationResponse';
  deletedCount: Scalars['Int']['output'];
};

export type DetectedObject = {
  __typename?: 'DetectedObject';
  longDescription: Scalars['String']['output'];
  shortDescription: Scalars['String']['output'];
};

export type Device = {
  __typename?: 'Device';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type DeviceInput = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export enum DisplayView {
  InstagramTab = 'INSTAGRAM_TAB',
  TiktokTab = 'TIKTOK_TAB'
}

export type EmojiEnrichedElement = {
  __typename?: 'EmojiEnrichedElement';
  emoji?: Maybe<Scalars['String']['output']>;
  highlightedWord?: Maybe<Scalars['String']['output']>;
};

export type EmojisForSentencesResponse = {
  __typename?: 'EmojisForSentencesResponse';
  sentences: Array<Maybe<SentenceWithEmoji>>;
};

export type EnrichedAudioElement = {
  __typename?: 'EnrichedAudioElement';
  category?: Maybe<Scalars['String']['output']>;
};

export type EnrichedBRollElementUrl = {
  __typename?: 'EnrichedBRollElementUrl';
  landscape: Scalars['String']['output'];
  large: Scalars['String']['output'];
  large2x: Scalars['String']['output'];
  medium: Scalars['String']['output'];
  original: Scalars['String']['output'];
  portrait: Scalars['String']['output'];
  small: Scalars['String']['output'];
  tiny: Scalars['String']['output'];
};

export type EnrichedBrollElement = {
  __typename?: 'EnrichedBrollElement';
  /** @deprecated old broll property */
  highlightedWord?: Maybe<Scalars['String']['output']>;
  /** @deprecated old broll property */
  keywords?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  keywordsString: Scalars['String']['output'];
  segment: Scalars['String']['output'];
  urls: EnrichedBRollElementUrl;
};

export type EnrichedElementTitle = {
  __typename?: 'EnrichedElementTitle';
  emoji?: Maybe<Scalars['String']['output']>;
  highlightedWord?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type EnrichedElementTopic = {
  __typename?: 'EnrichedElementTopic';
  textSection: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type EnrichedElements = {
  __typename?: 'EnrichedElements';
  bRolls?: Maybe<Array<EnrichedBrollElement>>;
  emojis?: Maybe<Array<EmojiEnrichedElement>>;
  soundFxs?: Maybe<Array<SoundEffectElement>>;
};

export type EnrichedElementsForContext = {
  __typename?: 'EnrichedElementsForContext';
  audio?: Maybe<EnrichedAudioElement>;
  detectedData?: Maybe<Scalars['String']['output']>;
  titles: Array<EnrichedElementTitle>;
  topics?: Maybe<Array<EnrichedElementTopic>>;
};

export type EnrichedElementsForSentences = {
  __typename?: 'EnrichedElementsForSentences';
  globalContextElements: EnrichedElementsForContext;
  sentences: Array<Maybe<SentenceWithEnrichedElements>>;
};

export type EnrichedElementsForSentencesResponse = {
  __typename?: 'EnrichedElementsForSentencesResponse';
  globalContextElements: GlobalContextEnrichedElements;
  sentences: Array<Maybe<SentenceWithEnrichedElements>>;
};

export type ExploreFilters = {
  category?: InputMaybe<Scalars['String']['input']>;
};

export enum Font_Extension {
  Otf = 'otf',
  Ttf = 'ttf'
}

export type FailedPresetModelMigration = {
  __typename?: 'FailedPresetModelMigration';
  presetId: Scalars['String']['output'];
  reason: Scalars['String']['output'];
};

export enum FalAiModel {
  AuraFlow = 'auraFlow',
  CogView = 'cogView',
  FluxPhoto = 'fluxPhoto',
  FluxPro = 'fluxPro',
  FluxProNew = 'fluxProNew',
  FluxSchnell = 'fluxSchnell',
  FluxUltra = 'fluxUltra',
  IdeogramV2 = 'ideogramV2',
  IdeogramV2A = 'ideogramV2A',
  IdeogramV2ATurbo = 'ideogramV2ATurbo',
  Lumina = 'lumina',
  MinimaxImage = 'minimaxImage',
  RecraftV3 = 'recraftV3',
  Sana = 'sana',
  Switti = 'switti'
}

export type FavoriteTemplate = {
  __typename?: 'FavoriteTemplate';
  addedAt: Scalars['Date']['output'];
  entityId: Scalars['String']['output'];
  format: FavoriteTemplateFormat;
};

export enum FavoriteTemplateFormat {
  Custom = 'CUSTOM',
  FacebookPost = 'FACEBOOK_POST',
  FacebookVideoAd = 'FACEBOOK_VIDEO_AD',
  InstagramPost = 'INSTAGRAM_POST',
  InstagramReel = 'INSTAGRAM_REEL',
  InstagramStory = 'INSTAGRAM_STORY',
  InstagramVideo = 'INSTAGRAM_VIDEO',
  Landscape = 'LANDSCAPE',
  PinterestPin = 'PINTEREST_PIN',
  Presentation = 'PRESENTATION',
  Square = 'SQUARE',
  Tiktok = 'TIKTOK',
  TwitterTweet = 'TWITTER_TWEET',
  TwitterVideo = 'TWITTER_VIDEO',
  Youtube = 'YOUTUBE',
  YoutubeShorts = 'YOUTUBE_SHORTS'
}

export type FavoriteTemplateInput = {
  entityId: Scalars['String']['input'];
  format: FavoriteTemplateFormat;
};

export type FeatureMutationResponse = MutationResponse & {
  __typename?: 'FeatureMutationResponse';
  code: Scalars['String']['output'];
  featuredVideo?: Maybe<CuratedVideo>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type FeaturingStatus = {
  __typename?: 'FeaturingStatus';
  /** Whether or not this export is allowed to be featured. */
  allowed?: Maybe<Scalars['Boolean']['output']>;
  /** Whether or not this export has been shortlisted to be featured. */
  curated?: Maybe<Scalars['Boolean']['output']>;
};

/** Type use to store Media/File */
export type File = {
  __typename?: 'File';
  _id: Scalars['ID']['output'];
  bucketName: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  validatedAt?: Maybe<Scalars['Date']['output']>;
};

export type Font = {
  __typename?: 'Font';
  _id: Scalars['ID']['output'];
  bucketName: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
};

export type Gcs = {
  __typename?: 'Gcs';
  expiredAt?: Maybe<Scalars['Date']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  uploadedAt?: Maybe<Scalars['Date']['output']>;
};

export enum Gender {
  Female = 'female',
  Male = 'male'
}

export type GenerateTemplateFilesFromSourceVideoResult = {
  __typename?: 'GenerateTemplateFilesFromSourceVideoResult';
  frame: Scalars['String']['output'];
  highRes: Scalars['String']['output'];
  lowRes: Scalars['String']['output'];
};

export type GeneratedImageData = {
  __typename?: 'GeneratedImageData';
  content_type: Scalars['String']['output'];
  height: Scalars['Float']['output'];
  url: Scalars['String']['output'];
  width: Scalars['Float']['output'];
};

export type GeneratedImagesFromPrompt = {
  __typename?: 'GeneratedImagesFromPrompt';
  image: GeneratedImageData;
  prompt: Scalars['String']['output'];
};

export type GenerationFeedback = {
  __typename?: 'GenerationFeedback';
  message?: Maybe<Scalars['String']['output']>;
  rating: Scalars['Int']['output'];
};

export type GenerationWithOrientation = {
  __typename?: 'GenerationWithOrientation';
  aspectRatio: AiRevealAspectRatio;
  generationId: Scalars['String']['output'];
};

export type GenerationsByDetectedObject = {
  __typename?: 'GenerationsByDetectedObject';
  detectedObject: Scalars['String']['output'];
  generations: Array<GenerationWithOrientation>;
  previewUrl?: Maybe<Scalars['String']['output']>;
};

export type GenerationsByDetectedObjectsResponse = {
  __typename?: 'GenerationsByDetectedObjectsResponse';
  items: Array<GenerationsByDetectedObject>;
};

export type GetCuratedVideosFilters = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type GetProfileByTokenResponse = {
  __typename?: 'GetProfileByTokenResponse';
  accessToken: Scalars['String']['output'];
  user: User;
};

export type GetRevealsCategoriesWithPresetsFilters = {
  /** Once cursor is given, it will take the original filter parameters from the first request and apply them to the next subsequent requests, i.e.: if showHidden was given, it will keep using the same value for the next requests. */
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  showHidden?: InputMaybe<Scalars['Boolean']['input']>;
  showHiddenPresets?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GetUsersFilters = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  updatedAfter?: InputMaybe<Scalars['Date']['input']>;
};

export type GlobalContextEnrichedElements = {
  __typename?: 'GlobalContextEnrichedElements';
  audio?: Maybe<AudioElement>;
  detectedData?: Maybe<Scalars['String']['output']>;
  /** @deprecated we needed to generate an array of titles */
  title?: Maybe<Scalars['String']['output']>;
  titles: Array<Title>;
  topics?: Maybe<Array<Topic>>;
};

/** Dummy Response used to check if server is up or not. */
export type HealthCheckResponse = {
  __typename?: 'HealthCheckResponse';
  /** Returns UP if the server is up. */
  status: ServerStatus;
};

export enum HeardFrom {
  AppStore = 'app_store',
  Article = 'article',
  Facebook = 'facebook',
  Google = 'google',
  Instagram = 'instagram',
  Other = 'other',
  PersonnalRecommendation = 'personnal_recommendation',
  PlayStore = 'play_store',
  Tiktok = 'tiktok',
  Youtube = 'youtube'
}

export enum IapEnvironment {
  Production = 'production',
  Sandbox = 'sandbox'
}

export type ImageInput = {
  bucketName: Scalars['String']['input'];
  filePath: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export enum ImageStyleTransferModel {
  NanoBanana = 'NANO_BANANA',
  OpenAi = 'OPEN_AI'
}

export type ImageWithTextResponse = {
  __typename?: 'ImageWithTextResponse';
  file: File;
  prompt: Scalars['String']['output'];
};

export type InputBucketInfo = {
  __typename?: 'InputBucketInfo';
  bucketName: Scalars['String']['output'];
  detectedObject?: Maybe<DetectedObject>;
  filePath: Scalars['String']['output'];
};

export type InstagramData = {
  __typename?: 'InstagramData';
  songUrl: Scalars['String']['output'];
  videoUrl: Scalars['String']['output'];
};

export type InstagramDataInput = {
  songUrl: Scalars['String']['input'];
  videoUrl: Scalars['String']['input'];
};

export enum IntentTag {
  AnswerQuestions = 'ANSWER_QUESTIONS',
  CelebrateSuccesses = 'CELEBRATE_SUCCESSES',
  EducateViewers = 'EDUCATE_VIEWERS',
  EngageWithAudience = 'ENGAGE_WITH_AUDIENCE',
  PromoteBookings = 'PROMOTE_BOOKINGS',
  PromoteEvents = 'PROMOTE_EVENTS',
  PromoteSalesAndOffers = 'PROMOTE_SALES_AND_OFFERS',
  PromoteVenues = 'PROMOTE_VENUES',
  ShareNews = 'SHARE_NEWS',
  ShowBehindTheScenes = 'SHOW_BEHIND_THE_SCENES',
  ShowCustomerReviews = 'SHOW_CUSTOMER_REVIEWS',
  ShowProducts = 'SHOW_PRODUCTS'
}

export type IntermediateFramesValidationInput = {
  numberOfVariations: Scalars['Int']['input'];
};

export type InvoiceInput = {
  attemptCount: Scalars['Int']['input'];
  billingReason: Scalars['String']['input'];
  currency: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
  invoiceCreatedAt: Scalars['Date']['input'];
  invoiceId: Scalars['String']['input'];
  paidAmount: Scalars['Float']['input'];
  periodEnd: Scalars['Date']['input'];
  periodStart: Scalars['Date']['input'];
  quantity: Scalars['Int']['input'];
  status: Scalars['String']['input'];
  subscriptionId: Scalars['String']['input'];
  teamId: Scalars['String']['input'];
};

export type IosVersion = {
  __typename?: 'IosVersion';
  /** Maximum iOS version (using semver format) */
  max?: Maybe<Scalars['String']['output']>;
  /** Minimum iOS version (using semver format) */
  min?: Maybe<Scalars['String']['output']>;
};

export type IosVersionInput = {
  max?: InputMaybe<Scalars['String']['input']>;
  min?: InputMaybe<Scalars['String']['input']>;
};

export enum Logo_Extension {
  Gif = 'gif',
  Jpeg = 'jpeg',
  Jpg = 'jpg',
  Png = 'png',
  Svg = 'svg'
}

export type LocaleTranslationResult = {
  __typename?: 'LocaleTranslationResult';
  locale: Scalars['String']['output'];
  translations: Array<WordTranslation>;
};

export type Logo = {
  __typename?: 'Logo';
  _id: Scalars['ID']['output'];
  bucketName: Scalars['String']['output'];
  displayName?: Maybe<Scalars['String']['output']>;
  fileName: Scalars['String']['output'];
};

export enum Media_Extension {
  Gif = 'gif',
  Jpeg = 'jpeg',
  Jpg = 'jpg',
  M4v = 'm4v',
  Mov = 'mov',
  Mp4 = 'mp4',
  Mpeg = 'mpeg',
  Png = 'png'
}

export type MergedVideoInfoInput = {
  bucketName: Scalars['String']['input'];
  filePath: Scalars['String']['input'];
  signedUrl: Scalars['String']['input'];
};

export type ModelInput = {
  inputData: Scalars['String']['input'];
  modelId: Scalars['String']['input'];
};

export type ModelSwitchPresetEgibility = {
  __typename?: 'ModelSwitchPresetEgibility';
  currentModel?: Maybe<Scalars['String']['output']>;
  eligible: Scalars['Boolean']['output'];
  nonEligibleReason?: Maybe<Scalars['String']['output']>;
  presetId: Scalars['String']['output'];
};

export type MojoApi = {
  __typename?: 'MojoApi';
  version?: Maybe<Scalars['String']['output']>;
};

export type MojoKitQueries = {
  __typename?: 'MojoKitQueries';
  convertSpeechFromAudioToTextWithTimings: ConvertSpeechFromAudioToTextResponse;
  generateEnrichedElementsForSentences: EnrichedElementsForSentences;
};


export type MojoKitQueriesConvertSpeechFromAudioToTextWithTimingsArgs = {
  input: SpeechAudioInput;
  timeoutMs?: InputMaybe<Scalars['Int']['input']>;
  withProvider?: InputMaybe<SpeechToTextProvider>;
};


export type MojoKitQueriesGenerateEnrichedElementsForSentencesArgs = {
  sentences: Array<Scalars['String']['input']>;
  targetLanguage: Scalars['String']['input'];
};

export type MojoSubscriptionInfo = {
  __typename?: 'MojoSubscriptionInfo';
  autoRenewalStatus?: Maybe<AutoRenewalStatus>;
  expirationDate?: Maybe<Scalars['Date']['output']>;
  hasActiveSubscription: Scalars['Boolean']['output'];
  interval?: Maybe<SubscriptionInterval>;
  isInGracePeriod: Scalars['Boolean']['output'];
  store?: Maybe<Store>;
  subscriptionEntitlement?: Maybe<SubscriptionEntitlement>;
  tokenRenewalInfo?: Maybe<TokenRenewalInfo>;
};

export enum MojoUsageAs {
  BusinessOwner = 'business_owner',
  Creator = 'creator',
  InfluencerBlogger = 'influencer_blogger',
  MarketingPro = 'marketing_pro',
  Other = 'other',
  PersonalUse = 'personal_use'
}

export type MultiframesPromptsResult = {
  __typename?: 'MultiframesPromptsResult';
  framePrompts: Array<Scalars['String']['output']>;
  transitionPrompts: Array<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addDeviceToUser?: Maybe<User>;
  addProjectToCollection: Scalars['Boolean']['output'];
  /** Add subscription info */
  addSubscriptionInfos?: Maybe<AddSubscriptionInfosMutationResponse>;
  /** Create a user onboarding survey */
  addUserOnboardingSurvey: UserOnboardingSurvey;
  banUser?: Maybe<User>;
  cancelA2eTask?: Maybe<Scalars['Boolean']['output']>;
  cancelGeneration: CancelGenerationResponse;
  changeTeamMemberRole: Team;
  /** The return is the number of teams deleted — only possible in staging */
  cleanTeamData?: Maybe<Scalars['Int']['output']>;
  clearRevealsCategoriesTranslationsCache: Scalars['Boolean']['output'];
  clearStaledGenerations: Scalars['Int']['output'];
  /** Clear staled tasks */
  clearStaledTasks: Scalars['Int']['output'];
  clearTikTokWrappedTranslationCacheKeys?: Maybe<Scalars['Boolean']['output']>;
  clearTrendySongTemplateCategoryTranslationsCache: TrendySongTemplateCategoryTranslationsCacheResult;
  clearTrendySongTemplatesCache?: Maybe<Scalars['Boolean']['output']>;
  /** Create an AI animated element input media template */
  createAiAnimatedElementInputMediaTemplate: AiAnimatedElementInputMediaTemplate;
  /** Create an AI animated element preset */
  createAiAnimatedElementPreset: AiAnimatedElementPreset;
  /** Launch a batch generation of animated elements with presets */
  createAiAnimatedElementsWithPresets: AiAnimatedElementsGeneration;
  createAiAnimatedElementsWithPresetsAnonymous: AiAnimatedElementsGeneration;
  createAnimatedVideoFromImageImmediate: AiAnimatedElementsGeneration;
  createAnimatedVideoFromMultipleImages: AiAnimatedElementsGeneration;
  createAnimatedVideoFromPrompt: AiAnimatedElementsGeneration;
  createAnimatedVideoFromPromptAnonymous: AiAnimatedElementsGeneration;
  createAnimatedVideoFromText: AiAnimatedElementsGeneration;
  createAnimatedVideoFromTextAndImage: AiAnimatedElementsGeneration;
  createAnimatedVideoFromTextAndImageAnonymous: AiAnimatedElementsGeneration;
  createAnimatedVideoFromTextAnonymous: AiAnimatedElementsGeneration;
  createGenerationVariation: AiAnimatedElementsGeneration;
  /** Creates a mojo project with a list of images generated from audio */
  createImageSlideshowProjectFromAudio: VideoProject;
  createImageWithText?: Maybe<ImageWithTextResponse>;
  createImagesFromPrompts: Array<GeneratedImagesFromPrompt>;
  /**
   * To create and link a media to the project
   * @deprecated createMedia is deprecated. Use createMediaWithExtension instead.
   */
  createMedia: File;
  /** To create and link a media with extension to the project */
  createMediaWithExtension: File;
  createOrUpdateVideoProject?: Maybe<CreateOrUpdateVideoProjectResult>;
  createOrUpdateVideoProjectV2?: Maybe<CreateOrUpdateVideoProjectResult>;
  createProjectCollection: ProjectCollection;
  createProjectFromGeneration: VideoProjectLight;
  createProjectMedias: CreateProjectMediasResponse;
  /** Create a remote template */
  createRemoteTemplate?: Maybe<RemoteTemplate>;
  createRevealsCategory: RevealsCategory;
  /** Create a shareable link for a given export and userId (reserved to internal user) */
  createShareableLink?: Maybe<ShareableLink>;
  /** Create a shareable link for a given export and userId (reserved to internal user) */
  createShareableLinkInternal?: Maybe<ShareableLink>;
  /** Create a new task in the database */
  createTask: Task;
  createTeam: Team;
  /** Preferences Colors Create */
  createTeamBrandKitColor: Scalars['String']['output'];
  /** Create a file entity in the database representing a future upload to the brandkit bucket */
  createTeamBrandKitFileForUpload: File;
  /** Preferences Fonts Create */
  createTeamBrandKitFont: Font;
  /** Preferences Logo Create */
  createTeamBrandKitLogo: Logo;
  createTeamInvoice: TeamInvoice;
  /** Generate a team template from a video project based on its id. */
  createTemplate?: Maybe<Template>;
  /** Create a trendy song template */
  createTrendySongTemplate?: Maybe<TrendySongTemplate>;
  /** Create a trendy song template category */
  createTrendySongTemplateCategory?: Maybe<TrendySongTemplateCategoryDocument>;
  /** Create a trendy song template from a reel URL */
  createTrendySongTemplateFromReelUrl?: Maybe<TrendySongTemplate>;
  createUser?: Maybe<User>;
  deleteAiAnimatedElementInputMediaTemplate: AiAnimatedElementInputMediaTemplate;
  /** Delete an AI animated element preset */
  deleteAiAnimatedElementPreset: AiAnimatedElementPreset;
  /** Delete a generation and returns the deleted generation */
  deleteAiGeneration: AiAnimatedElementsGeneration;
  deleteCuratedVideo?: Maybe<DeleteCuratedVideoMutationResponse>;
  /**
   * Delete a project based on its id.
   * @deprecated deleteProject is deprecated. Use 'removeProject' to remove a single project and 'removeProjects' to remove multiple projects.
   */
  deleteProject?: Maybe<DeleteProjectMutationResponse>;
  deleteProjectCollection: Scalars['Boolean']['output'];
  /** Update the template with a new configuration. */
  deleteRemoteTemplate?: Maybe<Template>;
  deleteRevealsCategory: RevealsCategory;
  /** Delete a task. */
  deleteTask: Task;
  deleteTeam: Team;
  /** Update the template with a new configuration. */
  deleteTemplate?: Maybe<Template>;
  /** Delete the template matching the given ID and platform */
  deleteTrendySongTemplate?: Maybe<DeleteTrendySongTemplateMutationResponse>;
  /** Use to delete the current user account */
  deleteUser?: Maybe<User>;
  /**
   * Duplicate a project based on its projectId - If pages is given, the duplicated project will use it
   * @deprecated duplicatePersonalProjectLight is deprecated. Use 'duplicateVideoProject' instead.
   */
  duplicatePersonalProjectLight: VideoProjectLight;
  /** Duplicate a project based on its id - If teamIds is given, the project will be shared with the given teams */
  duplicateServerVideoProject?: Maybe<VideoProject>;
  /** Duplicate a project based on its projectId - If pages is given, the duplicated project will use it - if the project is shared with a team, the duplicate will be shared with the same teams. */
  duplicateVideoProject: VideoProjectLight;
  /** Toggle active status of a featured video. */
  feature?: Maybe<FeatureMutationResponse>;
  fixUserAiSubIssues: UserAiSubHealthReport;
  /** Flush all memory cache */
  flushAllCache: Scalars['String']['output'];
  flushUserSubscriptionInfo: Scalars['Boolean']['output'];
  /** Generate a new invitation link for the team - The link is valid for 7 days */
  generateTeamInvitationLink: Scalars['String']['output'];
  /** Re-encode the given video with in high and low quality, as well as generating a thumbnail in the same repository. templateId is used in the naming of the file */
  generateTemplateFilesFromSourceVideo: GenerateTemplateFilesFromSourceVideoResult;
  /** Grant a given number of AI credits to a user. Return the number of credits if they were added, null if not */
  grantAiCredits?: Maybe<Scalars['Int']['output']>;
  handleAiCheckoutSessionSuccess: Scalars['Boolean']['output'];
  handleCheckoutSessionSuccess: Scalars['Boolean']['output'];
  handleInAppPurchaseSuccess: Scalars['Boolean']['output'];
  joinTeam: Team;
  leaveTeam: Team;
  /** To add and remove member invitation */
  manageInvitations: Team;
  migrateProjectCollections: Scalars['Boolean']['output'];
  notifyEmailOnGenerationComplete: AiAnimatedElementsGeneration;
  recoverUserLostProjects: RecoverUserLostProjectsResponse;
  /** Regenerate a specific frame for a multipass generation while in preview */
  regenerateMultipassFrame: AiAnimatedElementsGeneration;
  regeneratePreviewFrames: AiAnimatedElementsGeneration;
  /** Remove a template from the logged-in user's favorites. Returns the removed favorite, or null if it was not found. */
  removeFavoriteTemplate?: Maybe<FavoriteTemplate>;
  /** To remove and unlink a media to the project */
  removeMedia: File;
  removeProfilePicture?: Maybe<RemoveProfilePictureMutationResponse>;
  /** Remove a project based on its id. */
  removeProject?: Maybe<RemoveProjectMutationResponse>;
  removeProjectFromCollection: Scalars['Boolean']['output'];
  /** Remove a project based on its id. */
  removeProjects?: Maybe<RemoveProjectsMutationResponse>;
  /** Preferences Colors Remove */
  removeTeamBrandKitColor: Scalars['String']['output'];
  /** Preferences Fonts Remove */
  removeTeamBrandKitFont: Font;
  /** Preferences Logo Remove */
  removeTeamBrandKitLogo: Logo;
  removeTeamMember: Team;
  /** Remove the team profile picture, only TEAM_OWNER and TEAM_ADMIN have permission to do this */
  removeTeamProfilePicture?: Maybe<Scalars['Boolean']['output']>;
  /** Resend invitation email to a user that was already invited */
  resendInvitationEmail: Scalars['String']['output'];
  /** Revoke a specific token pack by its attribution ID for a given user */
  revokeTokens: Array<Scalars['String']['output']>;
  saveRevenueCatWebhookEvent: Scalars['Boolean']['output'];
  sendFeedbackForGeneration: AiAnimatedElementsGeneration;
  sendGenerationNotification: AiAnimatedElementsGeneration;
  setAiTokensScheduledTaskId?: Maybe<Scalars['String']['output']>;
  setAutoLoginToken?: Maybe<SetAutoLoginTokenMutationResponse>;
  setCurationStatus?: Maybe<SetCurationStatus>;
  /** Attach a new template as a favorite to the logged-in user. */
  setFavoriteTemplate: FavoriteTemplate;
  /** Attach a new template as a favorite to the logged-in user. */
  setFavoriteTemplates: Array<Maybe<FavoriteTemplate>>;
  /** Update the name of a user. */
  setName?: Maybe<SetUserNameMutationResponse>;
  setRevenueCatWebhookStatus: RevenueCatWebhookStatusResponse;
  /** Billing */
  setStripeBillingInfos: Team;
  /** Billing */
  setTeamAppStoreBillingInfos: Team;
  /** Set RevenueCat subscriptions and billing infos for Pro User */
  setUserRevenueCatBillingInfos: User;
  /** Update the role of a user. */
  setUserRole?: Maybe<SetUserRoleMutationResponse>;
  shallowUpdate?: Maybe<CuratedVideo>;
  /** Start sharing a project with a team */
  shareProjectWithTeam?: Maybe<VideoProject>;
  /** Launch a multi-pass generation with multiple input images creating N-1 tasks for N images */
  startMultiPassGeneration: AiAnimatedElementsGeneration;
  startPendingGeneration: AiAnimatedElementsGeneration;
  startPendingGenerationAnonymous: AiAnimatedElementsGeneration;
  subscribeToGenerationProgress: AiAnimatedElementsGeneration;
  subscribeToWaitingList: Scalars['Boolean']['output'];
  /** Automatically check the current month and update template to the next month. Returns the list of trendySongTemplateIds that have been updated. */
  switchMonthForRecapTemplates?: Maybe<SwitchMonthForRecapTemplatesResult>;
  tansferUserProjects: RecoverUserLostProjectsResponse;
  transferAiCredits: AiCreditsTransferResponse;
  transferAiSubscriptionBenefits: AiCreditsTransferResponse;
  transferProSubscription: TransferProSubscriptionResponse;
  /** Transfer stories from the logged-in user to a target user. */
  transferStories?: Maybe<TransferStoriesMutationResponse>;
  /** Stop sharing a project with a team */
  unshareProjectWithTeam?: Maybe<VideoProject>;
  /** Update an AI animated element input media template */
  updateAiAnimatedElementInputMediaTemplate: AiAnimatedElementInputMediaTemplate;
  /** Update an AI animated element preset */
  updateAiAnimatedElementPreset?: Maybe<AiAnimatedElementPreset>;
  /** Internal call to update a brandkit file that was attached to a team */
  updateBrandkitFileInternal: File;
  /** Update categories of a featured video */
  updateCategories?: Maybe<UpdateCategoriesMutationResponse>;
  updateCompositionForFile: Scalars['String']['output'];
  /** Update a multipass generation with merged video information */
  updateMultiPassMergedVideo: AiAnimatedElementsGeneration;
  updatePresetThumbnailData?: Maybe<AiAnimatedElementPreset>;
  updatePresetVideoModelForCategory: UpdatePresetVideoModelForCategoryResult;
  /** @deprecated user profile picture is asynchronously updated by the backend, please use 'getUserProfilePictureUploadInfo' to get the upload information and just upload the picture to the given bucketName+uploadPath */
  updateProfilePicture?: Maybe<Picture>;
  /** Update the profile picture of a user. */
  updateProfilePictureInternal: Picture;
  /**
   * Update the template with a new configuration.
   * @deprecated Use updateProjectV2 instead.
   */
  updateProject?: Maybe<VideoProject>;
  updateProjectCollectionName: ProjectCollection;
  updateProjectThumbnailData?: Maybe<VideoProject>;
  /** [V2] Update the template with a new configuration. */
  updateProjectV2?: Maybe<VideoProject>;
  updateRevealsCategory: RevealsCategory;
  /** Update thumbnail URL of a shareable link */
  updateShareableLinkThumbnailUrl?: Maybe<ShareableLink>;
  /** Update the task with new data */
  updateTask: Task;
  updateTaskThumbnailData: Task;
  /** Preferences Fonts Update */
  updateTeamBrandKitFont: Font;
  /** Preferences Logo Update */
  updateTeamBrandKitLogo: Logo;
  /** Change team name */
  updateTeamName: Team;
  /** Update the team profile picture */
  updateTeamProfilePictureInternal: Picture;
  /** Update the template with a new configuration. */
  updateTemplate?: Maybe<Template>;
  updateTemplateThumbnailData?: Maybe<Template>;
  /** Update an existing trendy song template */
  updateTrendySongTemplate?: Maybe<TrendySongTemplate>;
  /** Update an existing trendy song template category */
  updateTrendySongTemplateCategory?: Maybe<TrendySongTemplateCategoryDocument>;
  /** Update a trendy song template category by categoryId, including its templates */
  updateTrendySongTemplateCategoryByCategoryId?: Maybe<TrendySongTemplateCategoryWithTemplatesDocument>;
  updateVideoFiles?: Maybe<Array<Maybe<TrendySongTemplate>>>;
  /** Validate BrandKit File upload */
  validateBrandKitFile: Scalars['String']['output'];
};


export type MutationAddDeviceToUserArgs = {
  device: DeviceInput;
  userId: Scalars['String']['input'];
};


export type MutationAddProjectToCollectionArgs = {
  collectionId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


export type MutationAddSubscriptionInfosArgs = {
  autoRenew: Scalars['Boolean']['input'];
  manageSubscriptionUrl: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationAddUserOnboardingSurveyArgs = {
  answers: SurveyAnswersInput;
};


export type MutationBanUserArgs = {
  toggle?: InputMaybe<Scalars['Boolean']['input']>;
  userId: Scalars['String']['input'];
};


export type MutationCancelA2eTaskArgs = {
  taskId: Scalars['String']['input'];
};


export type MutationCancelGenerationArgs = {
  generationId: Scalars['ID']['input'];
};


export type MutationChangeTeamMemberRoleArgs = {
  role: TeamRole;
  teamId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationClearTrendySongTemplateCategoryTranslationsCacheArgs = {
  categoryId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationClearTrendySongTemplatesCacheArgs = {
  regenerateCacheAfterClear?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateAiAnimatedElementInputMediaTemplateArgs = {
  inputMediaTemplate: AiAnimatedElementInputMediaTemplateInput;
};


export type MutationCreateAiAnimatedElementPresetArgs = {
  preset: AiAnimatedElementPresetInput;
};


export type MutationCreateAiAnimatedElementsWithPresetsArgs = {
  inputBucketInfo?: InputMaybe<BucketInfoInput>;
  inputFileUrl: Scalars['String']['input'];
  needsIntermediateFramesValidation?: InputMaybe<IntermediateFramesValidationInput>;
  presets?: InputMaybe<Array<PresetConfig>>;
  withAudio?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateAiAnimatedElementsWithPresetsAnonymousArgs = {
  inputBucketInfo?: InputMaybe<BucketInfoInput>;
  inputFileUrl: Scalars['String']['input'];
  needsIntermediateFramesValidation?: InputMaybe<IntermediateFramesValidationInput>;
  presets?: InputMaybe<Array<PresetConfig>>;
  withAudio?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateAnimatedVideoFromImageImmediateArgs = {
  imageUrl: Scalars['String']['input'];
  inputBucketInfo: BucketInfoInput;
  preset: PresetConfig;
};


export type MutationCreateAnimatedVideoFromMultipleImagesArgs = {
  inputImages: Array<ImageInput>;
  preset: PresetConfig;
  withAudio?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateAnimatedVideoFromPromptArgs = {
  preset: PresetConfig;
  withAudio?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateAnimatedVideoFromPromptAnonymousArgs = {
  preset: PresetConfig;
  withAudio?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateAnimatedVideoFromTextArgs = {
  preset: PresetConfig;
  textInput: Scalars['String']['input'];
  withAudio?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateAnimatedVideoFromTextAndImageArgs = {
  imageUrl: Scalars['String']['input'];
  inputBucketInfo: BucketInfoInput;
  preset: PresetConfig;
  textInput: Scalars['String']['input'];
  withAudio?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateAnimatedVideoFromTextAndImageAnonymousArgs = {
  imageUrl: Scalars['String']['input'];
  inputBucketInfo: BucketInfoInput;
  preset: PresetConfig;
  textInput: Scalars['String']['input'];
  withAudio?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateAnimatedVideoFromTextAnonymousArgs = {
  preset: PresetConfig;
  textInput: Scalars['String']['input'];
  withAudio?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateGenerationVariationArgs = {
  generationId: Scalars['ID']['input'];
  taskId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateImageSlideshowProjectFromAudioArgs = {
  aspectRatio?: InputMaybe<AiRevealAspectRatio>;
  audioUrl: Scalars['String']['input'];
  model?: InputMaybe<FalAiModel>;
};


export type MutationCreateImageWithTextArgs = {
  aspectRatio?: InputMaybe<AiRevealAspectRatio>;
  model?: InputMaybe<FalAiModel>;
  projectId: Scalars['String']['input'];
  prompt?: InputMaybe<Scalars['String']['input']>;
  text: Scalars['String']['input'];
};


export type MutationCreateImagesFromPromptsArgs = {
  aspectRatio?: InputMaybe<AiRevealAspectRatio>;
  model?: InputMaybe<FalAiModel>;
  prompts: Array<Scalars['String']['input']>;
};


export type MutationCreateMediaArgs = {
  projectId: Scalars['ID']['input'];
};


export type MutationCreateMediaWithExtensionArgs = {
  extension: Media_Extension;
  projectId: Scalars['ID']['input'];
};


export type MutationCreateOrUpdateVideoProjectArgs = {
  projectInput: VideoProjectInput;
};


export type MutationCreateOrUpdateVideoProjectV2Args = {
  projectInput: VideoProjectInputV2;
};


export type MutationCreateProjectCollectionArgs = {
  favorite?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};


export type MutationCreateProjectFromGenerationArgs = {
  generationId: Scalars['ID']['input'];
  taskId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateProjectMediasArgs = {
  mediaFiles: Array<Scalars['String']['input']>;
  projectId: Scalars['String']['input'];
};


export type MutationCreateRemoteTemplateArgs = {
  category: Scalars['String']['input'];
  displayNewBadge: Scalars['Boolean']['input'];
  format: Scalars['String']['input'];
  isFree: Scalars['Boolean']['input'];
  json?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  nativeTemplateName: Scalars['String']['input'];
  type: Scalars['String']['input'];
  videoURL: Scalars['String']['input'];
};


export type MutationCreateRevealsCategoryArgs = {
  categoryId: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  iosVersion?: InputMaybe<IosVersionInput>;
  isHighlighted?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  presets?: InputMaybe<Array<RevealsCategoryPresetInput>>;
  targetApps: Array<AppName>;
  weight?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationCreateShareableLinkArgs = {
  exportId: Scalars['String']['input'];
};


export type MutationCreateShareableLinkInternalArgs = {
  shareableLinkInput: ShareableLinkInput;
};


export type MutationCreateTaskArgs = {
  task: TaskInput;
};


export type MutationCreateTeamArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateTeamBrandKitColorArgs = {
  color: Scalars['String']['input'];
  teamId: Scalars['ID']['input'];
};


export type MutationCreateTeamBrandKitFileForUploadArgs = {
  fileName: Scalars['String']['input'];
  fileType: BrandkitFileType;
  teamId: Scalars['ID']['input'];
};


export type MutationCreateTeamBrandKitFontArgs = {
  extension: Font_Extension;
  name: Scalars['String']['input'];
  teamId: Scalars['ID']['input'];
};


export type MutationCreateTeamBrandKitLogoArgs = {
  extension: Logo_Extension;
  name?: InputMaybe<Scalars['String']['input']>;
  teamId: Scalars['ID']['input'];
};


export type MutationCreateTeamInvoiceArgs = {
  invoice: InvoiceInput;
};


export type MutationCreateTemplateArgs = {
  projectId: Scalars['ID']['input'];
  teamId: Scalars['ID']['input'];
};


export type MutationCreateTrendySongTemplateArgs = {
  createForAllPlatforms?: InputMaybe<Scalars['Boolean']['input']>;
  data: TrendySongTemplateInput;
};


export type MutationCreateTrendySongTemplateCategoryArgs = {
  data: TrendySongTemplateCategoryInput;
};


export type MutationCreateTrendySongTemplateFromReelUrlArgs = {
  data: TrendySongTemplateVersionGeneratorInput;
};


export type MutationCreateUserArgs = {
  newUserData: NewUserInput;
};


export type MutationDeleteAiAnimatedElementInputMediaTemplateArgs = {
  templateId: Scalars['ID']['input'];
};


export type MutationDeleteAiAnimatedElementPresetArgs = {
  presetId: Scalars['ID']['input'];
};


export type MutationDeleteAiGenerationArgs = {
  generationId: Scalars['ID']['input'];
};


export type MutationDeleteCuratedVideoArgs = {
  exportId: Scalars['ID']['input'];
};


export type MutationDeleteProjectArgs = {
  projectIds: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type MutationDeleteProjectCollectionArgs = {
  collectionId: Scalars['ID']['input'];
};


export type MutationDeleteRemoteTemplateArgs = {
  remoteTemplateId: Scalars['ID']['input'];
};


export type MutationDeleteRevealsCategoryArgs = {
  categoryId: Scalars['String']['input'];
};


export type MutationDeleteTaskArgs = {
  taskId: Scalars['ID']['input'];
};


export type MutationDeleteTeamArgs = {
  teamId: Scalars['ID']['input'];
};


export type MutationDeleteTemplateArgs = {
  templateId: Scalars['ID']['input'];
};


export type MutationDeleteTrendySongTemplateArgs = {
  options?: InputMaybe<TrendySongTemplateUpdateOptions>;
  platform: Platform;
  trendySongTemplateId: Scalars['ID']['input'];
};


export type MutationDuplicatePersonalProjectLightArgs = {
  pages?: InputMaybe<Array<InputMaybe<PageInput>>>;
  projectId: Scalars['ID']['input'];
};


export type MutationDuplicateServerVideoProjectArgs = {
  projectId: Scalars['ID']['input'];
  teamIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationDuplicateVideoProjectArgs = {
  pages?: InputMaybe<Array<InputMaybe<PageInput>>>;
  projectId: Scalars['ID']['input'];
};


export type MutationFeatureArgs = {
  exportId: Scalars['ID']['input'];
};


export type MutationFixUserAiSubIssuesArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationFlushUserSubscriptionInfoArgs = {
  userId: Scalars['String']['input'];
};


export type MutationGenerateTeamInvitationLinkArgs = {
  teamId: Scalars['ID']['input'];
};


export type MutationGenerateTemplateFilesFromSourceVideoArgs = {
  filePath: Scalars['String']['input'];
  templateId: Scalars['String']['input'];
};


export type MutationGrantAiCreditsArgs = {
  fromTrial?: InputMaybe<Scalars['Boolean']['input']>;
  grantForApp?: InputMaybe<AppName>;
  numberOfCredits: Scalars['Int']['input'];
  source?: InputMaybe<TokenSource>;
  store?: InputMaybe<Store>;
  storeEnvironment?: InputMaybe<IapEnvironment>;
  transactionId: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationHandleAiCheckoutSessionSuccessArgs = {
  checkoutSessionId: Scalars['String']['input'];
};


export type MutationHandleCheckoutSessionSuccessArgs = {
  checkoutSessionId: Scalars['String']['input'];
};


export type MutationHandleInAppPurchaseSuccessArgs = {
  environment?: InputMaybe<IapEnvironment>;
  transactionId: Scalars['String']['input'];
};


export type MutationJoinTeamArgs = {
  inviteLinkURL: Scalars['String']['input'];
};


export type MutationLeaveTeamArgs = {
  teamId: Scalars['ID']['input'];
};


export type MutationManageInvitationsArgs = {
  pull?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  teamId: Scalars['ID']['input'];
};


export type MutationMigrateProjectCollectionsArgs = {
  collectionsToMigrate: Array<ProjectCollectionMigrationInput>;
};


export type MutationNotifyEmailOnGenerationCompleteArgs = {
  generationId: Scalars['ID']['input'];
};


export type MutationRecoverUserLostProjectsArgs = {
  migrateOnlyRecentAlias?: InputMaybe<Scalars['Boolean']['input']>;
  userId: Scalars['String']['input'];
};


export type MutationRegenerateMultipassFrameArgs = {
  frameIndex: Scalars['Int']['input'];
  generationId: Scalars['ID']['input'];
};


export type MutationRegeneratePreviewFramesArgs = {
  generationId: Scalars['ID']['input'];
  previewCounts: Scalars['Int']['input'];
};


export type MutationRemoveFavoriteTemplateArgs = {
  favoriteTemplate: FavoriteTemplateInput;
};


export type MutationRemoveMediaArgs = {
  fileId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
};


export type MutationRemoveProjectArgs = {
  projectId: Scalars['ID']['input'];
};


export type MutationRemoveProjectFromCollectionArgs = {
  collectionId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


export type MutationRemoveProjectsArgs = {
  projectIds: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type MutationRemoveTeamBrandKitColorArgs = {
  color: Scalars['String']['input'];
  teamId: Scalars['ID']['input'];
};


export type MutationRemoveTeamBrandKitFontArgs = {
  fileId: Scalars['ID']['input'];
  teamId: Scalars['ID']['input'];
};


export type MutationRemoveTeamBrandKitLogoArgs = {
  fileId: Scalars['ID']['input'];
  teamId: Scalars['ID']['input'];
};


export type MutationRemoveTeamMemberArgs = {
  teamId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationRemoveTeamProfilePictureArgs = {
  teamId: Scalars['ID']['input'];
};


export type MutationResendInvitationEmailArgs = {
  email: Scalars['String']['input'];
  teamId: Scalars['ID']['input'];
};


export type MutationRevokeTokensArgs = {
  attributionId: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationSaveRevenueCatWebhookEventArgs = {
  eventId: Scalars['ID']['input'];
  rawJsonEvent: Scalars['String']['input'];
};


export type MutationSendFeedbackForGenerationArgs = {
  generationId: Scalars['ID']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  rating: Scalars['Int']['input'];
};


export type MutationSendGenerationNotificationArgs = {
  generationId: Scalars['ID']['input'];
};


export type MutationSetAiTokensScheduledTaskIdArgs = {
  appName?: InputMaybe<AppName>;
  scheduledTaskId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSetCurationStatusArgs = {
  status: Scalars['Boolean']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationSetFavoriteTemplateArgs = {
  favoriteTemplate: FavoriteTemplateInput;
};


export type MutationSetFavoriteTemplatesArgs = {
  favoriteTemplates: Array<InputMaybe<FavoriteTemplateInput>>;
};


export type MutationSetNameArgs = {
  name: Scalars['String']['input'];
};


export type MutationSetRevenueCatWebhookStatusArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationSetStripeBillingInfosArgs = {
  currentPeriodEndMs: Scalars['Float']['input'];
  stripeCustomerId: Scalars['String']['input'];
  stripeSubscriptionItemId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationSetTeamAppStoreBillingInfosArgs = {
  data: AppStoreBillingData;
  userId: Scalars['String']['input'];
};


export type MutationSetUserRevenueCatBillingInfosArgs = {
  data: StoreBillingData;
  override?: InputMaybe<Scalars['Boolean']['input']>;
  userIds: Array<InputMaybe<Scalars['String']['input']>>;
};


export type MutationSetUserRoleArgs = {
  role: Role;
  userId: Scalars['ID']['input'];
};


export type MutationShallowUpdateArgs = {
  exportId: Scalars['ID']['input'];
};


export type MutationShareProjectWithTeamArgs = {
  projectId: Scalars['ID']['input'];
  teamId: Scalars['ID']['input'];
};


export type MutationStartMultiPassGenerationArgs = {
  inputImages: Array<ImageInput>;
  presets: Array<PresetConfig>;
};


export type MutationStartPendingGenerationArgs = {
  generationId: Scalars['ID']['input'];
  previewUrl: Scalars['String']['input'];
  videoDuration?: InputMaybe<Scalars['Int']['input']>;
  withAudio?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationStartPendingGenerationAnonymousArgs = {
  generationId: Scalars['ID']['input'];
  previewUrl: Scalars['String']['input'];
  videoDuration?: InputMaybe<Scalars['Int']['input']>;
  withAudio?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSubscribeToGenerationProgressArgs = {
  generationId: Scalars['ID']['input'];
  pushToken: Scalars['String']['input'];
};


export type MutationSubscribeToWaitingListArgs = {
  email: Scalars['String']['input'];
};


export type MutationTansferUserProjectsArgs = {
  uidFrom: Scalars['String']['input'];
  uidTo: Scalars['String']['input'];
};


export type MutationTransferAiSubscriptionBenefitsArgs = {
  appName: AppName;
  fromUserId: Scalars['String']['input'];
  toUserId: Scalars['String']['input'];
};


export type MutationTransferProSubscriptionArgs = {
  transferredFrom: Array<InputMaybe<Scalars['String']['input']>>;
  transferredTo: Array<InputMaybe<Scalars['String']['input']>>;
};


export type MutationTransferStoriesArgs = {
  stories?: InputMaybe<Array<InputMaybe<StorySnapshotInput>>>;
  target: Scalars['ID']['input'];
};


export type MutationUnshareProjectWithTeamArgs = {
  projectId: Scalars['ID']['input'];
  teamId: Scalars['ID']['input'];
  transferToUserId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpdateAiAnimatedElementInputMediaTemplateArgs = {
  templateId: Scalars['ID']['input'];
  updateData: AiAnimatedElementInputMediaTemplateUpdateInput;
};


export type MutationUpdateAiAnimatedElementPresetArgs = {
  presetId: Scalars['ID']['input'];
  updateData: AiAnimatedElementPresetUpdateInput;
};


export type MutationUpdateBrandkitFileInternalArgs = {
  fileName: Scalars['String']['input'];
};


export type MutationUpdateCategoriesArgs = {
  categories?: InputMaybe<Scalars['String']['input']>;
  exportId: Scalars['ID']['input'];
};


export type MutationUpdateCompositionForFileArgs = {
  compositionParameters: CompositionParametersInput;
  fileInfo: BucketInfoInput;
};


export type MutationUpdateMultiPassMergedVideoArgs = {
  generationId: Scalars['ID']['input'];
  mergedVideoInfo: MergedVideoInfoInput;
};


export type MutationUpdatePresetThumbnailDataArgs = {
  beforeAfterThumbnailData?: InputMaybe<ThumbnailDataInput>;
  presetId: Scalars['String']['input'];
  thumbnailData?: InputMaybe<ThumbnailDataInput>;
};


export type MutationUpdatePresetVideoModelForCategoryArgs = {
  updateVideoModelForCategoryInput: UpdateVideoModelForCategoryInput;
};


export type MutationUpdateProfilePictureArgs = {
  extension: Logo_Extension;
  name: Scalars['String']['input'];
};


export type MutationUpdateProfilePictureInternalArgs = {
  bucketName: Scalars['String']['input'];
  path: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationUpdateProjectArgs = {
  json?: InputMaybe<Scalars['JSON']['input']>;
  mediaFiles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pages: Array<InputMaybe<PageInput>>;
  projectId: Scalars['ID']['input'];
};


export type MutationUpdateProjectCollectionNameArgs = {
  collectionId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};


export type MutationUpdateProjectThumbnailDataArgs = {
  exportId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  thumbnailData: ThumbnailDataInput;
};


export type MutationUpdateProjectV2Args = {
  exportId: Scalars['String']['input'];
  json?: InputMaybe<Scalars['JSON']['input']>;
  mediaFiles: Array<InputMaybe<Scalars['String']['input']>>;
  pages: Array<InputMaybe<PageInput>>;
  projectId: Scalars['ID']['input'];
};


export type MutationUpdateRevealsCategoryArgs = {
  categoryId: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  iosVersion?: InputMaybe<IosVersionInput>;
  isHighlighted?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  presets?: InputMaybe<Array<RevealsCategoryPresetInput>>;
  targetApps?: InputMaybe<Array<AppName>>;
  weight?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUpdateShareableLinkThumbnailUrlArgs = {
  thumbnailUrl: Scalars['String']['input'];
  uid: Scalars['String']['input'];
};


export type MutationUpdateTaskArgs = {
  data: TaskUpdateInput;
  taskId: Scalars['ID']['input'];
};


export type MutationUpdateTaskThumbnailDataArgs = {
  taskId: Scalars['String']['input'];
  thumbnailData: ThumbnailDataInput;
};


export type MutationUpdateTeamBrandKitFontArgs = {
  fileId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  teamId: Scalars['ID']['input'];
};


export type MutationUpdateTeamBrandKitLogoArgs = {
  fileId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  teamId: Scalars['ID']['input'];
};


export type MutationUpdateTeamNameArgs = {
  name: Scalars['String']['input'];
  teamId: Scalars['ID']['input'];
};


export type MutationUpdateTeamProfilePictureInternalArgs = {
  bucketName: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  teamId: Scalars['String']['input'];
};


export type MutationUpdateTemplateArgs = {
  json: Scalars['JSON']['input'];
  pages: Array<InputMaybe<PageInput>>;
  templateId: Scalars['ID']['input'];
};


export type MutationUpdateTemplateThumbnailDataArgs = {
  templateId: Scalars['String']['input'];
  thumbnailData: ThumbnailDataInput;
};


export type MutationUpdateTrendySongTemplateArgs = {
  data: TrendySongTemplateUpdateInput;
  options?: InputMaybe<TrendySongTemplateUpdateOptions>;
  trendySongTemplateId: Scalars['ID']['input'];
};


export type MutationUpdateTrendySongTemplateCategoryArgs = {
  data: TrendySongTemplateCategoryUpdateInput;
  documentId: Scalars['ID']['input'];
};


export type MutationUpdateTrendySongTemplateCategoryByCategoryIdArgs = {
  androidTemplates?: InputMaybe<Array<CategoryTemplateInput>>;
  categoryId: Scalars['String']['input'];
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  iosTemplates?: InputMaybe<Array<CategoryTemplateInput>>;
  isDiscoverCategory?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  tiktokWeight?: InputMaybe<Scalars['Int']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUpdateVideoFilesArgs = {
  data: UpdateVideoFilesInput;
};


export type MutationValidateBrandKitFileArgs = {
  fileName: Scalars['String']['input'];
};

export type MutationResponse = {
  /** The status code of the mutation execution. */
  code: Scalars['String']['output'];
  /** The error/success message of the mutation execution. */
  message: Scalars['String']['output'];
  /** The success state of the mutation execution. */
  success: Scalars['Boolean']['output'];
};

export type MyAiGenerationsResponse = {
  __typename?: 'MyAiGenerationsResponse';
  data: Array<AiAnimatedElementsGeneration>;
  nextCursor?: Maybe<Scalars['String']['output']>;
};

export type MyFavoriteTemplatesFilters = {
  /** Filter by Favorite format. If not provided, all format will be returned. */
  formats?: InputMaybe<Array<InputMaybe<FavoriteTemplateFormat>>>;
};

export type MyGenerationsResponse = {
  __typename?: 'MyGenerationsResponse';
  generations: Array<AiAnimatedElementsGeneration>;
  nextCursor?: Maybe<Scalars['String']['output']>;
};

export type MyProjectCollectionsFilters = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type MyProjectFilters = {
  /** The cursor to retrieve the next page of projects. */
  cursor?: InputMaybe<Scalars['String']['input']>;
  /** The limit number of exports to retrieve per project. */
  exportsLimit?: InputMaybe<Scalars['Int']['input']>;
  /** The limit number of projects to retrieve. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** The start number of projects to retrieve. Offset is ignored if cursor is provided. */
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** A list of StorySnapshot */
  stories?: InputMaybe<Array<InputMaybe<StorySnapshotInput>>>;
};

export type MyProjectFiltersV2 = {
  /** The cursor to retrieve the next page of projects. */
  cursor?: InputMaybe<Scalars['String']['input']>;
  /** The limit number of projects to retrieve. */
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type MyTeamProjectFilters = {
  /** The cursor to retrieve the next page of projects. */
  cursor?: InputMaybe<Scalars['String']['input']>;
  /** The limit number of projects to retrieve. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** The start number of projects to retrieve. Offset is ignored if cursor is provided. */
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** Input for cursor-based pagination of team templates */
export type MyTeamTemplatesCursorFilters = {
  /** Cursor for pagination */
  cursor?: InputMaybe<Scalars['String']['input']>;
  /** Maximum number of templates to return */
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type MyTeamTemplatesFilters = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type NewUserInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  uid: Scalars['String']['input'];
};

export type NonDeletedProjectIdStatus = {
  __typename?: 'NonDeletedProjectIdStatus';
  projectId: Scalars['String']['output'];
  reason: Scalars['String']['output'];
};

export enum ObjectDescription {
  Long = 'LONG',
  Short = 'SHORT'
}

export type OriginalPictureInfo = {
  __typename?: 'OriginalPictureInfo';
  bucketName: Scalars['String']['output'];
  filePath: Scalars['String']['output'];
  pictureUrl: Scalars['String']['output'];
};

export type OutputVideo = {
  __typename?: 'OutputVideo';
  hasWatermark: Scalars['Boolean']['output'];
  url: Scalars['String']['output'];
};

export type Page = {
  __typename?: 'Page';
  /** The unique id of the page. */
  id: Scalars['ID']['output'];
  /** The JSON extract for this page. In string format. */
  json: Scalars['String']['output'];
  /** The JSON extract for this page. In JSON format. */
  jsonObject: Scalars['JSON']['output'];
};

export type PageInput = {
  /** The unique id of the page. */
  id: Scalars['ID']['input'];
  /** The JSON extract for this page. */
  json: Scalars['JSON']['input'];
};

export type Picture = {
  __typename?: 'Picture';
  _id: Scalars['ID']['output'];
  bucketName: Scalars['String']['output'];
  displayName?: Maybe<Scalars['String']['output']>;
  fileName: Scalars['String']['output'];
};

export type PictureSequenceSuggestionFromAudioResponse = {
  __typename?: 'PictureSequenceSuggestionFromAudioResponse';
  duration: Scalars['Float']['output'];
  sentences: Array<SentencesWithImagePrompt>;
};

export type PlanPrice = {
  __typename?: 'PlanPrice';
  currency: Currency;
  periodicity: PricePeriodicity;
  price: Scalars['Int']['output'];
};

export enum Platform {
  Android = 'ANDROID',
  Ios = 'IOS',
  Web = 'WEB'
}

export type PortalSessionInput = {
  isTeam: Scalars['Boolean']['input'];
};

export type PresetAudioPromptResponse = {
  __typename?: 'PresetAudioPromptResponse';
  prompt: Scalars['String']['output'];
};

export type PresetConfig = {
  aspectRatio?: InputMaybe<AiRevealAspectRatio>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  coordinates?: InputMaybe<CoordinatesInput>;
  customFirstFramePrompt?: InputMaybe<Scalars['String']['input']>;
  customLastFramePrompt?: InputMaybe<Scalars['String']['input']>;
  customPrompt?: InputMaybe<Scalars['String']['input']>;
  customVideoPrompt?: InputMaybe<Scalars['String']['input']>;
  imagePosition?: InputMaybe<AiRevealImagePosition>;
  margin?: InputMaybe<Scalars['Float']['input']>;
  modelName?: InputMaybe<Scalars['String']['input']>;
  presetFlow?: InputMaybe<PresetFlow>;
  presetId: Scalars['String']['input'];
  rotation?: InputMaybe<Scalars['Float']['input']>;
  scale?: InputMaybe<Scalars['Float']['input']>;
  seeds?: InputMaybe<Array<Scalars['Int']['input']>>;
  videoDuration?: InputMaybe<Scalars['Int']['input']>;
};

export enum PresetFlow {
  ImageAndTextToVideo = 'imageAndTextToVideo',
  ImageListToVideo = 'imageListToVideo',
  ImageStyleTransferToVideo = 'imageStyleTransferToVideo',
  ImageToVideo = 'imageToVideo',
  ImageToVideoImmediate = 'imageToVideoImmediate',
  Multipass = 'multipass',
  PromptToVideo = 'promptToVideo',
  PromptToVideoFromImage = 'promptToVideoFromImage',
  TextToVideo = 'textToVideo'
}

export enum PresetPreviewToUse {
  BeforeAfter = 'beforeAfter',
  Preview = 'preview'
}

export type PresetPreviewVideo = {
  __typename?: 'PresetPreviewVideo';
  thumbnailData?: Maybe<ThumbnailData>;
  url: Scalars['String']['output'];
};

export type PresetSuggestionsResponse = {
  __typename?: 'PresetSuggestionsResponse';
  long: Scalars['String']['output'];
  object: Scalars['String']['output'];
  short: Scalars['String']['output'];
  suggestions: Array<AiAnimatedElementPreset>;
};

export enum PricePeriodicity {
  Month = 'MONTH',
  Year = 'YEAR'
}

export type ProjectCollection = {
  __typename?: 'ProjectCollection';
  favorite: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  projects: Array<ProjectCollectionProject>;
  thumbnailUrls: Array<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
};

export type ProjectCollectionMigrationInput = {
  collectionName: Scalars['String']['input'];
  favorite: Scalars['Boolean']['input'];
  projectIds: Array<Scalars['String']['input']>;
};

export type ProjectCollectionProject = {
  __typename?: 'ProjectCollectionProject';
  addedToCollectionAt: Scalars['Date']['output'];
  format: VideoFormatOutput;
  pages: Array<Page>;
  platform?: Maybe<Platform>;
  projectId: Scalars['String']['output'];
  thumbnailUrl: Scalars['String']['output'];
  videoInfo: VideoInfo;
};

export type ProjectSyncData = {
  exportId?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['String']['input'];
};

export type ProjectSyncOperationData = {
  __typename?: 'ProjectSyncOperationData';
  exportId?: Maybe<Scalars['String']['output']>;
  projectId: Scalars['String']['output'];
};

export type ProjectSyncOperationsInput = {
  deviceId?: InputMaybe<Scalars['String']['input']>;
  inputs: Array<InputMaybe<ProjectSyncData>>;
  runAs?: InputMaybe<Scalars['String']['input']>;
};

export type ProjectSyncOperationsResponse = {
  __typename?: 'ProjectSyncOperationsResponse';
  delete: Array<Maybe<ProjectSyncOperationData>>;
  get: Array<Maybe<ProjectSyncOperationData>>;
  post: Array<Maybe<ProjectSyncOperationData>>;
};

export type PromptPreset = {
  __typename?: 'PromptPreset';
  long: Scalars['String']['output'];
  short: Scalars['String']['output'];
};

export type PromptPresetResponse = {
  __typename?: 'PromptPresetResponse';
  long: Scalars['String']['output'];
  object: Scalars['String']['output'];
  presets: Array<Maybe<PromptPreset>>;
  short: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  /** Get the current version of the mojo api. */
  api?: Maybe<MojoApi>;
  /** Calculate the total credit cost for a list of presets */
  calculatePresetsCreditCost: Scalars['Int']['output'];
  /** Return the filtered list of projectIds colliding for this user. */
  checkProjectsCollision: Array<Scalars['ID']['output']>;
  checkTemplates?: Maybe<CheckTrendySoundTemplatesResult>;
  /** Check the health of the AI subscription of a user */
  checkUserAiSubHealth: UserAiSubHealthReport;
  /** Convert speech from audio to text with timings */
  convertSpeechFromAudioToTextWithTimings: ConvertSpeechFromAudioToTextResponse;
  /** Asynchronously convert speech from audio to text with timings - Returns a taskId */
  convertSpeechFromAudioToTextWithTimingsAsync: Task;
  /** Detects the language of a text */
  detectTextLanguage: A2ELanguage;
  /** Get a list of all featured videos. */
  explore: Array<CuratedVideo>;
  generateAiAnimatedPictureInputFromBase64: RemoveBackgroundFromBase64Result;
  generateAiAnimatedPictureInputFromPictureUrl: RemoveBackgroundFromPictureResult;
  /** Generate an audio from a text - Speed must be from 0.7 to 1.2, default is 1.0 */
  generateAudioFromText: AudioFromTextResponse;
  /**
   * Generate an avatar from a text - speed must be from 1 to 1.5, default is 1.0
   * - anchorId: is the id of the avatar to use, from getA2eAnchorList
   * - ttsId: is the id of the voice to use, from getA2eVoiceList
   */
  generateAvatarFromText: AvatarFromTextResponse;
  generateCustomAuthToken: Scalars['String']['output'];
  /** Get effects for a list of sentences */
  generateEnrichedElementsForSentences: EnrichedElementsForSentences;
  generateImageFromPrompt: BrollBucketInfo;
  /** Generate images or videos with a given model and JSON stringified inputs corresponding to it */
  generateMediaWithModelId: Array<Maybe<Scalars['String']['output']>>;
  /** Asynchronously generate images or videos with a given model and JSON stringified inputs corresponding to it - Returns a taskId */
  generateMediaWithModelIdAsync: Task;
  /** Create a video script from an idea */
  generateVideoScriptFromIdea: VideoScriptFromIdeaResponse;
  getA2eAnchorList: Array<A2EAnchor>;
  /** Gets a list of available voices */
  getA2eVoiceList: Array<A2EVoice>;
  getAccountInfo: AccountInfo;
  /** Get a list of all AI animated input media templates */
  getAiAnimatedElementInputMediaTemplates: Array<AiAnimatedElementInputMediaTemplate>;
  getAiAnimatedElementPreset: AiAnimatedElementPreset;
  getAiAnimatedElementPresetByIds: Array<AiAnimatedElementPreset>;
  /** Get a list of AI Animated Element presets */
  getAiAnimatedElementPresets: AiAnimatedElementPresetsResponse;
  getAiAnimatedElementsGeneration: AiAnimatedElementsGeneration;
  getAiCheckoutSession: CheckoutSession;
  getAiRevealsPlanPrices: Array<Maybe<AiRevealSubscription>>;
  /** Get the number of AI tokens the user has - getProfile has to be called at least once before this */
  getAiTokens: Scalars['Int']['output'];
  getAiTokensAttributionNumbers: AiTokensAttributionNumbers;
  getAiTokensNumbersForProductId: Scalars['Int']['output'];
  getAiTokensPlans: Array<Maybe<AiTokensPlan>>;
  /** Get a list of all animated emojis with their url */
  getAllAnimatedEmojis: Array<AnimatedEmoji>;
  getAllTeams: Array<Team>;
  /** Get a list of animated emojis by categories. */
  getAnimatedEmojisByCategories: Array<AnimatedEmojyByCategory>;
  getAutoEditsData: AutoEditsResponse;
  getAvailableTemplateTagsList: TemplateTagsList;
  /** Get the status of an avatar video task */
  getAvatarVideoTaskStatus: AvatarVideoTaskResponse;
  /** Get a list of background suggestions from a pictureUrl */
  getBackgroundSuggestionsFromPictureUrl: Array<Maybe<Scalars['String']['output']>>;
  /** Get a caption from a pictureUrl */
  getCaptionFromPictureUrl?: Maybe<Scalars['String']['output']>;
  getCheckoutSession: CheckoutSession;
  getCheckoutSessionSuccessInfo: CheckoutSessionSuccessInfo;
  /** Get a single project collection based on its id. */
  getCollection: ProjectCollection;
  /** Get all curated videos. */
  getCuratedVideos: Array<CuratedVideo>;
  getEmojisForSentences: EmojisForSentencesResponse;
  /**
   * Get effects for a list of sentences - deprecated
   * @deprecated this query is deprecated, use generateEnrichedElementsForSentences instead
   */
  getEnrichedElementsForSentences: EnrichedElementsForSentencesResponse;
  /** Get a single file based on its id. */
  getFile?: Maybe<File>;
  /** Get multiple files based on thems ids. */
  getFiles: Array<Maybe<File>>;
  getGenerations: Array<AiAnimatedElementsGeneration>;
  getGenerationsAnonymous: Array<AiAnimatedElementsGeneration>;
  getGenerationsByDetectedObjects: GenerationsByDetectedObjectsResponse;
  getGenerationsByDetectedObjectsAnonymous: GenerationsByDetectedObjectsResponse;
  getImageTransferModels: Array<ImageStyleTransferModel>;
  /** Get a list of memes output from a pictureUrl */
  getMemesFromPictureUrl: Array<Maybe<Scalars['String']['output']>>;
  getMojoProAiCheckoutSession: CheckoutSession;
  getMojoProAiPlanPrices: Array<Maybe<AiRevealSubscription>>;
  getOneOffCheckoutSession: CheckoutSession;
  getPictureSequenceSuggestionFromAudio: PictureSequenceSuggestionFromAudioResponse;
  /** Generates an audio prompt for a preset */
  getPresetGenerateAudioPrompt: PresetAudioPromptResponse;
  getPresetSuggestionsFromImage: PresetSuggestionsResponse;
  getPresetSuggestionsFromText: TextPresetSuggestionsResponse;
  getProPlanPrices: Array<Maybe<PlanPrice>>;
  /** Get profile information about the currently logged-in user. */
  getProfile?: Maybe<User>;
  getProfileByToken?: Maybe<GetProfileByTokenResponse>;
  getProjectSyncOperations: ProjectSyncOperationsResponse;
  /** Get a list of projects of the authenticated user and authenticated user teams. */
  getProjects: Array<VideoProject>;
  getPromptPresetsFromImage: PromptPresetResponse;
  getProviderUsedForSpeechToText: SpeechToTextApiProviderData;
  getRecentlyUsedFilesForAI: Array<RecentlyUsedAiFile>;
  /** get remote templates */
  getRemoteTemplates: Array<RemoteTemplate>;
  /** Get only the most recent versions of a Replicate model */
  getReplicateModelVersions: Array<Maybe<Scalars['String']['output']>>;
  getRevealsCategoriesWithPresets: RevealsCategoriesWithPresetsResponse;
  getRevealsCategoryWithPresets: RevealsCategoryWithPresets;
  getRevenueCatWebhookStatus: RevenueCatWebhookStatusResponse;
  /** Get shareableLink informations with uid. */
  getShareableLink?: Maybe<ShareableLink>;
  getSongsByMoods?: Maybe<SongSearchResult>;
  getStripePortalSession: Scalars['String']['output'];
  /** Get a list of supported locales for Speech-To-Text API usage */
  getSupportedLocalesForSpeechToText: Array<Maybe<Scalars['String']['output']>>;
  getTask?: Maybe<Task>;
  getTaskFromMetadataProperty?: Maybe<Task>;
  getTeam: Team;
  getTeamBrandKit?: Maybe<TeamBrandKit>;
  getTeamPayingInvoices: Array<TeamInvoice>;
  getTeamPlanPrices: Array<Maybe<PlanPrice>>;
  /** Get information about which bucket and path the team profile picture of the user should be uploaded to */
  getTeamProfilePictureUploadInfo: TeamProfilePictureUploadInfo;
  getTeamTemplate?: Maybe<TeamVideoTemplateLight>;
  /** Get a list of projects of the authenticated user teams. */
  getTeamsProjects: Array<VideoProject>;
  getTemplate?: Maybe<Template>;
  getTemplateSchemaLookupTable?: Maybe<TemplateSchemaLookupTable>;
  getTiktokWrapped: TikTokWrappedResponse;
  getTranslations: Array<LocaleTranslationResult>;
  /** Get a trendy song template by its database ID */
  getTrendySongTemplateById?: Maybe<TrendySongTemplate>;
  /** Get a trendy song template by its trendySongTemplateId+platform */
  getTrendySongTemplateByTemplateId?: Maybe<TrendySongTemplate>;
  getUnfinishedGenerations: Array<AiAnimatedElementsGeneration>;
  /** Get user by uid */
  getUser?: Maybe<User>;
  /** Get information about which bucket and path the profile picture of the user should be uploaded to */
  getUserProfilePictureUploadInfo: UserProfilePictureUploadInfo;
  getUserWithEmail?: Maybe<User>;
  /** Get a list of all registered users. */
  getUsers?: Maybe<Array<Maybe<User>>>;
  getUsersByUids: Array<User>;
  /** Get a single export based on its id. */
  getVideoExport?: Maybe<VideoExport>;
  getVideoExportsByTemplateId: Array<VideoExport>;
  getVideoGenerationModels: Array<VideoGenerationModelInfo>;
  /** Get a single project based on its id. */
  getVideoProject?: Maybe<VideoProject>;
  /** Check if user has tokens that were granted from trial */
  hasTrialTokens: Scalars['Boolean']['output'];
  /** Dummy Query used to check if server is up or not. */
  healthCheck?: Maybe<HealthCheckResponse>;
  licenseSongs?: Maybe<Scalars['Boolean']['output']>;
  /** Get a list of trendy song categories */
  listTrendySongTemplateCategories: Array<TrendySongTemplateCategoryDocument>;
  /** Get all trendy song template categories with their templates for admin panel (no caching, no version filtering) */
  listTrendySongTemplateCategoriesForAdmin: Array<TrendySongTemplateCategoryForAdmin>;
  /** Get a list of trendy song categories with associated templates */
  listTrendySongTemplateCategoriesWithTemplates: Array<TrendySongTemplateCategoryWithTemplates>;
  /** Get a list of trendy song templates */
  listTrendySongTemplates: Array<TrendySongTemplate>;
  /** Get a list of trendy song templates with cursor-based pagination, sorted by updatedAt descending */
  listTrendySongTemplatesWithCursor: TrendySongTemplatesWithCursorResponse;
  mojoKit: MojoKitQueries;
  /** Get a list of AI animated element generations of a user */
  myAiGenerations: MyAiGenerationsResponse;
  myAiGenerationsAnonymous: MyAiGenerationsResponse;
  /** Get a list of favorite templates for the logged-in user. */
  myFavoriteTemplates: Array<Maybe<FavoriteTemplate>>;
  /**
   * Get a list of AI animated element generations of a user
   * @deprecated myGenerations is deprecated. Use 'myAiGenerations' instead.
   */
  myGenerations: MyGenerationsResponse;
  /** Get a list of personal projects of the authenticated user. */
  myPersonalProjects: Array<VideoProject>;
  /** Get the total of personal projects of the authenticated user. */
  myPersonalProjectsLength?: Maybe<Scalars['Int']['output']>;
  /**
   * Get a list of personal projects of the authenticated user.
   * @deprecated myPersonalProjectsLight is deprecated. Use 'myPersonalProjectsLightV2' instead.
   */
  myPersonalProjectsLight: Array<VideoProjectLight>;
  /** Get a list of personal projects of the authenticated user. */
  myPersonalProjectsLightV2: VideoProjectLightResponse;
  /** Get a list of all project collections for the current user. */
  myProjectCollections: Array<ProjectCollection>;
  /** Get a list of projects of the authenticated user. */
  myProjects: Array<VideoProject>;
  /** @deprecated myTeamProjects is deprecated. Use 'myTeamProjectsLight' instead. */
  myTeamProjects: Array<TeamVideoProjectLight>;
  /** My number of team projects */
  myTeamProjectsLength?: Maybe<Scalars['Int']['output']>;
  myTeamProjectsLight: TeamVideoProjectLightResponse;
  /** Get all team templates of the authenticated user. */
  myTeamTemplates: Array<TeamVideoTemplateLight>;
  /** Get team templates with cursor-based pagination. */
  myTeamTemplatesWithCursor: TeamVideoTemplatesResponse;
  playgroundGenerateMultiframesPrompts: MultiframesPromptsResult;
  playgroundImageCreate: AiFileInfo;
  playgroundImagePromptRefine: Scalars['String']['output'];
  playgroundImageReplaceBackground: AiFileInfo;
  playgroundImageTransfer: AiFileInfo;
  playgroundVideoPromptRefine: Scalars['String']['output'];
  projectBuckets: BucketsInfo;
  refinePromptWithImage: StyleTransferPromptFromImageResponse;
  removeBackgroundFromPictureUrl: RemoveBackgroundFromPictureResult;
  requestInfo: RequestInfo;
  /** Search trendy song templates by templateId (partial match, case-insensitive) */
  searchTrendySongTemplates: Array<TrendySongTemplate>;
};


export type QueryCalculatePresetsCreditCostArgs = {
  presets: Array<PresetConfig>;
};


export type QueryCheckProjectsCollisionArgs = {
  projectIds: Array<Scalars['ID']['input']>;
};


export type QueryCheckUserAiSubHealthArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryConvertSpeechFromAudioToTextWithTimingsArgs = {
  input: SpeechAudioInput;
  timeoutMs?: InputMaybe<Scalars['Int']['input']>;
  withProvider?: InputMaybe<SpeechToTextProvider>;
};


export type QueryConvertSpeechFromAudioToTextWithTimingsAsyncArgs = {
  input: SpeechAudioInput;
  withProvider?: InputMaybe<SpeechToTextProvider>;
};


export type QueryDetectTextLanguageArgs = {
  text: Scalars['String']['input'];
};


export type QueryExploreArgs = {
  filters?: InputMaybe<ExploreFilters>;
};


export type QueryGenerateAiAnimatedPictureInputFromBase64Args = {
  base64Data: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
};


export type QueryGenerateAiAnimatedPictureInputFromPictureUrlArgs = {
  originalFilePathOnBucket?: InputMaybe<Scalars['String']['input']>;
  pictureUrl: Scalars['String']['input'];
};


export type QueryGenerateAudioFromTextArgs = {
  speaker?: InputMaybe<VoiceSpeaker>;
  speed?: InputMaybe<Scalars['Float']['input']>;
  text: Scalars['String']['input'];
};


export type QueryGenerateAvatarFromTextArgs = {
  anchorId: Scalars['String']['input'];
  speed?: InputMaybe<Scalars['Float']['input']>;
  text: Scalars['String']['input'];
  ttsId: Scalars['String']['input'];
};


export type QueryGenerateEnrichedElementsForSentencesArgs = {
  sentences: Array<InputMaybe<Scalars['String']['input']>>;
  targetLanguage: Scalars['String']['input'];
};


export type QueryGenerateImageFromPromptArgs = {
  aspectRatio: AiRevealAspectRatio;
  prompt: Scalars['String']['input'];
};


export type QueryGenerateMediaWithModelIdArgs = {
  input: ModelInput;
  timeoutMs?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGenerateMediaWithModelIdAsyncArgs = {
  input: ModelInput;
};


export type QueryGenerateVideoScriptFromIdeaArgs = {
  languageCode?: InputMaybe<Scalars['String']['input']>;
  prompt: Scalars['String']['input'];
  wordCount?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetA2eVoiceListArgs = {
  language?: InputMaybe<A2ELanguage>;
};


export type QueryGetAiAnimatedElementPresetArgs = {
  presetId: Scalars['ID']['input'];
};


export type QueryGetAiAnimatedElementPresetByIdsArgs = {
  presetIds: Array<Scalars['ID']['input']>;
};


export type QueryGetAiAnimatedElementPresetsArgs = {
  filters?: InputMaybe<AiAnimatedElementPresetsFilters>;
};


export type QueryGetAiAnimatedElementsGenerationArgs = {
  generationId: Scalars['ID']['input'];
};


export type QueryGetAiCheckoutSessionArgs = {
  aiCheckoutSessionInput: AiCheckoutSessionInput;
};


export type QueryGetAiTokensNumbersForProductIdArgs = {
  productId: Scalars['String']['input'];
};


export type QueryGetAutoEditsDataArgs = {
  input: SpeechAudioInput;
  timeoutMs?: InputMaybe<Scalars['Int']['input']>;
  withSpeechToTextProvider?: InputMaybe<SpeechToTextProvider>;
  withStockVideoProvider?: InputMaybe<StockVideoProvider>;
};


export type QueryGetAvatarVideoTaskStatusArgs = {
  taskIds: Array<Scalars['String']['input']>;
};


export type QueryGetBackgroundSuggestionsFromPictureUrlArgs = {
  blip2TimeoutMs?: InputMaybe<Scalars['Int']['input']>;
  pictureUrl: Scalars['String']['input'];
};


export type QueryGetCaptionFromPictureUrlArgs = {
  blip2TimeoutMs?: InputMaybe<Scalars['Int']['input']>;
  pictureUrl: Scalars['String']['input'];
};


export type QueryGetCheckoutSessionArgs = {
  checkoutSessionInput: CheckoutSessionInput;
};


export type QueryGetCheckoutSessionSuccessInfoArgs = {
  checkoutSessionId: Scalars['String']['input'];
};


export type QueryGetCollectionArgs = {
  collectionId: Scalars['ID']['input'];
};


export type QueryGetCuratedVideosArgs = {
  filters?: InputMaybe<GetCuratedVideosFilters>;
};


export type QueryGetEmojisForSentencesArgs = {
  sentences: Array<InputMaybe<Scalars['String']['input']>>;
};


export type QueryGetEnrichedElementsForSentencesArgs = {
  sentences: Array<InputMaybe<Scalars['String']['input']>>;
  targetLanguage: Scalars['String']['input'];
};


export type QueryGetFileArgs = {
  fileId: Scalars['ID']['input'];
};


export type QueryGetFilesArgs = {
  fileIds: Array<Scalars['ID']['input']>;
};


export type QueryGetGenerationsArgs = {
  generationsIds: Array<Scalars['String']['input']>;
};


export type QueryGetGenerationsAnonymousArgs = {
  generationsIds: Array<Scalars['String']['input']>;
};


export type QueryGetGenerationsByDetectedObjectsArgs = {
  objectDescriptionToUse?: InputMaybe<ObjectDescription>;
};


export type QueryGetGenerationsByDetectedObjectsAnonymousArgs = {
  objectDescriptionToUse?: InputMaybe<ObjectDescription>;
};


export type QueryGetMemesFromPictureUrlArgs = {
  blip2TimeoutMs?: InputMaybe<Scalars['Int']['input']>;
  pictureUrl: Scalars['String']['input'];
  userLocale?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetMojoProAiCheckoutSessionArgs = {
  aiCheckoutSessionInput: AiCheckoutSessionInput;
};


export type QueryGetOneOffCheckoutSessionArgs = {
  productId: Scalars['String']['input'];
};


export type QueryGetPictureSequenceSuggestionFromAudioArgs = {
  audioUrl: Scalars['String']['input'];
};


export type QueryGetPresetGenerateAudioPromptArgs = {
  prompt: Scalars['String']['input'];
};


export type QueryGetPresetSuggestionsFromImageArgs = {
  imageUrl: Scalars['String']['input'];
};


export type QueryGetPresetSuggestionsFromTextArgs = {
  text: Scalars['String']['input'];
};


export type QueryGetProfileByTokenArgs = {
  token: Scalars['String']['input'];
};


export type QueryGetProjectSyncOperationsArgs = {
  data: ProjectSyncOperationsInput;
};


export type QueryGetProjectsArgs = {
  filters?: InputMaybe<MyProjectFilters>;
};


export type QueryGetPromptPresetsFromImageArgs = {
  imageUrl: Scalars['String']['input'];
};


export type QueryGetRecentlyUsedFilesForAiArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetRemoteTemplatesArgs = {
  platform?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetReplicateModelVersionsArgs = {
  modelName: Scalars['String']['input'];
  modelOwner: Scalars['String']['input'];
};


export type QueryGetRevealsCategoriesWithPresetsArgs = {
  filters?: InputMaybe<GetRevealsCategoriesWithPresetsFilters>;
};


export type QueryGetRevealsCategoryWithPresetsArgs = {
  categoryId: Scalars['String']['input'];
};


export type QueryGetShareableLinkArgs = {
  uid: Scalars['String']['input'];
};


export type QueryGetSongsByMoodsArgs = {
  moods: Array<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetStripePortalSessionArgs = {
  portalSessionInput: PortalSessionInput;
};


export type QueryGetTaskArgs = {
  taskId: Scalars['ID']['input'];
};


export type QueryGetTaskFromMetadataPropertyArgs = {
  propertyName?: InputMaybe<Scalars['String']['input']>;
  propertyValue?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetTeamArgs = {
  teamId: Scalars['ID']['input'];
};


export type QueryGetTeamBrandKitArgs = {
  lastUpdate?: InputMaybe<Scalars['Date']['input']>;
  teamId: Scalars['ID']['input'];
};


export type QueryGetTeamPayingInvoicesArgs = {
  teamId: Scalars['String']['input'];
};


export type QueryGetTeamProfilePictureUploadInfoArgs = {
  teamId: Scalars['ID']['input'];
};


export type QueryGetTeamTemplateArgs = {
  templateId: Scalars['ID']['input'];
};


export type QueryGetTeamsProjectsArgs = {
  filters?: InputMaybe<MyProjectFilters>;
  teamId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetTemplateArgs = {
  templateId: Scalars['ID']['input'];
};


export type QueryGetTiktokWrappedArgs = {
  input: TikTokWrappedInput;
};


export type QueryGetTranslationsArgs = {
  locales: Array<Scalars['String']['input']>;
  words: Array<Scalars['String']['input']>;
};


export type QueryGetTrendySongTemplateByIdArgs = {
  id: Scalars['ID']['input'];
  ignoreTemplateWatermark?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetTrendySongTemplateByTemplateIdArgs = {
  ignoreTemplateWatermark?: InputMaybe<Scalars['Boolean']['input']>;
  platform: Platform;
  templateId: Scalars['String']['input'];
};


export type QueryGetUserArgs = {
  userId: Scalars['String']['input'];
};


export type QueryGetUserWithEmailArgs = {
  email: Scalars['String']['input'];
};


export type QueryGetUsersArgs = {
  filters?: InputMaybe<GetUsersFilters>;
};


export type QueryGetUsersByUidsArgs = {
  userIds: Array<InputMaybe<Scalars['String']['input']>>;
};


export type QueryGetVideoExportArgs = {
  exportId: Scalars['String']['input'];
};


export type QueryGetVideoExportsByTemplateIdArgs = {
  filters?: InputMaybe<VideoExportsByTemplateIdFilters>;
  templateId: Scalars['String']['input'];
};


export type QueryGetVideoProjectArgs = {
  projectId: Scalars['ID']['input'];
};


export type QueryHasTrialTokensArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryLicenseSongsArgs = {
  shutterstockIds: Array<Scalars['String']['input']>;
};


export type QueryListTrendySongTemplateCategoriesWithTemplatesArgs = {
  filters?: InputMaybe<TrendySongTemplateCategoryWithTemplateFilters>;
};


export type QueryListTrendySongTemplatesArgs = {
  filters?: InputMaybe<TrendySongTemplateFilters>;
};


export type QueryListTrendySongTemplatesWithCursorArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<TrendySongTemplateFilters>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMyAiGenerationsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMyAiGenerationsAnonymousArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMyFavoriteTemplatesArgs = {
  filters?: InputMaybe<MyFavoriteTemplatesFilters>;
};


export type QueryMyGenerationsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMyPersonalProjectsArgs = {
  filters?: InputMaybe<MyProjectFilters>;
};


export type QueryMyPersonalProjectsLightArgs = {
  filters?: InputMaybe<MyProjectFilters>;
};


export type QueryMyPersonalProjectsLightV2Args = {
  filters?: InputMaybe<MyProjectFiltersV2>;
};


export type QueryMyProjectCollectionsArgs = {
  filters?: InputMaybe<MyProjectCollectionsFilters>;
};


export type QueryMyProjectsArgs = {
  filters?: InputMaybe<MyProjectFilters>;
};


export type QueryMyTeamProjectsArgs = {
  filters?: InputMaybe<MyTeamProjectFilters>;
  teamId: Scalars['String']['input'];
};


export type QueryMyTeamProjectsLengthArgs = {
  teamId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMyTeamProjectsLightArgs = {
  filters?: InputMaybe<MyProjectFiltersV2>;
  teamId: Scalars['String']['input'];
};


export type QueryMyTeamTemplatesArgs = {
  filters?: InputMaybe<MyTeamTemplatesFilters>;
  teamId: Scalars['String']['input'];
};


export type QueryMyTeamTemplatesWithCursorArgs = {
  filters?: InputMaybe<MyTeamTemplatesCursorFilters>;
  teamId: Scalars['String']['input'];
};


export type QueryPlaygroundGenerateMultiframesPromptsArgs = {
  description: Scalars['String']['input'];
  image?: InputMaybe<Scalars['String']['input']>;
  isLoop: Scalars['Boolean']['input'];
  numberOfFrames: Scalars['Int']['input'];
};


export type QueryPlaygroundImageCreateArgs = {
  prompt: Scalars['String']['input'];
};


export type QueryPlaygroundImagePromptRefineArgs = {
  image?: InputMaybe<Scalars['String']['input']>;
  instruction: Scalars['String']['input'];
  presetFlow: PresetFlow;
  prompt?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPlaygroundImageReplaceBackgroundArgs = {
  prompt: Scalars['String']['input'];
  url: Scalars['String']['input'];
};


export type QueryPlaygroundImageTransferArgs = {
  additionalUrls?: InputMaybe<Array<Scalars['String']['input']>>;
  contextImageUrls?: InputMaybe<Array<Scalars['String']['input']>>;
  imageTransferModel?: InputMaybe<ImageStyleTransferModel>;
  prompt: Scalars['String']['input'];
  url: Scalars['String']['input'];
  withGreenScreen?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPlaygroundVideoPromptRefineArgs = {
  image?: InputMaybe<Scalars['String']['input']>;
  imagePrompt: Scalars['String']['input'];
  instruction: Scalars['String']['input'];
  presetFlow: PresetFlow;
  prompt?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRefinePromptWithImageArgs = {
  imageUrl: Scalars['String']['input'];
  prompt: Scalars['String']['input'];
};


export type QueryRemoveBackgroundFromPictureUrlArgs = {
  options?: InputMaybe<RemoveBackgroundOptions>;
  pictureUrl: Scalars['String']['input'];
};


export type QuerySearchTrendySongTemplatesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Platform>;
  query: Scalars['String']['input'];
};

export type RecentlyUsedAiFile = {
  __typename?: 'RecentlyUsedAiFile';
  aiRemovedBackground: AiFileInfo;
  fileId: Scalars['ID']['output'];
  originalFile?: Maybe<AiFileInfo>;
};

export type RecoverUserLostProjectsResponse = {
  __typename?: 'RecoverUserLostProjectsResponse';
  projectsMoved: Scalars['Int']['output'];
};

/** Template shared with a team. */
export type RemoteTemplate = {
  __typename?: 'RemoteTemplate';
  category?: Maybe<Scalars['String']['output']>;
  /** The creation date of the template in the database. */
  createdAt: Scalars['Date']['output'];
  /** To display or not the 'New' badge */
  displayNewBadge?: Maybe<Scalars['Boolean']['output']>;
  /** The unique id of the template. */
  id: Scalars['ID']['output'];
  /** To display or not the Mojo pro badge */
  isFree?: Maybe<Scalars['Boolean']['output']>;
  json?: Maybe<Scalars['JSON']['output']>;
  /** Used for Tracking (Could be used also for user) */
  name?: Maybe<Scalars['String']['output']>;
  nativeTemplateName?: Maybe<Scalars['String']['output']>;
  templateFormat?: Maybe<Scalars['String']['output']>;
  templateType?: Maybe<Scalars['String']['output']>;
  /** The last time the template was updated in the database. */
  updatedAt: Scalars['Date']['output'];
  videoURL?: Maybe<Scalars['String']['output']>;
};

export type RemoveBackgroundFromBase64Result = {
  __typename?: 'RemoveBackgroundFromBase64Result';
  /** If determined, best background color to use from the image, hexadecimal format */
  backgroundColorToUse?: Maybe<Scalars['String']['output']>;
  bucketName: Scalars['String']['output'];
  filePath: Scalars['String']['output'];
  originalPictureInfo: OriginalPictureInfo;
  removedBackgroundPictureUrl: Scalars['String']['output'];
};

export type RemoveBackgroundFromPictureResult = {
  __typename?: 'RemoveBackgroundFromPictureResult';
  /** If determined, best background color to use from the image, hexadecimal format */
  backgroundColorToUse?: Maybe<Scalars['String']['output']>;
  bucketName: Scalars['String']['output'];
  filePath: Scalars['String']['output'];
  removedBackgroundPictureUrl: Scalars['String']['output'];
};

export type RemoveBackgroundOptions = {
  crop?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RemoveProfilePictureMutationResponse = MutationResponse & {
  __typename?: 'RemoveProfilePictureMutationResponse';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type RemoveProjectMutationResponse = {
  __typename?: 'RemoveProjectMutationResponse';
  deletedProjectId: Scalars['String']['output'];
};

export type RemoveProjectsMutationResponse = {
  __typename?: 'RemoveProjectsMutationResponse';
  deletedProjectIds: Array<Maybe<Scalars['String']['output']>>;
  nonDeletedProjectIds?: Maybe<Array<Maybe<NonDeletedProjectIdStatus>>>;
};

export type ReplicateModel = {
  __typename?: 'ReplicateModel';
  jsonPrompt: Scalars['String']['output'];
  jsonPromptObject: Scalars['JSON']['output'];
  modelInfo: ReplicateModelInfo;
};

export type ReplicateModelDataInput = {
  /** Must be a valid JSON encoded format */
  jsonPrompt: Scalars['String']['input'];
  modelInfo: ReplicateModelInfoInput;
};

export type ReplicateModelDataUpdateInput = {
  /** Must be a valid JSON encoded format */
  jsonPrompt?: InputMaybe<Scalars['String']['input']>;
  modelInfo?: InputMaybe<ReplicateModelInfoInput>;
};

export type ReplicateModelInfo = {
  __typename?: 'ReplicateModelInfo';
  modelName: Scalars['String']['output'];
  modelVersion: Scalars['String']['output'];
  ownerName: Scalars['String']['output'];
};

export type ReplicateModelInfoInput = {
  modelName: Scalars['String']['input'];
  modelVersion: Scalars['String']['input'];
  ownerName: Scalars['String']['input'];
};

export type RequestInfo = {
  __typename?: 'RequestInfo';
  requestId: Scalars['String']['output'];
};

export type RevealsCategoriesWithPresetsResponse = {
  __typename?: 'RevealsCategoriesWithPresetsResponse';
  categories: Array<RevealsCategoryWithPresets>;
  nextCursor?: Maybe<Scalars['String']['output']>;
};

export type RevealsCategory = {
  __typename?: 'RevealsCategory';
  categoryId: Scalars['String']['output'];
  hidden: Scalars['Boolean']['output'];
  presets: Array<RevealsCategoryPreset>;
  targetApps: Array<AppName>;
  weight: Scalars['Int']['output'];
};

export type RevealsCategoryPreset = {
  __typename?: 'RevealsCategoryPreset';
  hidden: Scalars['Boolean']['output'];
  presetId: Scalars['String']['output'];
  previewToUse: PresetPreviewToUse;
  weight: Scalars['Int']['output'];
};

export type RevealsCategoryPresetInput = {
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  presetId: Scalars['String']['input'];
  previewToUse: PresetPreviewToUse;
  weight?: InputMaybe<Scalars['Int']['input']>;
};

export type RevealsCategoryWithPresets = {
  __typename?: 'RevealsCategoryWithPresets';
  categoryId: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  hidden: Scalars['Boolean']['output'];
  /** iOS versions for which this preset is available */
  iosVersion?: Maybe<IosVersion>;
  /** Whether this category is should be placed at the top of the list of categories */
  isHighlighted?: Maybe<Scalars['Boolean']['output']>;
  label: Scalars['String']['output'];
  presets: Array<AiAnimatedElementPreset>;
  targetApps?: Maybe<Array<AppName>>;
  weight: Scalars['Int']['output'];
};

export enum RevealsModelName {
  AnimatedControlnet = 'ANIMATED_CONTROLNET',
  Runway = 'RUNWAY'
}

export type RevenueCatWebhookStatusResponse = {
  __typename?: 'RevenueCatWebhookStatusResponse';
  calledAt?: Maybe<Scalars['Date']['output']>;
};

export enum Role {
  /** ADMINs are mojo teammates. */
  Admin = 'ADMIN',
  /** CURATORs are the people curating stories for the explore tab. */
  Curator = 'CURATOR',
  /** USERs are the creators using the mojo application. */
  User = 'USER'
}

export type SentenceWithEmoji = {
  __typename?: 'SentenceWithEmoji';
  emoji?: Maybe<Scalars['String']['output']>;
  highlightedWord?: Maybe<Scalars['String']['output']>;
  sentence: Scalars['String']['output'];
};

export type SentenceWithEnrichedElements = {
  __typename?: 'SentenceWithEnrichedElements';
  elements: EnrichedElements;
  sentence: Scalars['String']['output'];
};

export type SentenceWithSegments = {
  __typename?: 'SentenceWithSegments';
  emoji?: Maybe<Scalars['String']['output']>;
  end: Scalars['Float']['output'];
  highlightedWord?: Maybe<Scalars['String']['output']>;
  start: Scalars['Float']['output'];
  text: Scalars['String']['output'];
  words: Array<Maybe<TextWithTimings>>;
};

export type SentencesWithImagePrompt = {
  __typename?: 'SentencesWithImagePrompt';
  end: Scalars['Float']['output'];
  prompt: Scalars['String']['output'];
  start: Scalars['Float']['output'];
  text: Scalars['String']['output'];
};

/** Server status enum */
export enum ServerStatus {
  /** The server is down. */
  Down = 'DOWN',
  /** The server is up. */
  Up = 'UP'
}

export type SetAutoLoginTokenMutationResponse = MutationResponse & {
  __typename?: 'SetAutoLoginTokenMutationResponse';
  /** The new autoLoginToken. */
  autoLoginToken?: Maybe<Scalars['String']['output']>;
  autoLoginTokenExpiration?: Maybe<Scalars['Date']['output']>;
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type SetCurationStatus = MutationResponse & {
  __typename?: 'SetCurationStatus';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  /** The user whose blacklist status was changed. */
  user?: Maybe<User>;
};

export type SetUserNameMutationResponse = MutationResponse & {
  __typename?: 'SetUserNameMutationResponse';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  /** The user whose name was changed. */
  user?: Maybe<User>;
};

export type SetUserRoleMutationResponse = MutationResponse & {
  __typename?: 'SetUserRoleMutationResponse';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  /** The user whose role was changed. */
  user?: Maybe<User>;
};

/** A shareable link created by a user to share his video export. */
export type ShareableLink = {
  __typename?: 'ShareableLink';
  allowRemix: Scalars['Boolean']['output'];
  /** The date when the video was created. */
  createdAt: Scalars['Date']['output'];
  /** The export id of the export concerned by this shareable link. */
  exportId: Scalars['String']['output'];
  /** The project id of the project concerned by this shareable link. */
  projectId: Scalars['String']['output'];
  /** The direct video url. */
  signedUrl: Scalars['String']['output'];
  /** The allowance to remix the video. */
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  /** The unique id of the link, notably used in the URL. */
  uid: Scalars['String']['output'];
  /** The date when the video was updated. */
  updatedAt: Scalars['Date']['output'];
  /** The url to display the video. */
  url: Scalars['String']['output'];
  /** The video height. */
  videoHeight: Scalars['Int']['output'];
  /** The video width. */
  videoWidth: Scalars['Int']['output'];
};

export type ShareableLinkInput = {
  allowRemix: Scalars['Boolean']['input'];
  exportId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type Song = {
  __typename?: 'Song';
  _id: Scalars['ID']['output'];
  artistName: Scalars['String']['output'];
  duration: Scalars['Int']['output'];
  fullUrl: Scalars['String']['output'];
  shutterstockId: Scalars['String']['output'];
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type SongSearchResult = {
  __typename?: 'SongSearchResult';
  page: Scalars['Int']['output'];
  songs: Array<Song>;
  totalCount: Scalars['Int']['output'];
};

export type SoundEffectElement = {
  __typename?: 'SoundEffectElement';
  highlightedWord?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

/** languageCode must be any of the supported locales from getSupportedLocalesForSpeechmatics */
export type SpeechAudioInput = {
  audioUrl: Scalars['String']['input'];
  /** includesEmojis is experimental */
  includesEmojis?: InputMaybe<Scalars['Boolean']['input']>;
  languageCode?: InputMaybe<Scalars['String']['input']>;
};

export type SpeechToTextApiProviderData = {
  __typename?: 'SpeechToTextApiProviderData';
  currentUsedProvider: Scalars['String']['output'];
  gladiaLastFiveMinutesSuccessRate?: Maybe<Scalars['Float']['output']>;
  lastFiveMinutesTotalRequestsCount?: Maybe<Scalars['Int']['output']>;
};

export enum SpeechToTextProvider {
  AssemblyAi = 'ASSEMBLY_AI',
  Gladia = 'GLADIA',
  Speechmatics = 'SPEECHMATICS'
}

export enum StockVideoProvider {
  AiGeneratedTexts = 'AI_GENERATED_TEXTS',
  Pexels = 'PEXELS',
  Storyblocks = 'STORYBLOCKS'
}

export enum Store {
  Amazon = 'AMAZON',
  AppStore = 'APP_STORE',
  MacAppStore = 'MAC_APP_STORE',
  PlayStore = 'PLAY_STORE',
  Promotional = 'PROMOTIONAL',
  RcBilling = 'RC_BILLING',
  Stripe = 'STRIPE'
}

export type StoreBillingData = {
  eventId: Scalars['String']['input'];
  expirationTimeMs: Scalars['Float']['input'];
  originalTransactionId: Scalars['String']['input'];
  periodType: TransactionPeriodType;
  productId: Scalars['String']['input'];
  purchasedAtMs: Scalars['Float']['input'];
  store: Store;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  transactionId: Scalars['String']['input'];
};

/** The state of the stories owned by a specific user. */
export type StoriesState = {
  __typename?: 'StoriesState';
  /** A list of snapshot representing the state to delete. */
  delete: Array<Maybe<StorySnapshot>>;
  /** A list of snapshot representing the state to download. */
  get: Array<Maybe<StorySnapshot>>;
  /** A list of snapshot representing the state to upload. */
  post: Array<Maybe<StorySnapshot>>;
};

/** A snapshot of a story in the server with both project id and export id. */
export type StorySnapshot = {
  __typename?: 'StorySnapshot';
  /** The export id of the story when the snapshot was made. */
  exportId?: Maybe<Scalars['ID']['output']>;
  /** The project id of the story when the snapshot was made. */
  projectId?: Maybe<Scalars['ID']['output']>;
};

/** A snapshot of a story from the user device with both project id and export id. */
export type StorySnapshotInput = {
  /** The export id of the story when the snapshot was made. */
  exportId?: InputMaybe<Scalars['ID']['input']>;
  /** The project id of the story when the snapshot was made. */
  projectId?: InputMaybe<Scalars['ID']['input']>;
};

export type StripeMetadata = {
  __typename?: 'StripeMetadata';
  stripeCustomerId: Scalars['String']['output'];
  stripeSubscriptionItemId: Scalars['String']['output'];
};

export enum StyleTag {
  Bold = 'BOLD',
  Collage = 'COLLAGE',
  Colorful = 'COLORFUL',
  Cute = 'CUTE',
  Cutout = 'CUTOUT',
  Digital = 'DIGITAL',
  Elegant = 'ELEGANT',
  Feminine = 'FEMININE',
  Floral = 'FLORAL',
  Frame = 'FRAME',
  Minimalist = 'MINIMALIST',
  Modern = 'MODERN',
  Playful = 'PLAYFUL',
  Retro = 'RETRO',
  Subtitles = 'SUBTITLES',
  Vintage = 'VINTAGE'
}

export type StyleTransferPromptFromImageResponse = {
  __typename?: 'StyleTransferPromptFromImageResponse';
  imagePrompt: Scalars['String']['output'];
};

export enum SubscriptionEntitlement {
  MojoPro = 'MOJO_PRO',
  MojoProAi = 'MOJO_PRO_AI'
}

export type SubscriptionInfos = {
  __typename?: 'SubscriptionInfos';
  autoRenew?: Maybe<Scalars['Boolean']['output']>;
  manageSubscriptionUrl?: Maybe<Scalars['String']['output']>;
};

export enum SubscriptionInterval {
  Monthly = 'MONTHLY',
  Yearly = 'YEARLY'
}

export type SurveyAnswers = {
  __typename?: 'SurveyAnswers';
  contentAbout?: Maybe<Array<Maybe<ContentAbout>>>;
  heardFrom?: Maybe<Array<Maybe<HeardFrom>>>;
  teamSize?: Maybe<Array<Maybe<TeamSize>>>;
  usingMojoAs?: Maybe<Array<Maybe<MojoUsageAs>>>;
  whereToShare?: Maybe<Array<Maybe<WhereToShare>>>;
};

export type SurveyAnswersInput = {
  contentAbout?: InputMaybe<Array<InputMaybe<ContentAbout>>>;
  heardFrom?: InputMaybe<Array<InputMaybe<HeardFrom>>>;
  teamSize?: InputMaybe<Array<InputMaybe<TeamSize>>>;
  usingMojoAs?: InputMaybe<Array<InputMaybe<MojoUsageAs>>>;
  whereToShare?: InputMaybe<Array<InputMaybe<WhereToShare>>>;
};

export type SwitchMonthForRecapTemplatesResult = {
  __typename?: 'SwitchMonthForRecapTemplatesResult';
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  updatedTemplates?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type Task = {
  __typename?: 'Task';
  _id: Scalars['ID']['output'];
  createdAt: Scalars['Date']['output'];
  intermediateResults: Array<TaskIntermediateResults>;
  jsonPayload: Scalars['String']['output'];
  jsonResult?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  outputMetadata?: Maybe<Scalars['JSON']['output']>;
  outputVideo?: Maybe<OutputVideo>;
  parsedResult?: Maybe<Scalars['JSON']['output']>;
  prompt?: Maybe<Scalars['String']['output']>;
  status: TaskStatus;
  thumbnailData?: Maybe<ThumbnailData>;
  type: TaskType;
  updatedAt: Scalars['Date']['output'];
  userId: Scalars['String']['output'];
};

export type TaskInput = {
  jsonPayload: Scalars['String']['input'];
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  type: TaskType;
};

export type TaskIntermediateResults = {
  __typename?: 'TaskIntermediateResults';
  type: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export enum TaskStatus {
  /** Task processing has been canceled */
  Canceled = 'CANCELED',
  /** Task processing is complete */
  Completed = 'COMPLETED',
  /** Task has just been created but the execution workflow has not been started yet */
  Created = 'CREATED',
  /** Task processing has failed */
  Failed = 'FAILED',
  /** The task has been sent to the provider and is waiting to be processed */
  Pending = 'PENDING',
  /** The task is being prepared (PENDING, STARTING, OR QUEUED for less than 10 seconds) - Only sent to app users and not internal user */
  Preparing = 'PREPARING',
  /** Task processing is in progress */
  Processing = 'PROCESSING',
  /** The task has been created in our DB and is queued in our internal task queue */
  Queued = 'QUEUED',
  /** Task processing is starting */
  Starting = 'STARTING'
}

export enum TaskType {
  FalAudio = 'FAL_AUDIO',
  MediaGeneration = 'MEDIA_GENERATION',
  RunwayImageToVideo = 'RUNWAY_IMAGE_TO_VIDEO',
  SpeechToTextTranscription = 'SPEECH_TO_TEXT_TRANSCRIPTION'
}

export type TaskUpdateInput = {
  jsonResult?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  outputMetadata?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<TaskStatus>;
  watermarkData?: InputMaybe<WatermarkDataInput>;
};

export type Team = {
  __typename?: 'Team';
  /** The team billing infos */
  billingInfos?: Maybe<BillingInfos>;
  /** The team role of the current user */
  currentUserTeamRole: TeamRole;
  entitlements: TeamRoleEntitlements;
  /** Team ID */
  id: Scalars['ID']['output'];
  /** The list of the email invited */
  invitations: Array<Maybe<Scalars['String']['output']>>;
  inviteLink?: Maybe<TeamInviteLink>;
  /** The link to invite someone to join the team */
  inviteLinkUrl?: Maybe<Scalars['String']['output']>;
  /** To know if the team have subscribe */
  isPro: Scalars['Boolean']['output'];
  logo?: Maybe<TeamLogo>;
  /** The list of the users inside the team */
  members: Array<TeamUser>;
  /** The team name */
  name: Scalars['String']['output'];
  /** The team brandkit */
  preferences?: Maybe<TeamBrandKit>;
  profilePictureUrl?: Maybe<Scalars['String']['output']>;
  /** The team templates */
  templates?: Maybe<Array<Maybe<Template>>>;
};

export type TeamBrandKit = {
  __typename?: 'TeamBrandKit';
  colors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  fonts?: Maybe<Array<Maybe<Font>>>;
  logos?: Maybe<Array<Maybe<Logo>>>;
  updatedAt: Scalars['Date']['output'];
};

export type TeamInviteLink = {
  __typename?: 'TeamInviteLink';
  isEnabled: Scalars['Boolean']['output'];
  url: Scalars['String']['output'];
};

export type TeamInvoice = {
  __typename?: 'TeamInvoice';
  attemptCount: Scalars['Int']['output'];
  billingReason: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  currency: Scalars['String']['output'];
  customerId: Scalars['String']['output'];
  invoiceCreatedAt: Scalars['Date']['output'];
  invoiceId: Scalars['String']['output'];
  paidAmount: Scalars['Float']['output'];
  periodEnd: Scalars['Date']['output'];
  periodStart: Scalars['Date']['output'];
  quantity: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  subscriptionId: Scalars['String']['output'];
  teamId: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type TeamLogo = {
  __typename?: 'TeamLogo';
  bucketName: Scalars['String']['output'];
  exist: Scalars['Boolean']['output'];
  fileName: Scalars['String']['output'];
  pictureUrl?: Maybe<Scalars['String']['output']>;
};

export type TeamProfilePictureUploadInfo = {
  __typename?: 'TeamProfilePictureUploadInfo';
  bucketName: Scalars['String']['output'];
  uploadPath: Scalars['String']['output'];
};

export enum TeamRole {
  TeamAdmin = 'TEAM_ADMIN',
  TeamMember = 'TEAM_MEMBER',
  TeamOwner = 'TEAM_OWNER'
}

export type TeamRoleEntitlements = {
  __typename?: 'TeamRoleEntitlements';
  canChangeUserRights: Scalars['Boolean']['output'];
  canDeleteTeamUsers: Scalars['Boolean']['output'];
  canInvitePeople: Scalars['Boolean']['output'];
  canManageBilling: Scalars['Boolean']['output'];
  canSeeTeamUsers: Scalars['Boolean']['output'];
};

export enum TeamSize {
  LargeTeam = 'large_team',
  SmallTeam = 'small_team',
  Solo = 'solo'
}

export type TeamUser = {
  __typename?: 'TeamUser';
  role: TeamRole;
  user: User;
};

export type TeamVideoProjectLight = {
  __typename?: 'TeamVideoProjectLight';
  _id: Scalars['ID']['output'];
  exportId: Scalars['String']['output'];
  format: VideoFormatOutput;
  isOwner: Scalars['Boolean']['output'];
  pages: Array<Page>;
  platform?: Maybe<Platform>;
  projectId: Scalars['String']['output'];
  savedAt: Scalars['Date']['output'];
  thumbHash?: Maybe<Scalars['String']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  videoInfo: VideoInfo;
};

export type TeamVideoProjectLightResponse = {
  __typename?: 'TeamVideoProjectLightResponse';
  data: Array<TeamVideoProjectLight>;
  nextCursor?: Maybe<Scalars['String']['output']>;
};

export type TeamVideoTemplateLight = {
  __typename?: 'TeamVideoTemplateLight';
  format: VideoFormatOutput;
  isOwner: Scalars['Boolean']['output'];
  pages: Array<Page>;
  platform?: Maybe<Platform>;
  /** do not use this field (projectId), it will be removed soon */
  projectId: Scalars['String']['output'];
  savedAt: Scalars['Date']['output'];
  templateId: Scalars['String']['output'];
  thumbHash?: Maybe<Scalars['String']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  videoInfo: VideoInfo;
};

/** Response type for cursor-based pagination of team templates */
export type TeamVideoTemplatesResponse = {
  __typename?: 'TeamVideoTemplatesResponse';
  /** List of team templates */
  data: Array<TeamVideoTemplateLight>;
  /** Cursor for the next page of templates, null if no more templates */
  nextCursor?: Maybe<Scalars['String']['output']>;
};

/** Template shared with a team. */
export type Template = {
  __typename?: 'Template';
  /** The creation date of the template in the database. */
  createdAt: Scalars['Date']['output'];
  /** The creator of the original video project used to generate this template. */
  createdBy?: Maybe<User>;
  /** The original video project used to generate this template. */
  createdFrom?: Maybe<VideoProject>;
  fileName?: Maybe<Scalars['String']['output']>;
  /** Indicate if the current user is the creator of the original video project used to generate this template. */
  isSharer: Scalars['Boolean']['output'];
  /** Contains informations about the template format (e.g. story, reel, post, ...). Mapped from templateJson Firebase metadata field. */
  json?: Maybe<Scalars['JSON']['output']>;
  /** Contains informations about the project format (e.g. story, reel, post, ...). Mapped from templateJson Firebase metadata field. In string format. */
  jsonString?: Maybe<Scalars['String']['output']>;
  /** List of all pages of the template */
  pages: Array<Page>;
  /** The platform of the application used to generate this template. */
  platform: Scalars['String']['output'];
  /** The team who own this template. */
  team: Team;
  /** The unique id of the template. */
  templateId: Scalars['ID']['output'];
  thumbnailData?: Maybe<TemplateThumbnailData>;
  /** The last time the template was updated in the database. */
  updatedAt: Scalars['Date']['output'];
  /** Access to the video holder */
  videoHolder: VideoHolder;
};

export type TemplateSchemaLookupTable = {
  __typename?: 'TemplateSchemaLookupTable';
  ANDROID: Scalars['JSON']['output'];
  IOS: Scalars['JSON']['output'];
};

export type TemplateTags = {
  __typename?: 'TemplateTags';
  intents?: Maybe<Array<IntentTag>>;
  styles?: Maybe<Array<StyleTag>>;
  topics?: Maybe<Array<TopicTag>>;
};

export type TemplateTagsInput = {
  intents?: InputMaybe<Array<IntentTag>>;
  styles?: InputMaybe<Array<StyleTag>>;
  topics?: InputMaybe<Array<TopicTag>>;
};

export type TemplateTagsList = {
  __typename?: 'TemplateTagsList';
  intents: Array<IntentTag>;
  styles: Array<StyleTag>;
  topics: Array<TopicTag>;
};

export type TemplateThumbnailData = {
  __typename?: 'TemplateThumbnailData';
  thumbHash?: Maybe<Scalars['String']['output']>;
  thumbnailPath?: Maybe<Scalars['String']['output']>;
};

export type TextPresetSuggestionsResponse = {
  __typename?: 'TextPresetSuggestionsResponse';
  suggestions: Array<AiAnimatedElementPreset>;
};

export type TextWithTimings = {
  __typename?: 'TextWithTimings';
  end: Scalars['Float']['output'];
  start: Scalars['Float']['output'];
  text: Scalars['String']['output'];
};

export type ThumbnailData = {
  __typename?: 'ThumbnailData';
  thumbHash?: Maybe<Scalars['String']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
};

export type ThumbnailDataInput = {
  thumbHash: Scalars['String']['input'];
  thumbnailPath: Scalars['String']['input'];
  thumbnailUrl?: InputMaybe<Scalars['String']['input']>;
  thumbnailUrlExpiresAt?: InputMaybe<Scalars['Date']['input']>;
};

export type ThumbnailDataSimpleInput = {
  thumbnailHash?: InputMaybe<Scalars['String']['input']>;
  thumbnailPath: Scalars['String']['input'];
};

export type TikTokWrappedInput = {
  authorizationToken: Scalars['String']['input'];
  codeVerifier: Scalars['String']['input'];
};

export type TikTokWrappedResponse = {
  __typename?: 'TikTokWrappedResponse';
  jsonTemplate: Scalars['String']['output'];
};

export type TiktokData = {
  __typename?: 'TiktokData';
  songUrl: Scalars['String']['output'];
  videoUrl: Scalars['String']['output'];
};

export type TiktokDataInput = {
  songUrl: Scalars['String']['input'];
  videoUrl: Scalars['String']['input'];
};

export type Title = {
  __typename?: 'Title';
  emoji?: Maybe<Scalars['String']['output']>;
  highlightedWord?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type TokenRenewalInfo = {
  __typename?: 'TokenRenewalInfo';
  tokenRenewalDate: Scalars['Date']['output'];
  tokensAmount: Scalars['Int']['output'];
};

export enum TokenSource {
  Admin = 'admin',
  Free = 'free',
  Initial = 'initial',
  Migration = 'migration',
  MonthlyAttributionForYearly = 'monthly_attribution_for_yearly',
  SubscriptionPurchase = 'subscription_purchase',
  SubscriptionRenewal = 'subscription_renewal',
  TokenPurchase = 'token_purchase'
}

export type Topic = {
  __typename?: 'Topic';
  textSection: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export enum TopicTag {
  ArtAndDesign = 'ART_AND_DESIGN',
  Beauty = 'BEAUTY',
  BusinessVenues = 'BUSINESS_VENUES',
  Ecommerce = 'ECOMMERCE',
  Education = 'EDUCATION',
  Fashion = 'FASHION',
  Food = 'FOOD',
  HealthAndFitness = 'HEALTH_AND_FITNESS',
  HomeAndLiving = 'HOME_AND_LIVING',
  MediaPublishing = 'MEDIA_PUBLISHING',
  Music = 'MUSIC',
  Photography = 'PHOTOGRAPHY',
  RealEstate = 'REAL_ESTATE',
  Travel = 'TRAVEL'
}

export type TransactionMetadata = {
  __typename?: 'TransactionMetadata';
  eventId: Scalars['String']['output'];
  originalTransactionId: Scalars['String']['output'];
  periodType: TransactionPeriodType;
  productId: Scalars['String']['output'];
  purchasedAtMs: Scalars['Float']['output'];
  transactionId: Scalars['String']['output'];
};

export enum TransactionPeriodType {
  Intro = 'INTRO',
  Normal = 'NORMAL',
  Promotional = 'PROMOTIONAL',
  Trial = 'TRIAL'
}

export type TransferProSubscriptionResponse = {
  __typename?: 'TransferProSubscriptionResponse';
  status: TransferProSubscriptionStatus;
};

export enum TransferProSubscriptionStatus {
  Ko = 'KO',
  Ok = 'OK'
}

export type TransferStoriesMutationResponse = {
  __typename?: 'TransferStoriesMutationResponse';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  /** The snapshot of the transfered stories. */
  stories?: Maybe<Array<Maybe<StorySnapshot>>>;
  success: Scalars['Boolean']['output'];
};

/** Template */
export type TrendySongTemplate = {
  __typename?: 'TrendySongTemplate';
  /** The unique id of the template. */
  _id: Scalars['ID']['output'];
  categories: Array<TrendySongTemplateCategory>;
  cleancut: Scalars['Boolean']['output'];
  /** The creation date of the template in the database. */
  createdAt: Scalars['Date']['output'];
  debug: Scalars['Boolean']['output'];
  displayViews: Array<Maybe<DisplayView>>;
  durationInSeconds: Scalars['Float']['output'];
  hasRoyaltyFreeMusic: Scalars['Boolean']['output'];
  hasSound: Scalars['Boolean']['output'];
  hidden: Scalars['Boolean']['output'];
  instagramData?: Maybe<InstagramData>;
  isPro: Scalars['Boolean']['output'];
  isTemplateNew: Scalars['Boolean']['output'];
  jsonTemplate: Scalars['String']['output'];
  maxMediaNb: Scalars['Int']['output'];
  minMediaNb: Scalars['Int']['output'];
  onlyShowForEnglishUser: Scalars['Boolean']['output'];
  platform: Platform;
  tags?: Maybe<TemplateTags>;
  templateSchemaVersion: Scalars['Int']['output'];
  thumbnailUrl: Scalars['String']['output'];
  tiktokData?: Maybe<TiktokData>;
  tiktokWeight: Scalars['Float']['output'];
  trendingSoundArtist?: Maybe<Scalars['String']['output']>;
  trendingSoundTitle?: Maybe<Scalars['String']['output']>;
  trendySongTemplateId: Scalars['String']['output'];
  /** The last time the template was updated in the database. */
  updatedAt: Scalars['Date']['output'];
  videoLowResUrl: Scalars['String']['output'];
  videoUrl: Scalars['String']['output'];
  weight: Scalars['Float']['output'];
};

export type TrendySongTemplateCategory = {
  __typename?: 'TrendySongTemplateCategory';
  categoryId: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  hidden: Scalars['Boolean']['output'];
  isDiscoverCategory?: Maybe<Scalars['Boolean']['output']>;
  label: Scalars['String']['output'];
  tiktokWeight: Scalars['Int']['output'];
  updatedAt: Scalars['Date']['output'];
  weight: Scalars['Int']['output'];
};

export type TrendySongTemplateCategoryDocument = {
  __typename?: 'TrendySongTemplateCategoryDocument';
  _id: Scalars['ID']['output'];
  categoryId: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  hidden: Scalars['Boolean']['output'];
  isDiscoverCategory?: Maybe<Scalars['Boolean']['output']>;
  label: Scalars['String']['output'];
  tiktokWeight: Scalars['Int']['output'];
  translations: Array<TrendySongTemplateCategoryTranslation>;
  updatedAt: Scalars['Date']['output'];
  weight: Scalars['Int']['output'];
};

/** Admin category document with full TrendySongTemplate objects */
export type TrendySongTemplateCategoryForAdmin = {
  __typename?: 'TrendySongTemplateCategoryForAdmin';
  _id: Scalars['ID']['output'];
  /** Raw Android template references from the category (templateId, weight, hidden) */
  androidTemplateRefs: Array<CategoryTemplateOutput>;
  /** Full TrendySongTemplate objects for Android, sorted by weight from androidTemplateRefs */
  androidTemplates: Array<TrendySongTemplate>;
  categoryId: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  hidden: Scalars['Boolean']['output'];
  /** Raw iOS template references from the category (templateId, weight, hidden) */
  iosTemplateRefs: Array<CategoryTemplateOutput>;
  /** Full TrendySongTemplate objects for iOS, sorted by weight from iosTemplateRefs */
  iosTemplates: Array<TrendySongTemplate>;
  isDiscoverCategory?: Maybe<Scalars['Boolean']['output']>;
  label: Scalars['String']['output'];
  tiktokWeight: Scalars['Int']['output'];
  updatedAt: Scalars['Date']['output'];
  weight: Scalars['Int']['output'];
};

export type TrendySongTemplateCategoryInput = {
  categoryId: Scalars['String']['input'];
  hidden: Scalars['Boolean']['input'];
  label: Scalars['String']['input'];
  tiktokWeight: Scalars['Int']['input'];
  weight: Scalars['Int']['input'];
};

export type TrendySongTemplateCategoryTranslation = {
  __typename?: 'TrendySongTemplateCategoryTranslation';
  languageIso: Scalars['String']['output'];
  translation: Scalars['String']['output'];
};

export type TrendySongTemplateCategoryTranslationsCacheResult = {
  __typename?: 'TrendySongTemplateCategoryTranslationsCacheResult';
  code: Scalars['Int']['output'];
};

export type TrendySongTemplateCategoryUpdateInput = {
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  isDiscoverCategory?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  tiktokWeight?: InputMaybe<Scalars['Int']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
};

export type TrendySongTemplateCategoryWithTemplateFilters = {
  appVersionFilters?: InputMaybe<AppPlatformVersionFilters>;
  ignoreTemplateWatermark?: InputMaybe<Scalars['Boolean']['input']>;
  /** The limit number of template categories to retrieve. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** The start number of template categories to retrieve. */
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Show hidden categories */
  showHidden?: InputMaybe<Scalars['Boolean']['input']>;
  /** Show hidden templates within categories */
  showHiddenItems?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TrendySongTemplateCategoryWithTemplates = {
  __typename?: 'TrendySongTemplateCategoryWithTemplates';
  category: TrendySongTemplateCategory;
  items: Array<TrendySongTemplate>;
};

/** Extended category document that includes templates (basic output) */
export type TrendySongTemplateCategoryWithTemplatesDocument = {
  __typename?: 'TrendySongTemplateCategoryWithTemplatesDocument';
  _id: Scalars['ID']['output'];
  androidTemplates: Array<CategoryTemplateOutput>;
  categoryId: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  hidden: Scalars['Boolean']['output'];
  iosTemplates: Array<CategoryTemplateOutput>;
  isDiscoverCategory?: Maybe<Scalars['Boolean']['output']>;
  label: Scalars['String']['output'];
  tiktokWeight: Scalars['Int']['output'];
  updatedAt: Scalars['Date']['output'];
  weight: Scalars['Int']['output'];
};

export type TrendySongTemplateFilters = {
  cleancut?: InputMaybe<CleancutFilters>;
  ignoreTemplateWatermark?: InputMaybe<Scalars['Boolean']['input']>;
  /** If include cleancut is set to true, the cleancut filter will be ignored */
  includeCleancut?: InputMaybe<Scalars['Boolean']['input']>;
  /** The limit number of template to retrieve. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** The start number of template to retrieve. */
  offset?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Platform>;
  showHidden?: InputMaybe<Scalars['Boolean']['input']>;
  /** Sort direction */
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  /** Give only results where updatedAt is more recent than given value */
  updatedGreaterThan?: InputMaybe<Scalars['Date']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type TrendySongTemplateInput = {
  cleancut: Scalars['Boolean']['input'];
  debug: Scalars['Boolean']['input'];
  displayViews: Array<InputMaybe<DisplayView>>;
  hasSound: Scalars['Boolean']['input'];
  hidden: Scalars['Boolean']['input'];
  instagramData?: InputMaybe<InstagramDataInput>;
  isPro: Scalars['Boolean']['input'];
  isTemplateNew: Scalars['Boolean']['input'];
  /** Must be a valid JSON format */
  jsonTemplate: Scalars['String']['input'];
  maxMediaNb: Scalars['Int']['input'];
  minMediaNb: Scalars['Int']['input'];
  onlyShowForEnglishUser: Scalars['Boolean']['input'];
  platform: Platform;
  tags?: InputMaybe<TemplateTagsInput>;
  templateSchemaVersion: Scalars['Int']['input'];
  thumbnailUrl: Scalars['String']['input'];
  tiktokData?: InputMaybe<TiktokDataInput>;
  tiktokWeight: Scalars['Float']['input'];
  trendingSoundArtist?: InputMaybe<Scalars['String']['input']>;
  trendingSoundTitle?: InputMaybe<Scalars['String']['input']>;
  trendySongTemplateId: Scalars['String']['input'];
  videoLowResUrl: Scalars['String']['input'];
  /** Must be a valid URL format */
  videoUrl: Scalars['String']['input'];
  weight: Scalars['Float']['input'];
};

export type TrendySongTemplateUpdateInput = {
  cleancut?: InputMaybe<Scalars['Boolean']['input']>;
  debug?: InputMaybe<Scalars['Boolean']['input']>;
  displayViews?: InputMaybe<Array<InputMaybe<DisplayView>>>;
  hasSound?: InputMaybe<Scalars['Boolean']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  instagramData?: InputMaybe<InstagramDataInput>;
  isPro?: InputMaybe<Scalars['Boolean']['input']>;
  isTemplateNew?: InputMaybe<Scalars['Boolean']['input']>;
  /** Must be a valid JSON format */
  jsonTemplate?: InputMaybe<Scalars['String']['input']>;
  maxMediaNb?: InputMaybe<Scalars['Int']['input']>;
  minMediaNb?: InputMaybe<Scalars['Int']['input']>;
  onlyShowForEnglishUser?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<TemplateTagsInput>;
  templateSchemaVersion?: InputMaybe<Scalars['Int']['input']>;
  thumbnailUrl?: InputMaybe<Scalars['String']['input']>;
  tiktokData?: InputMaybe<TiktokDataInput>;
  tiktokWeight?: InputMaybe<Scalars['Float']['input']>;
  trendingSoundArtist?: InputMaybe<Scalars['String']['input']>;
  trendingSoundTitle?: InputMaybe<Scalars['String']['input']>;
  trendySongTemplateId?: InputMaybe<Scalars['String']['input']>;
  videoLowResUrl?: InputMaybe<Scalars['String']['input']>;
  /** Must be a valid URL format */
  videoUrl?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type TrendySongTemplateUpdateOptions = {
  applyForAllPlatforms?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TrendySongTemplateVersionGeneratorInput = {
  category: Scalars['String']['input'];
  createForAllPlatforms: Scalars['Boolean']['input'];
  instagramReelSoundUrl: Scalars['String']['input'];
  jsonTemplate: Scalars['String']['input'];
  mp4Url: Scalars['String']['input'];
  platform: Platform;
  reelId: Scalars['String']['input'];
  templateSchemaVersion: Scalars['Int']['input'];
};

/** Response type for cursor-based pagination of trendy song templates */
export type TrendySongTemplatesWithCursorResponse = {
  __typename?: 'TrendySongTemplatesWithCursorResponse';
  /** List of trendy song templates */
  data: Array<TrendySongTemplate>;
  /** Cursor for the next page of templates, null if no more templates */
  nextCursor?: Maybe<Scalars['String']['output']>;
};

export type UpdateCategoriesMutationResponse = MutationResponse & {
  __typename?: 'UpdateCategoriesMutationResponse';
  code: Scalars['String']['output'];
  featuredVideo?: Maybe<CuratedVideo>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type UpdatePresetVideoModelForCategoryResult = {
  __typename?: 'UpdatePresetVideoModelForCategoryResult';
  backupInfo?: Maybe<VideoModelMigrationForPresetCategoryBackupInfo>;
  checkResult?: Maybe<UpdateVideoModelForCategoryCheckResult>;
  failedMigrations: Array<FailedPresetModelMigration>;
  successfulMigrations: Array<Scalars['String']['output']>;
};

export type UpdateVideoModelForCategoryCheckResult = {
  __typename?: 'UpdateVideoModelForCategoryCheckResult';
  presetsEgibility: Array<ModelSwitchPresetEgibility>;
};

export type UpdateVideoModelForCategoryInput = {
  categoryId: Scalars['String']['input'];
  check?: InputMaybe<Scalars['Boolean']['input']>;
  targetModel: VideoGenerationModel;
};

export type User = {
  __typename?: 'User';
  /** Number of AI credits the user has */
  aiCredits?: Maybe<Scalars['Int']['output']>;
  /** List of scheduled tasks related to AI credits for the user (yearly plans) */
  aiCreditsScheduledTasks?: Maybe<Array<AiCreditsScheduledTask>>;
  aiSubscriberInfo: AiSubscriberInfo;
  /** Auto login token. */
  autoLoginToken?: Maybe<Scalars['String']['output']>;
  /** Auto login token expiration date. */
  autoLoginTokenExpiration?: Maybe<Scalars['Date']['output']>;
  billingInfos?: Maybe<UserBillingInfos>;
  /** List of the blacklist status of the user. */
  blacklist?: Maybe<BlacklistStatus>;
  /** The creation date of the user in the database. */
  createdAt: Scalars['Date']['output'];
  /** A list of all devices of the user. */
  devices?: Maybe<Array<Maybe<Device>>>;
  /** The email used to register. */
  email?: Maybe<Scalars['String']['output']>;
  favoriteTemplates: Array<Maybe<FavoriteTemplate>>;
  /** The email used to register. */
  ip?: Maybe<Scalars['String']['output']>;
  /** Whether or not the user is subscribed to an AI plan */
  isAiSubscriber: Scalars['Boolean']['output'];
  /** Whether or not the user is banned from generating AI videos */
  isBannedFromGenerating?: Maybe<Scalars['Boolean']['output']>;
  /** Whether or not the user is considered pro. */
  isPro?: Maybe<Scalars['Boolean']['output']>;
  lastSeen: Scalars['Date']['output'];
  mojoSubscriptionInfo: MojoSubscriptionInfo;
  /** Name of the user. */
  name?: Maybe<Scalars['String']['output']>;
  /** The fileId of the profile picture. */
  profilePicture?: Maybe<Scalars['String']['output']>;
  /** Profile Picture URL - 7 days validity */
  profilePictureUrl?: Maybe<Scalars['String']['output']>;
  /** The user IP address */
  role: Scalars['String']['output'];
  /** The Stripe customer id in case the user registered by Stripe. */
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  /** Subscription info from revenue cat */
  subscriptionInfos?: Maybe<SubscriptionInfos>;
  /** Teams the user is part of */
  teams: Array<Maybe<Team>>;
  /** The Firebase ID of the user. */
  uid: Scalars['String']['output'];
  /** The last time the user was updated in the database. */
  updatedAt: Scalars['Date']['output'];
  /** The user current country code */
  userCurrentCountry?: Maybe<Scalars['String']['output']>;
};

export type UserAiSubHealthReport = {
  __typename?: 'UserAiSubHealthReport';
  currentCycle: Scalars['Int']['output'];
  currentTokensAmount: Scalars['Int']['output'];
  isHealthy: Scalars['Boolean']['output'];
  isSubscribed: Scalars['Boolean']['output'];
  issueCodes: Array<AiSubIssueCode>;
  periodicity?: Maybe<SubscriptionInterval>;
};

export type UserBillingInfos = {
  __typename?: 'UserBillingInfos';
  store: Store;
  transactionMetadata: TransactionMetadata;
  validUntil: Scalars['Date']['output'];
};

/** Survey */
export type UserOnboardingSurvey = {
  __typename?: 'UserOnboardingSurvey';
  /** Survey's answers */
  answers: SurveyAnswers;
  /** The creation date of the survey in the database. */
  createdAt: Scalars['Date']['output'];
  /** The unique id of the survey. */
  id: Scalars['ID']['output'];
  /** The last time the survey was updated in the database. */
  updatedAt: Scalars['Date']['output'];
};

export type UserProfilePictureUploadInfo = {
  __typename?: 'UserProfilePictureUploadInfo';
  bucketName: Scalars['String']['output'];
  uploadPath: Scalars['String']['output'];
};

export type UserSnapshot = {
  __typename?: 'UserSnapshot';
  /** The email of the user. */
  email: Scalars['String']['output'];
  /** The firebase id of the user. */
  uid: Scalars['String']['output'];
  /** Whether or not the user was paying when this data was created. */
  wasPaying: Scalars['Boolean']['output'];
  /** Whether or not the user was pro when this data was created. */
  wasPro: Scalars['Boolean']['output'];
};

/** Video exports are all users' saved videos. */
export type VideoExport = {
  __typename?: 'VideoExport';
  /** The application snapshot related to this export. */
  app: AppSnapshot;
  /**
   * The creation date of the export in the database.
   * @deprecated createdAt is deprecated on export.
   */
  createdAt: Scalars['Date']['output'];
  /** The information about the device used to create this export. */
  device?: Maybe<Device>;
  /** The unique id of this export. */
  exportId: Scalars['ID']['output'];
  /** GCS storage information */
  gcs?: Maybe<Gcs>;
  /** The unique id of the project this export originated from. */
  projectId: Scalars['ID']['output'];
  /** The exact date the user pressed save for this export. */
  savedAt?: Maybe<Scalars['Date']['output']>;
  /** A list of all shareable links created for this export. */
  shareableLinks: Array<Maybe<ShareableLink>>;
  templateId?: Maybe<Scalars['String']['output']>;
  thumbHash?: Maybe<Scalars['String']['output']>;
  thumbnailPath?: Maybe<Scalars['String']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  /**
   * The last time the export was updated in the database.
   * @deprecated updatedAt is deprecated on export.
   */
  updatedAt: Scalars['Date']['output'];
  /** The user information snapshot related to this export. */
  user?: Maybe<UserSnapshot>;
  /** The video information related to this export. */
  video?: Maybe<VideoInformation>;
};

export type VideoExportAppInput = {
  build: Scalars['String']['input'];
  env: Scalars['String']['input'];
  featuring: VideoExportFeaturingInput;
  language?: InputMaybe<Scalars['String']['input']>;
  pages: Array<InputMaybe<VideoProjectPageInput>>;
  platform: Scalars['String']['input'];
  version: Scalars['String']['input'];
};

export type VideoExportFeaturingInput = {
  allowed: Scalars['Boolean']['input'];
  curated: Scalars['Boolean']['input'];
};

export type VideoExportsByTemplateIdFilters = {
  /** The limit number of exports to retrieve. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** The start number of exports to retrieve. */
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type VideoFormat = {
  height: Scalars['Int']['input'];
  width: Scalars['Int']['input'];
};

export type VideoFormatOutput = {
  __typename?: 'VideoFormatOutput';
  height: Scalars['Int']['output'];
  width: Scalars['Int']['output'];
};

export enum VideoGenerationModel {
  Kling_2_6 = 'KLING_2_6',
  KlingPro = 'KLING_PRO',
  KlingStandard = 'KLING_STANDARD',
  KlingTurboPro = 'KLING_TURBO_PRO',
  KlingTurboStandard = 'KLING_TURBO_STANDARD',
  Veo_3_1 = 'VEO_3_1'
}

export type VideoGenerationModelInfo = {
  __typename?: 'VideoGenerationModelInfo';
  label: Scalars['String']['output'];
  model: VideoGenerationModel;
  supportsStartEndFrame: Scalars['Boolean']['output'];
};

export type VideoHolder = {
  __typename?: 'VideoHolder';
  bucketName: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
};

export type VideoInfo = {
  __typename?: 'VideoInfo';
  bucketName: Scalars['String']['output'];
  path: Scalars['String']['output'];
};

export type VideoInformation = {
  __typename?: 'VideoInformation';
  /** The height of the video in pixels. */
  height?: Maybe<Scalars['Int']['output']>;
  /** The permanent link of the video. */
  permanentLink?: Maybe<Scalars['String']['output']>;
  /** The width of the video in pixels. */
  width?: Maybe<Scalars['Int']['output']>;
};

export type VideoModelMigrationForPresetCategoryBackupInfo = {
  __typename?: 'VideoModelMigrationForPresetCategoryBackupInfo';
  bucketName: Scalars['String']['output'];
  directory: Scalars['String']['output'];
};

/** Video projects are all users' saved videos. */
export type VideoProject = {
  __typename?: 'VideoProject';
  /** The creation date of the export in the database. */
  createdAt: Scalars['Date']['output'];
  /** A list of exports made on this project. */
  exports?: Maybe<Array<VideoExport>>;
  /** Contains informations about the project format (e.g. story, reel, post, ...). Mapped from projectJson Firebase metadata field. In JSON format. */
  json?: Maybe<Scalars['JSON']['output']>;
  /** Contains informations about the project format (e.g. story, reel, post, ...). Mapped from projectJson Firebase metadata field. In string format. */
  jsonString?: Maybe<Scalars['String']['output']>;
  lastExport?: Maybe<VideoExport>;
  /** Media/File use to generate this project */
  medias?: Maybe<Array<Maybe<File>>>;
  /** List of all pages of the project */
  pages: Array<Page>;
  /** The unique id of the project. */
  projectId: Scalars['ID']['output'];
  /** The last time the project was saved in the app. */
  savedAt?: Maybe<Scalars['Date']['output']>;
  /** A list of shareable links created for this project. */
  shareableLinks?: Maybe<Array<ShareableLink>>;
  /** The last time the project was saved in the app. */
  sharedWithTeams?: Maybe<Array<Maybe<Team>>>;
  /** The last time the project was updated in the database. */
  updatedAt: Scalars['Date']['output'];
};

export type VideoProjectInput = {
  json: Scalars['JSON']['input'];
  lastExport: VideoProjectLastExportInput;
  medias: Array<InputMaybe<Scalars['ID']['input']>>;
  pages: Array<InputMaybe<VideoProjectPageInput>>;
  projectId: Scalars['String']['input'];
  sharedWithTeams: Array<InputMaybe<Scalars['ID']['input']>>;
  user: VideoProjectUserInput;
};

export type VideoProjectInputV2 = {
  lastExport: VideoProjectLastExportInputV2;
  projectId: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type VideoProjectLastExportDeviceInput = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type VideoProjectLastExportGcsInput = {
  filename: Scalars['String']['input'];
};

export type VideoProjectLastExportInput = {
  app: VideoExportAppInput;
  createdAt: Scalars['Date']['input'];
  device?: InputMaybe<VideoProjectLastExportDeviceInput>;
  exportId: Scalars['String']['input'];
  gcs: VideoProjectLastExportGcsInput;
  lastViewedAt: Scalars['Date']['input'];
  savedAt: Scalars['Date']['input'];
  savedBy: Scalars['String']['input'];
  templateId: Scalars['String']['input'];
  thumbnailData?: InputMaybe<ThumbnailDataInput>;
  updatedAt: Scalars['Date']['input'];
  user: VideoProjectUserInput;
  video: VideoProjectLastExportVideoInfoInput;
};

export type VideoProjectLastExportInputV2 = {
  device?: InputMaybe<VideoProjectLastExportDeviceInput>;
  exportId: Scalars['String']['input'];
  filePath: Scalars['String']['input'];
  format: VideoFormat;
  isFeaturingAllowed: Scalars['Boolean']['input'];
  isUserPro: Scalars['Boolean']['input'];
  pages: Array<InputMaybe<VideoProjectPageInputV2>>;
  savedAt: Scalars['Date']['input'];
  thumbnailData: ThumbnailDataSimpleInput;
};

export type VideoProjectLastExportVideoInfoInput = {
  height: Scalars['Int']['input'];
  permanentLink?: InputMaybe<Scalars['String']['input']>;
  width: Scalars['Int']['input'];
};

export type VideoProjectLight = {
  __typename?: 'VideoProjectLight';
  _id: Scalars['ID']['output'];
  collections: Array<Collection>;
  exportId: Scalars['String']['output'];
  format: VideoFormatOutput;
  pages: Array<Page>;
  platform?: Maybe<Platform>;
  projectId: Scalars['String']['output'];
  savedAt: Scalars['Date']['output'];
  thumbHash?: Maybe<Scalars['String']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  videoInfo: VideoInfo;
};

export type VideoProjectLightResponse = {
  __typename?: 'VideoProjectLightResponse';
  data: Array<VideoProjectLight>;
  nextCursor?: Maybe<Scalars['String']['output']>;
};

export type VideoProjectPageInput = {
  id: Scalars['String']['input'];
  json?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  templateName?: InputMaybe<Scalars['String']['input']>;
};

export type VideoProjectPageInputV2 = {
  id: Scalars['String']['input'];
  json: Scalars['JSON']['input'];
  templateName: Scalars['String']['input'];
};

export type VideoProjectUserInput = {
  firebaseId: Scalars['String']['input'];
  wasPaying: Scalars['Boolean']['input'];
  wasPro: Scalars['Boolean']['input'];
};

export type VideoScriptFromIdeaResponse = {
  __typename?: 'VideoScriptFromIdeaResponse';
  language: Scalars['String']['output'];
  script: Scalars['String']['output'];
};

export enum VoiceSpeaker {
  Adam = 'ADAM',
  Alice = 'ALICE',
  Antoni = 'ANTONI',
  Aria = 'ARIA',
  Arnold = 'ARNOLD',
  Bill = 'BILL',
  Brian = 'BRIAN',
  Callum = 'CALLUM',
  Charlie = 'CHARLIE',
  Charlotte = 'CHARLOTTE',
  Chris = 'CHRIS',
  Clyde = 'CLYDE',
  Daniel = 'DANIEL',
  Dave = 'DAVE',
  Domi = 'DOMI',
  Dorothy = 'DOROTHY',
  Drew = 'DREW',
  Elli = 'ELLI',
  Emily = 'EMILY',
  Eric = 'ERIC',
  Ethan = 'ETHAN',
  Fin = 'FIN',
  Freya = 'FREYA',
  George = 'GEORGE',
  Gigi = 'GIGI',
  Giovanni = 'GIOVANNI',
  Glinda = 'GLINDA',
  Grace = 'GRACE',
  Harry = 'HARRY',
  James = 'JAMES',
  Jeremy = 'JEREMY',
  Jessica = 'JESSICA',
  Jessie = 'JESSIE',
  Joseph = 'JOSEPH',
  Josh = 'JOSH',
  Laura = 'LAURA',
  Liam = 'LIAM',
  Lily = 'LILY',
  Matilda = 'MATILDA',
  Michael = 'MICHAEL',
  Mimi = 'MIMI',
  Nicole = 'NICOLE',
  Patrick = 'PATRICK',
  Paul = 'PAUL',
  Rachel = 'RACHEL',
  River = 'RIVER',
  Roger = 'ROGER',
  Sam = 'SAM',
  SantaClaus = 'SANTA_CLAUS',
  Sarah = 'SARAH',
  Serena = 'SERENA',
  Thomas = 'THOMAS',
  Will = 'WILL'
}

export type WatermarkDataInput = {
  filePath: Scalars['String']['input'];
  fileUrl?: InputMaybe<Scalars['String']['input']>;
  fileUrlExpiresAt?: InputMaybe<Scalars['Date']['input']>;
};

export enum WhereToShare {
  Facebook = 'facebook',
  Instagram = 'instagram',
  Message = 'message',
  Other = 'other',
  Snapchat = 'snapchat',
  Tiktok = 'tiktok',
  Twitter = 'twitter',
  Youtube = 'youtube'
}

export type WordTranslation = {
  __typename?: 'WordTranslation';
  translation: Scalars['String']['output'];
  word: Scalars['String']['output'];
};

export type UpdateVideoFilesInput = {
  frame?: InputMaybe<Scalars['Int']['input']>;
  mp4Url: Scalars['String']['input'];
  reelId: Scalars['String']['input'];
};

export type GetRevealsCategoriesWithPresetsQueryVariables = Exact<{
  filters?: InputMaybe<GetRevealsCategoriesWithPresetsFilters>;
}>;


export type GetRevealsCategoriesWithPresetsQuery = { __typename?: 'Query', getRevealsCategoriesWithPresets: { __typename?: 'RevealsCategoriesWithPresetsResponse', categories: Array<{ __typename?: 'RevealsCategoryWithPresets', categoryId: string, description?: string | null, isHighlighted?: boolean | null, label: string, presets: Array<{ __typename?: 'AiAnimatedElementPreset', categoryIds?: Array<string> | null, presetId: string, presetFlow: PresetFlow, isPresetNew: boolean, modelData: { __typename?: 'ReplicateModel', jsonPromptObject: any }, thumbnailData?: { __typename?: 'ThumbnailData', thumbnailUrl?: string | null } | null, previewVideoForCategory?: { __typename?: 'PresetPreviewVideo', url: string } | null }> }> } };

export type CreateAiAnimatedElementsWithPresetsPreviewMutationVariables = Exact<{
  inputFileUrl: Scalars['String']['input'];
  presets?: InputMaybe<Array<PresetConfig> | PresetConfig>;
  inputBucketInfo?: InputMaybe<BucketInfoInput>;
  needsIntermediateFramesValidation?: InputMaybe<IntermediateFramesValidationInput>;
}>;


export type CreateAiAnimatedElementsWithPresetsPreviewMutation = { __typename?: 'Mutation', createAiAnimatedElementsWithPresetsAnonymous: { __typename?: 'AiAnimatedElementsGeneration', _id: string, progress: number, generationId: string, inputFileUrl: string, status: AiAnimatedElementsGenerationStatus, inputBucketInfo?: { __typename?: 'InputBucketInfo', bucketName: string, filePath: string } | null, feedback?: { __typename?: 'GenerationFeedback', rating: number, message?: string | null } | null, presets: Array<{ __typename?: 'AiAnimatedElementGenerationTask', aspectRatio: AiRevealAspectRatio, imagePosition: AiRevealImagePosition, margin?: number | null, customPrompt?: string | null, backgroundColor?: string | null, presetId: string, modelName: RevealsModelName, videoDuration?: number | null, coordinates?: { __typename?: 'Coordinates', x: number, y: number } | null, audioTask?: { __typename?: 'Task', status: TaskStatus, jsonPayload: string } | null, task?: { __typename?: 'Task', status: TaskStatus, parsedResult?: any | null, jsonPayload: string, metadata?: any | null, intermediateResults: Array<{ __typename?: 'TaskIntermediateResults', url: string }>, thumbnailData?: { __typename?: 'ThumbnailData', thumbHash?: string | null, thumbnailUrl?: string | null } | null } | null }> } };

export type CreateAnimatedVideoFromTextMutationVariables = Exact<{
  textInput: Scalars['String']['input'];
  preset: PresetConfig;
}>;


export type CreateAnimatedVideoFromTextMutation = { __typename?: 'Mutation', createAnimatedVideoFromTextAnonymous: { __typename?: 'AiAnimatedElementsGeneration', _id: string, progress: number, generationId: string, inputFileUrl: string, status: AiAnimatedElementsGenerationStatus, inputBucketInfo?: { __typename?: 'InputBucketInfo', bucketName: string, filePath: string } | null, feedback?: { __typename?: 'GenerationFeedback', rating: number, message?: string | null } | null, presets: Array<{ __typename?: 'AiAnimatedElementGenerationTask', aspectRatio: AiRevealAspectRatio, imagePosition: AiRevealImagePosition, margin?: number | null, customPrompt?: string | null, backgroundColor?: string | null, presetId: string, modelName: RevealsModelName, videoDuration?: number | null, coordinates?: { __typename?: 'Coordinates', x: number, y: number } | null, audioTask?: { __typename?: 'Task', status: TaskStatus, jsonPayload: string } | null, task?: { __typename?: 'Task', status: TaskStatus, parsedResult?: any | null, jsonPayload: string, metadata?: any | null, intermediateResults: Array<{ __typename?: 'TaskIntermediateResults', url: string }>, thumbnailData?: { __typename?: 'ThumbnailData', thumbHash?: string | null, thumbnailUrl?: string | null } | null } | null }> } };

export type CreateAnimatedVideoFromPromptMutationVariables = Exact<{
  preset: PresetConfig;
}>;


export type CreateAnimatedVideoFromPromptMutation = { __typename?: 'Mutation', createAnimatedVideoFromPromptAnonymous: { __typename?: 'AiAnimatedElementsGeneration', _id: string, progress: number, generationId: string, inputFileUrl: string, status: AiAnimatedElementsGenerationStatus, inputBucketInfo?: { __typename?: 'InputBucketInfo', bucketName: string, filePath: string } | null, feedback?: { __typename?: 'GenerationFeedback', rating: number, message?: string | null } | null, presets: Array<{ __typename?: 'AiAnimatedElementGenerationTask', aspectRatio: AiRevealAspectRatio, imagePosition: AiRevealImagePosition, margin?: number | null, customPrompt?: string | null, backgroundColor?: string | null, presetId: string, modelName: RevealsModelName, videoDuration?: number | null, coordinates?: { __typename?: 'Coordinates', x: number, y: number } | null, audioTask?: { __typename?: 'Task', status: TaskStatus, jsonPayload: string } | null, task?: { __typename?: 'Task', status: TaskStatus, parsedResult?: any | null, jsonPayload: string, metadata?: any | null, intermediateResults: Array<{ __typename?: 'TaskIntermediateResults', url: string }>, thumbnailData?: { __typename?: 'ThumbnailData', thumbHash?: string | null, thumbnailUrl?: string | null } | null } | null }> } };

export type StartPendingGenerationMutationVariables = Exact<{
  generationId: Scalars['ID']['input'];
  previewUrl: Scalars['String']['input'];
  withAudio?: InputMaybe<Scalars['Boolean']['input']>;
  videoDuration?: InputMaybe<Scalars['Int']['input']>;
}>;


export type StartPendingGenerationMutation = { __typename?: 'Mutation', startPendingGenerationAnonymous: { __typename?: 'AiAnimatedElementsGeneration', _id: string, progress: number, generationId: string, inputFileUrl: string, status: AiAnimatedElementsGenerationStatus, inputBucketInfo?: { __typename?: 'InputBucketInfo', bucketName: string, filePath: string } | null, feedback?: { __typename?: 'GenerationFeedback', rating: number, message?: string | null } | null, presets: Array<{ __typename?: 'AiAnimatedElementGenerationTask', aspectRatio: AiRevealAspectRatio, imagePosition: AiRevealImagePosition, margin?: number | null, customPrompt?: string | null, backgroundColor?: string | null, presetId: string, modelName: RevealsModelName, videoDuration?: number | null, coordinates?: { __typename?: 'Coordinates', x: number, y: number } | null, audioTask?: { __typename?: 'Task', status: TaskStatus, jsonPayload: string } | null, task?: { __typename?: 'Task', status: TaskStatus, parsedResult?: any | null, jsonPayload: string, metadata?: any | null, intermediateResults: Array<{ __typename?: 'TaskIntermediateResults', url: string }>, thumbnailData?: { __typename?: 'ThumbnailData', thumbHash?: string | null, thumbnailUrl?: string | null } | null } | null }> } };

export type GenerateAiAnimatedPictureInputFromBase64QueryVariables = Exact<{
  base64Data: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
}>;


export type GenerateAiAnimatedPictureInputFromBase64Query = { __typename?: 'Query', generateAiAnimatedPictureInputFromBase64: { __typename?: 'RemoveBackgroundFromBase64Result', removedBackgroundPictureUrl: string, bucketName: string, filePath: string, backgroundColorToUse?: string | null } };

export type GetPresetSuggestionsFromImageQueryVariables = Exact<{
  imageUrl: Scalars['String']['input'];
}>;


export type GetPresetSuggestionsFromImageQuery = { __typename?: 'Query', getPresetSuggestionsFromImage: { __typename?: 'PresetSuggestionsResponse', long: string, object: string, short: string, suggestions: Array<{ __typename?: 'AiAnimatedElementPreset', categoryIds?: Array<string> | null, presetId: string, presetFlow: PresetFlow, isPresetNew: boolean, previewVideoUrl: string, modelData: { __typename?: 'ReplicateModel', jsonPromptObject: any }, previewVideoForCategory?: { __typename?: 'PresetPreviewVideo', url: string } | null }> } };

export type GetPresetSuggestionsFromTextQueryVariables = Exact<{
  text: Scalars['String']['input'];
}>;


export type GetPresetSuggestionsFromTextQuery = { __typename?: 'Query', getPresetSuggestionsFromText: { __typename?: 'TextPresetSuggestionsResponse', suggestions: Array<{ __typename?: 'AiAnimatedElementPreset', categoryIds?: Array<string> | null, presetId: string, presetFlow: PresetFlow, isPresetNew: boolean, previewVideoUrl: string, modelData: { __typename?: 'ReplicateModel', jsonPromptObject: any }, previewVideoForCategory?: { __typename?: 'PresetPreviewVideo', url: string } | null }> } };

export type CreateAnimatedVideoFromImageImmediateMutationVariables = Exact<{
  imageUrl: Scalars['String']['input'];
  inputBucketInfo: BucketInfoInput;
  preset: PresetConfig;
}>;


export type CreateAnimatedVideoFromImageImmediateMutation = { __typename?: 'Mutation', createAnimatedVideoFromImageImmediate: { __typename?: 'AiAnimatedElementsGeneration', _id: string, progress: number, generationId: string, inputFileUrl: string, status: AiAnimatedElementsGenerationStatus, inputBucketInfo?: { __typename?: 'InputBucketInfo', bucketName: string, filePath: string } | null, feedback?: { __typename?: 'GenerationFeedback', rating: number, message?: string | null } | null, presets: Array<{ __typename?: 'AiAnimatedElementGenerationTask', aspectRatio: AiRevealAspectRatio, imagePosition: AiRevealImagePosition, margin?: number | null, customPrompt?: string | null, backgroundColor?: string | null, presetId: string, modelName: RevealsModelName, videoDuration?: number | null, coordinates?: { __typename?: 'Coordinates', x: number, y: number } | null, audioTask?: { __typename?: 'Task', status: TaskStatus, jsonPayload: string } | null, task?: { __typename?: 'Task', status: TaskStatus, parsedResult?: any | null, jsonPayload: string, metadata?: any | null, intermediateResults: Array<{ __typename?: 'TaskIntermediateResults', url: string }>, thumbnailData?: { __typename?: 'ThumbnailData', thumbHash?: string | null, thumbnailUrl?: string | null } | null } | null }> } };

export type GenerationFragmentFragment = { __typename?: 'AiAnimatedElementsGeneration', _id: string, progress: number, generationId: string, inputFileUrl: string, status: AiAnimatedElementsGenerationStatus, inputBucketInfo?: { __typename?: 'InputBucketInfo', bucketName: string, filePath: string } | null, feedback?: { __typename?: 'GenerationFeedback', rating: number, message?: string | null } | null, presets: Array<{ __typename?: 'AiAnimatedElementGenerationTask', aspectRatio: AiRevealAspectRatio, imagePosition: AiRevealImagePosition, margin?: number | null, customPrompt?: string | null, backgroundColor?: string | null, presetId: string, modelName: RevealsModelName, videoDuration?: number | null, coordinates?: { __typename?: 'Coordinates', x: number, y: number } | null, audioTask?: { __typename?: 'Task', status: TaskStatus, jsonPayload: string } | null, task?: { __typename?: 'Task', status: TaskStatus, parsedResult?: any | null, jsonPayload: string, metadata?: any | null, intermediateResults: Array<{ __typename?: 'TaskIntermediateResults', url: string }>, thumbnailData?: { __typename?: 'ThumbnailData', thumbHash?: string | null, thumbnailUrl?: string | null } | null } | null }> } & { ' $fragmentName'?: 'GenerationFragmentFragment' };

export type GenerationCompleteFragmentFragment = { __typename?: 'AiAnimatedElementsGeneration', _id: string, progress: number, generationId: string, inputFileUrl: string, status: AiAnimatedElementsGenerationStatus, inputBucketInfo?: { __typename?: 'InputBucketInfo', bucketName: string, filePath: string } | null, feedback?: { __typename?: 'GenerationFeedback', rating: number, message?: string | null } | null, presets: Array<{ __typename?: 'AiAnimatedElementGenerationTask', aspectRatio: AiRevealAspectRatio, imagePosition: AiRevealImagePosition, margin?: number | null, customPrompt?: string | null, videoDuration?: number | null, backgroundColor?: string | null, presetId: string, modelName: RevealsModelName, coordinates?: { __typename?: 'Coordinates', x: number, y: number } | null, audioTask?: { __typename?: 'Task', status: TaskStatus, jsonPayload: string, parsedResult?: any | null, outputVideo?: { __typename?: 'OutputVideo', url: string, hasWatermark: boolean } | null } | null, task?: { __typename?: 'Task', status: TaskStatus, parsedResult?: any | null, jsonPayload: string, intermediateResults: Array<{ __typename?: 'TaskIntermediateResults', url: string }>, outputVideo?: { __typename?: 'OutputVideo', url: string, hasWatermark: boolean } | null, thumbnailData?: { __typename?: 'ThumbnailData', thumbHash?: string | null, thumbnailUrl?: string | null } | null } | null }> } & { ' $fragmentName'?: 'GenerationCompleteFragmentFragment' };

export type CancelGenerationMutationVariables = Exact<{
  generationId: Scalars['ID']['input'];
}>;


export type CancelGenerationMutation = { __typename?: 'Mutation', cancelGeneration: { __typename?: 'CancelGenerationResponse', generationId: string, status: AiAnimatedElementsGenerationStatus } };

export type CreateAiAnimatedElementsWithPresetsMutationVariables = Exact<{
  inputFileUrl: Scalars['String']['input'];
  presets?: InputMaybe<Array<PresetConfig> | PresetConfig>;
  inputBucketInfo?: InputMaybe<BucketInfoInput>;
}>;


export type CreateAiAnimatedElementsWithPresetsMutation = { __typename?: 'Mutation', createAiAnimatedElementsWithPresetsAnonymous: (
    { __typename?: 'AiAnimatedElementsGeneration' }
    & { ' $fragmentRefs'?: { 'GenerationFragmentFragment': GenerationFragmentFragment } }
  ) };

export type DeleteAiGenerationMutationVariables = Exact<{
  generationId: Scalars['ID']['input'];
}>;


export type DeleteAiGenerationMutation = { __typename?: 'Mutation', deleteAiGeneration: { __typename?: 'AiAnimatedElementsGeneration', generationId: string } };

export type MyGenerationsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type MyGenerationsQuery = { __typename?: 'Query', myAiGenerationsAnonymous: { __typename?: 'MyAiGenerationsResponse', nextCursor?: string | null, data: Array<(
      { __typename?: 'AiAnimatedElementsGeneration' }
      & { ' $fragmentRefs'?: { 'GenerationCompleteFragmentFragment': GenerationCompleteFragmentFragment } }
    )> } };

export type GetGenerationsProgressQueryVariables = Exact<{
  generationsIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetGenerationsProgressQuery = { __typename?: 'Query', getGenerationsAnonymous: Array<(
    { __typename?: 'AiAnimatedElementsGeneration' }
    & { ' $fragmentRefs'?: { 'GenerationFragmentFragment': GenerationFragmentFragment } }
  )> };

export type GetGenerationsCompleteQueryVariables = Exact<{
  generationsIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetGenerationsCompleteQuery = { __typename?: 'Query', getGenerationsAnonymous: Array<(
    { __typename?: 'AiAnimatedElementsGeneration' }
    & { ' $fragmentRefs'?: { 'GenerationCompleteFragmentFragment': GenerationCompleteFragmentFragment } }
  )> };

export type GetGenerationsByDetectedObjectsQueryVariables = Exact<{
  objectDescriptionToUse?: InputMaybe<ObjectDescription>;
}>;


export type GetGenerationsByDetectedObjectsQuery = { __typename?: 'Query', getGenerationsByDetectedObjectsAnonymous: { __typename?: 'GenerationsByDetectedObjectsResponse', items: Array<{ __typename?: 'GenerationsByDetectedObject', previewUrl?: string | null, detectedObject: string, generations: Array<{ __typename?: 'GenerationWithOrientation', generationId: string, aspectRatio: AiRevealAspectRatio }> }> } };

export const GenerationFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GenerationFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AiAnimatedElementsGeneration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"progress"}},{"kind":"Field","name":{"kind":"Name","value":"generationId"}},{"kind":"Field","name":{"kind":"Name","value":"inputFileUrl"}},{"kind":"Field","name":{"kind":"Name","value":"inputBucketInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bucketName"}},{"kind":"Field","name":{"kind":"Name","value":"filePath"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"feedback"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rating"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"presets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aspectRatio"}},{"kind":"Field","name":{"kind":"Name","value":"imagePosition"}},{"kind":"Field","name":{"kind":"Name","value":"margin"}},{"kind":"Field","name":{"kind":"Name","value":"customPrompt"}},{"kind":"Field","name":{"kind":"Name","value":"coordinates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}}]}},{"kind":"Field","name":{"kind":"Name","value":"backgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"presetId"}},{"kind":"Field","name":{"kind":"Name","value":"modelName"}},{"kind":"Field","name":{"kind":"Name","value":"audioTask"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"jsonPayload"}}]}},{"kind":"Field","name":{"kind":"Name","value":"videoDuration"}},{"kind":"Field","name":{"kind":"Name","value":"task"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"parsedResult"}},{"kind":"Field","name":{"kind":"Name","value":"jsonPayload"}},{"kind":"Field","name":{"kind":"Name","value":"intermediateResults"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"thumbHash"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}}]}}]}}]} as unknown as DocumentNode<GenerationFragmentFragment, unknown>;
export const GenerationCompleteFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GenerationCompleteFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AiAnimatedElementsGeneration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"progress"}},{"kind":"Field","name":{"kind":"Name","value":"generationId"}},{"kind":"Field","name":{"kind":"Name","value":"inputFileUrl"}},{"kind":"Field","name":{"kind":"Name","value":"inputBucketInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bucketName"}},{"kind":"Field","name":{"kind":"Name","value":"filePath"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"feedback"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rating"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"presets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aspectRatio"}},{"kind":"Field","name":{"kind":"Name","value":"imagePosition"}},{"kind":"Field","name":{"kind":"Name","value":"margin"}},{"kind":"Field","name":{"kind":"Name","value":"customPrompt"}},{"kind":"Field","name":{"kind":"Name","value":"coordinates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}}]}},{"kind":"Field","name":{"kind":"Name","value":"videoDuration"}},{"kind":"Field","name":{"kind":"Name","value":"backgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"presetId"}},{"kind":"Field","name":{"kind":"Name","value":"modelName"}},{"kind":"Field","name":{"kind":"Name","value":"audioTask"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"jsonPayload"}},{"kind":"Field","name":{"kind":"Name","value":"parsedResult"}},{"kind":"Field","name":{"kind":"Name","value":"outputVideo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"hasWatermark"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"task"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"parsedResult"}},{"kind":"Field","name":{"kind":"Name","value":"jsonPayload"}},{"kind":"Field","name":{"kind":"Name","value":"intermediateResults"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"outputVideo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"hasWatermark"}}]}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"thumbHash"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GenerationCompleteFragmentFragment, unknown>;
export const GetRevealsCategoriesWithPresetsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetRevealsCategoriesWithPresets"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"GetRevealsCategoriesWithPresetsFilters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getRevealsCategoriesWithPresets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"categoryId"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"isHighlighted"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"presets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"categoryIds"}},{"kind":"Field","name":{"kind":"Name","value":"presetId"}},{"kind":"Field","name":{"kind":"Name","value":"presetFlow"}},{"kind":"Field","name":{"kind":"Name","value":"isPresetNew"}},{"kind":"Field","name":{"kind":"Name","value":"modelData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jsonPromptObject"}}]}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previewVideoForCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetRevealsCategoriesWithPresetsQuery, GetRevealsCategoriesWithPresetsQueryVariables>;
export const CreateAiAnimatedElementsWithPresetsPreviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateAiAnimatedElementsWithPresetsPreview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inputFileUrl"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"presets"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PresetConfig"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inputBucketInfo"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BucketInfoInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"needsIntermediateFramesValidation"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"IntermediateFramesValidationInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createAiAnimatedElementsWithPresetsAnonymous"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"inputFileUrl"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inputFileUrl"}}},{"kind":"Argument","name":{"kind":"Name","value":"presets"},"value":{"kind":"Variable","name":{"kind":"Name","value":"presets"}}},{"kind":"Argument","name":{"kind":"Name","value":"inputBucketInfo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inputBucketInfo"}}},{"kind":"Argument","name":{"kind":"Name","value":"needsIntermediateFramesValidation"},"value":{"kind":"Variable","name":{"kind":"Name","value":"needsIntermediateFramesValidation"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"progress"}},{"kind":"Field","name":{"kind":"Name","value":"generationId"}},{"kind":"Field","name":{"kind":"Name","value":"inputFileUrl"}},{"kind":"Field","name":{"kind":"Name","value":"inputBucketInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bucketName"}},{"kind":"Field","name":{"kind":"Name","value":"filePath"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"feedback"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rating"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"presets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aspectRatio"}},{"kind":"Field","name":{"kind":"Name","value":"imagePosition"}},{"kind":"Field","name":{"kind":"Name","value":"margin"}},{"kind":"Field","name":{"kind":"Name","value":"customPrompt"}},{"kind":"Field","name":{"kind":"Name","value":"coordinates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}}]}},{"kind":"Field","name":{"kind":"Name","value":"backgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"presetId"}},{"kind":"Field","name":{"kind":"Name","value":"modelName"}},{"kind":"Field","name":{"kind":"Name","value":"audioTask"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"jsonPayload"}}]}},{"kind":"Field","name":{"kind":"Name","value":"videoDuration"}},{"kind":"Field","name":{"kind":"Name","value":"task"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"parsedResult"}},{"kind":"Field","name":{"kind":"Name","value":"jsonPayload"}},{"kind":"Field","name":{"kind":"Name","value":"intermediateResults"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"thumbHash"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreateAiAnimatedElementsWithPresetsPreviewMutation, CreateAiAnimatedElementsWithPresetsPreviewMutationVariables>;
export const CreateAnimatedVideoFromTextDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateAnimatedVideoFromText"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"textInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"preset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PresetConfig"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createAnimatedVideoFromTextAnonymous"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"textInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"textInput"}}},{"kind":"Argument","name":{"kind":"Name","value":"preset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"progress"}},{"kind":"Field","name":{"kind":"Name","value":"generationId"}},{"kind":"Field","name":{"kind":"Name","value":"inputFileUrl"}},{"kind":"Field","name":{"kind":"Name","value":"inputBucketInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bucketName"}},{"kind":"Field","name":{"kind":"Name","value":"filePath"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"feedback"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rating"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"presets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aspectRatio"}},{"kind":"Field","name":{"kind":"Name","value":"imagePosition"}},{"kind":"Field","name":{"kind":"Name","value":"margin"}},{"kind":"Field","name":{"kind":"Name","value":"customPrompt"}},{"kind":"Field","name":{"kind":"Name","value":"coordinates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}}]}},{"kind":"Field","name":{"kind":"Name","value":"backgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"presetId"}},{"kind":"Field","name":{"kind":"Name","value":"modelName"}},{"kind":"Field","name":{"kind":"Name","value":"audioTask"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"jsonPayload"}}]}},{"kind":"Field","name":{"kind":"Name","value":"videoDuration"}},{"kind":"Field","name":{"kind":"Name","value":"task"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"parsedResult"}},{"kind":"Field","name":{"kind":"Name","value":"jsonPayload"}},{"kind":"Field","name":{"kind":"Name","value":"intermediateResults"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"thumbHash"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreateAnimatedVideoFromTextMutation, CreateAnimatedVideoFromTextMutationVariables>;
export const CreateAnimatedVideoFromPromptDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateAnimatedVideoFromPrompt"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"preset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PresetConfig"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createAnimatedVideoFromPromptAnonymous"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"preset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"progress"}},{"kind":"Field","name":{"kind":"Name","value":"generationId"}},{"kind":"Field","name":{"kind":"Name","value":"inputFileUrl"}},{"kind":"Field","name":{"kind":"Name","value":"inputBucketInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bucketName"}},{"kind":"Field","name":{"kind":"Name","value":"filePath"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"feedback"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rating"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"presets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aspectRatio"}},{"kind":"Field","name":{"kind":"Name","value":"imagePosition"}},{"kind":"Field","name":{"kind":"Name","value":"margin"}},{"kind":"Field","name":{"kind":"Name","value":"customPrompt"}},{"kind":"Field","name":{"kind":"Name","value":"coordinates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}}]}},{"kind":"Field","name":{"kind":"Name","value":"backgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"presetId"}},{"kind":"Field","name":{"kind":"Name","value":"modelName"}},{"kind":"Field","name":{"kind":"Name","value":"audioTask"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"jsonPayload"}}]}},{"kind":"Field","name":{"kind":"Name","value":"videoDuration"}},{"kind":"Field","name":{"kind":"Name","value":"task"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"parsedResult"}},{"kind":"Field","name":{"kind":"Name","value":"jsonPayload"}},{"kind":"Field","name":{"kind":"Name","value":"intermediateResults"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"thumbHash"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreateAnimatedVideoFromPromptMutation, CreateAnimatedVideoFromPromptMutationVariables>;
export const StartPendingGenerationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"StartPendingGeneration"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"generationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"previewUrl"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"withAudio"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"videoDuration"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startPendingGenerationAnonymous"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"generationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"generationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"previewUrl"},"value":{"kind":"Variable","name":{"kind":"Name","value":"previewUrl"}}},{"kind":"Argument","name":{"kind":"Name","value":"withAudio"},"value":{"kind":"Variable","name":{"kind":"Name","value":"withAudio"}}},{"kind":"Argument","name":{"kind":"Name","value":"videoDuration"},"value":{"kind":"Variable","name":{"kind":"Name","value":"videoDuration"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"progress"}},{"kind":"Field","name":{"kind":"Name","value":"generationId"}},{"kind":"Field","name":{"kind":"Name","value":"inputFileUrl"}},{"kind":"Field","name":{"kind":"Name","value":"inputBucketInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bucketName"}},{"kind":"Field","name":{"kind":"Name","value":"filePath"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"feedback"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rating"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"presets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aspectRatio"}},{"kind":"Field","name":{"kind":"Name","value":"imagePosition"}},{"kind":"Field","name":{"kind":"Name","value":"margin"}},{"kind":"Field","name":{"kind":"Name","value":"customPrompt"}},{"kind":"Field","name":{"kind":"Name","value":"coordinates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}}]}},{"kind":"Field","name":{"kind":"Name","value":"backgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"presetId"}},{"kind":"Field","name":{"kind":"Name","value":"modelName"}},{"kind":"Field","name":{"kind":"Name","value":"audioTask"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"jsonPayload"}}]}},{"kind":"Field","name":{"kind":"Name","value":"videoDuration"}},{"kind":"Field","name":{"kind":"Name","value":"task"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"parsedResult"}},{"kind":"Field","name":{"kind":"Name","value":"jsonPayload"}},{"kind":"Field","name":{"kind":"Name","value":"intermediateResults"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"thumbHash"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}}]}}]}}]}}]} as unknown as DocumentNode<StartPendingGenerationMutation, StartPendingGenerationMutationVariables>;
export const GenerateAiAnimatedPictureInputFromBase64Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GenerateAiAnimatedPictureInputFromBase64"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"base64Data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fileName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generateAiAnimatedPictureInputFromBase64"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"base64Data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"base64Data"}}},{"kind":"Argument","name":{"kind":"Name","value":"fileName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fileName"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removedBackgroundPictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"bucketName"}},{"kind":"Field","name":{"kind":"Name","value":"filePath"}},{"kind":"Field","name":{"kind":"Name","value":"backgroundColorToUse"}}]}}]}}]} as unknown as DocumentNode<GenerateAiAnimatedPictureInputFromBase64Query, GenerateAiAnimatedPictureInputFromBase64QueryVariables>;
export const GetPresetSuggestionsFromImageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPresetSuggestionsFromImage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"imageUrl"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getPresetSuggestionsFromImage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"imageUrl"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imageUrl"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"long"}},{"kind":"Field","name":{"kind":"Name","value":"object"}},{"kind":"Field","name":{"kind":"Name","value":"short"}},{"kind":"Field","name":{"kind":"Name","value":"suggestions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"categoryIds"}},{"kind":"Field","name":{"kind":"Name","value":"presetId"}},{"kind":"Field","name":{"kind":"Name","value":"presetFlow"}},{"kind":"Field","name":{"kind":"Name","value":"isPresetNew"}},{"kind":"Field","name":{"kind":"Name","value":"modelData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jsonPromptObject"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previewVideoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"previewVideoForCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetPresetSuggestionsFromImageQuery, GetPresetSuggestionsFromImageQueryVariables>;
export const GetPresetSuggestionsFromTextDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPresetSuggestionsFromText"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"text"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getPresetSuggestionsFromText"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"text"},"value":{"kind":"Variable","name":{"kind":"Name","value":"text"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"suggestions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"categoryIds"}},{"kind":"Field","name":{"kind":"Name","value":"presetId"}},{"kind":"Field","name":{"kind":"Name","value":"presetFlow"}},{"kind":"Field","name":{"kind":"Name","value":"isPresetNew"}},{"kind":"Field","name":{"kind":"Name","value":"modelData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jsonPromptObject"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previewVideoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"previewVideoForCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetPresetSuggestionsFromTextQuery, GetPresetSuggestionsFromTextQueryVariables>;
export const CreateAnimatedVideoFromImageImmediateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateAnimatedVideoFromImageImmediate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"imageUrl"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inputBucketInfo"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BucketInfoInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"preset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PresetConfig"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createAnimatedVideoFromImageImmediate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"imageUrl"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imageUrl"}}},{"kind":"Argument","name":{"kind":"Name","value":"inputBucketInfo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inputBucketInfo"}}},{"kind":"Argument","name":{"kind":"Name","value":"preset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"progress"}},{"kind":"Field","name":{"kind":"Name","value":"generationId"}},{"kind":"Field","name":{"kind":"Name","value":"inputFileUrl"}},{"kind":"Field","name":{"kind":"Name","value":"inputBucketInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bucketName"}},{"kind":"Field","name":{"kind":"Name","value":"filePath"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"feedback"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rating"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"presets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aspectRatio"}},{"kind":"Field","name":{"kind":"Name","value":"imagePosition"}},{"kind":"Field","name":{"kind":"Name","value":"margin"}},{"kind":"Field","name":{"kind":"Name","value":"customPrompt"}},{"kind":"Field","name":{"kind":"Name","value":"coordinates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}}]}},{"kind":"Field","name":{"kind":"Name","value":"backgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"presetId"}},{"kind":"Field","name":{"kind":"Name","value":"modelName"}},{"kind":"Field","name":{"kind":"Name","value":"audioTask"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"jsonPayload"}}]}},{"kind":"Field","name":{"kind":"Name","value":"videoDuration"}},{"kind":"Field","name":{"kind":"Name","value":"task"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"parsedResult"}},{"kind":"Field","name":{"kind":"Name","value":"jsonPayload"}},{"kind":"Field","name":{"kind":"Name","value":"intermediateResults"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"thumbHash"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreateAnimatedVideoFromImageImmediateMutation, CreateAnimatedVideoFromImageImmediateMutationVariables>;
export const CancelGenerationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CancelGeneration"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"generationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cancelGeneration"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"generationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"generationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generationId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<CancelGenerationMutation, CancelGenerationMutationVariables>;
export const CreateAiAnimatedElementsWithPresetsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateAiAnimatedElementsWithPresets"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inputFileUrl"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"presets"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PresetConfig"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inputBucketInfo"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BucketInfoInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createAiAnimatedElementsWithPresetsAnonymous"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"inputFileUrl"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inputFileUrl"}}},{"kind":"Argument","name":{"kind":"Name","value":"presets"},"value":{"kind":"Variable","name":{"kind":"Name","value":"presets"}}},{"kind":"Argument","name":{"kind":"Name","value":"inputBucketInfo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inputBucketInfo"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GenerationFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GenerationFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AiAnimatedElementsGeneration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"progress"}},{"kind":"Field","name":{"kind":"Name","value":"generationId"}},{"kind":"Field","name":{"kind":"Name","value":"inputFileUrl"}},{"kind":"Field","name":{"kind":"Name","value":"inputBucketInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bucketName"}},{"kind":"Field","name":{"kind":"Name","value":"filePath"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"feedback"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rating"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"presets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aspectRatio"}},{"kind":"Field","name":{"kind":"Name","value":"imagePosition"}},{"kind":"Field","name":{"kind":"Name","value":"margin"}},{"kind":"Field","name":{"kind":"Name","value":"customPrompt"}},{"kind":"Field","name":{"kind":"Name","value":"coordinates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}}]}},{"kind":"Field","name":{"kind":"Name","value":"backgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"presetId"}},{"kind":"Field","name":{"kind":"Name","value":"modelName"}},{"kind":"Field","name":{"kind":"Name","value":"audioTask"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"jsonPayload"}}]}},{"kind":"Field","name":{"kind":"Name","value":"videoDuration"}},{"kind":"Field","name":{"kind":"Name","value":"task"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"parsedResult"}},{"kind":"Field","name":{"kind":"Name","value":"jsonPayload"}},{"kind":"Field","name":{"kind":"Name","value":"intermediateResults"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"thumbHash"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}}]}}]}}]} as unknown as DocumentNode<CreateAiAnimatedElementsWithPresetsMutation, CreateAiAnimatedElementsWithPresetsMutationVariables>;
export const DeleteAiGenerationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteAiGeneration"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"generationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteAiGeneration"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"generationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"generationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generationId"}}]}}]}}]} as unknown as DocumentNode<DeleteAiGenerationMutation, DeleteAiGenerationMutationVariables>;
export const MyGenerationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MyGenerations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"myAiGenerationsAnonymous"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"cursor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GenerationCompleteFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nextCursor"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GenerationCompleteFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AiAnimatedElementsGeneration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"progress"}},{"kind":"Field","name":{"kind":"Name","value":"generationId"}},{"kind":"Field","name":{"kind":"Name","value":"inputFileUrl"}},{"kind":"Field","name":{"kind":"Name","value":"inputBucketInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bucketName"}},{"kind":"Field","name":{"kind":"Name","value":"filePath"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"feedback"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rating"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"presets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aspectRatio"}},{"kind":"Field","name":{"kind":"Name","value":"imagePosition"}},{"kind":"Field","name":{"kind":"Name","value":"margin"}},{"kind":"Field","name":{"kind":"Name","value":"customPrompt"}},{"kind":"Field","name":{"kind":"Name","value":"coordinates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}}]}},{"kind":"Field","name":{"kind":"Name","value":"videoDuration"}},{"kind":"Field","name":{"kind":"Name","value":"backgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"presetId"}},{"kind":"Field","name":{"kind":"Name","value":"modelName"}},{"kind":"Field","name":{"kind":"Name","value":"audioTask"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"jsonPayload"}},{"kind":"Field","name":{"kind":"Name","value":"parsedResult"}},{"kind":"Field","name":{"kind":"Name","value":"outputVideo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"hasWatermark"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"task"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"parsedResult"}},{"kind":"Field","name":{"kind":"Name","value":"jsonPayload"}},{"kind":"Field","name":{"kind":"Name","value":"intermediateResults"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"outputVideo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"hasWatermark"}}]}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"thumbHash"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}}]}}]}}]}}]}}]} as unknown as DocumentNode<MyGenerationsQuery, MyGenerationsQueryVariables>;
export const GetGenerationsProgressDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetGenerationsProgress"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"generationsIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getGenerationsAnonymous"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"generationsIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"generationsIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GenerationFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GenerationFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AiAnimatedElementsGeneration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"progress"}},{"kind":"Field","name":{"kind":"Name","value":"generationId"}},{"kind":"Field","name":{"kind":"Name","value":"inputFileUrl"}},{"kind":"Field","name":{"kind":"Name","value":"inputBucketInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bucketName"}},{"kind":"Field","name":{"kind":"Name","value":"filePath"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"feedback"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rating"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"presets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aspectRatio"}},{"kind":"Field","name":{"kind":"Name","value":"imagePosition"}},{"kind":"Field","name":{"kind":"Name","value":"margin"}},{"kind":"Field","name":{"kind":"Name","value":"customPrompt"}},{"kind":"Field","name":{"kind":"Name","value":"coordinates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}}]}},{"kind":"Field","name":{"kind":"Name","value":"backgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"presetId"}},{"kind":"Field","name":{"kind":"Name","value":"modelName"}},{"kind":"Field","name":{"kind":"Name","value":"audioTask"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"jsonPayload"}}]}},{"kind":"Field","name":{"kind":"Name","value":"videoDuration"}},{"kind":"Field","name":{"kind":"Name","value":"task"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"parsedResult"}},{"kind":"Field","name":{"kind":"Name","value":"jsonPayload"}},{"kind":"Field","name":{"kind":"Name","value":"intermediateResults"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"thumbHash"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}}]}}]}}]} as unknown as DocumentNode<GetGenerationsProgressQuery, GetGenerationsProgressQueryVariables>;
export const GetGenerationsCompleteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetGenerationsComplete"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"generationsIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getGenerationsAnonymous"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"generationsIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"generationsIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GenerationCompleteFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GenerationCompleteFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AiAnimatedElementsGeneration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"progress"}},{"kind":"Field","name":{"kind":"Name","value":"generationId"}},{"kind":"Field","name":{"kind":"Name","value":"inputFileUrl"}},{"kind":"Field","name":{"kind":"Name","value":"inputBucketInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bucketName"}},{"kind":"Field","name":{"kind":"Name","value":"filePath"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"feedback"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rating"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"presets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aspectRatio"}},{"kind":"Field","name":{"kind":"Name","value":"imagePosition"}},{"kind":"Field","name":{"kind":"Name","value":"margin"}},{"kind":"Field","name":{"kind":"Name","value":"customPrompt"}},{"kind":"Field","name":{"kind":"Name","value":"coordinates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}}]}},{"kind":"Field","name":{"kind":"Name","value":"videoDuration"}},{"kind":"Field","name":{"kind":"Name","value":"backgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"presetId"}},{"kind":"Field","name":{"kind":"Name","value":"modelName"}},{"kind":"Field","name":{"kind":"Name","value":"audioTask"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"jsonPayload"}},{"kind":"Field","name":{"kind":"Name","value":"parsedResult"}},{"kind":"Field","name":{"kind":"Name","value":"outputVideo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"hasWatermark"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"task"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"parsedResult"}},{"kind":"Field","name":{"kind":"Name","value":"jsonPayload"}},{"kind":"Field","name":{"kind":"Name","value":"intermediateResults"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"outputVideo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"hasWatermark"}}]}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"thumbHash"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetGenerationsCompleteQuery, GetGenerationsCompleteQueryVariables>;
export const GetGenerationsByDetectedObjectsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetGenerationsByDetectedObjects"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objectDescriptionToUse"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectDescription"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getGenerationsByDetectedObjectsAnonymous"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objectDescriptionToUse"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objectDescriptionToUse"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"previewUrl"}},{"kind":"Field","name":{"kind":"Name","value":"detectedObject"}},{"kind":"Field","name":{"kind":"Name","value":"generations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generationId"}},{"kind":"Field","name":{"kind":"Name","value":"aspectRatio"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetGenerationsByDetectedObjectsQuery, GetGenerationsByDetectedObjectsQueryVariables>;